import * as Cs from "vue";
import { defineComponent as ye, h as jo, inject as el, onMounted as Dt, onUnmounted as qo, Fragment as Me, ref as z, shallowRef as tl, computed as me, watch as bt, createVNode as ot, Text as nl, createElementBlock as I, openBlock as $, createElementVNode as u, createCommentVNode as X, toDisplayString as T, unref as k, withModifiers as Wo, withDirectives as Qe, createTextVNode as Ge, vModelText as pt, renderList as ze, normalizeClass as ke, reactive as zo, createBlock as it, resolveComponent as tr, Transition as sl, withCtx as kn, renderSlot as rl, mergeModels as Pr, useModel as ol, vModelSelect as nr, nextTick as al } from "vue";
import { logger as Ce, getOrderItemStatusLabel as Yo, STATUS_FLOW as En, ORDER_ITEM_STATUS as Nt, ORDER_STATUS as Re, formatToMerchantTimeHM as Ko, getOrderStatusLabel as Ds, confirmDuplicateOrders as il, processUbnInput as ll } from "@myorg/type-lib";
/*!
  * shared v11.2.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function Tt(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const Dr = {};
function cl(e) {
  Dr[e] || (Dr[e] = !0, Tt(e));
}
const It = typeof window < "u";
let at, Kt;
if (process.env.NODE_ENV !== "production") {
  const e = It && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (at = (t) => {
    e.mark(t);
  }, Kt = (t, n, s) => {
    e.measure(t, n, s), e.clearMarks(n), e.clearMarks(s);
  });
}
const ul = /\{([0-9a-zA-Z]+)\}/g;
function us(e, ...t) {
  return t.length === 1 && ce(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(ul, (n, s) => t.hasOwnProperty(s) ? t[s] : "");
}
const Mt = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), dl = (e, t, n) => fl({ l: e, k: t, s: n }), fl = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), Fe = (e) => typeof e == "number" && isFinite(e), ml = (e) => sr(e) === "[object Date]", Xn = (e) => sr(e) === "[object RegExp]", ds = (e) => le(e) && Object.keys(e).length === 0, Be = Object.assign, hl = Object.create, be = (e = null) => hl(e);
let Mr;
const qt = () => Mr || (Mr = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : be());
function Rr(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;").replace(/=/g, "&#x3D;");
}
function Fr(e) {
  return e.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function pl(e) {
  return e = e.replace(/(\w+)\s*=\s*"([^"]*)"/g, (s, r, o) => `${r}="${Fr(o)}"`), e = e.replace(/(\w+)\s*=\s*'([^']*)'/g, (s, r, o) => `${r}='${Fr(o)}'`), /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi.test(e) && (process.env.NODE_ENV !== "production" && Tt("Potentially dangerous event handlers detected in translation. Consider removing onclick, onerror, etc. from your translation messages."), e = e.replace(/(\s+)(on)(\w+\s*=)/gi, "$1&#111;n$3")), [
    // In href, src, action, formaction attributes
    /(\s+(?:href|src|action|formaction)\s*=\s*["']?)\s*javascript:/gi,
    // In style attributes within url()
    /(style\s*=\s*["'][^"']*url\s*\(\s*)javascript:/gi
  ].forEach((s) => {
    e = e.replace(s, "$1javascript&#58;");
  }), e;
}
const gl = Object.prototype.hasOwnProperty;
function gt(e, t) {
  return gl.call(e, t);
}
const Le = Array.isArray, Ee = (e) => typeof e == "function", H = (e) => typeof e == "string", $e = (e) => typeof e == "boolean", ce = (e) => e !== null && typeof e == "object", wl = (e) => ce(e) && Ee(e.then) && Ee(e.catch), Go = Object.prototype.toString, sr = (e) => Go.call(e), le = (e) => sr(e) === "[object Object]", bl = (e) => e == null ? "" : Le(e) || le(e) && e.toString === Go ? JSON.stringify(e, null, 2) : String(e);
function rr(e, t = "") {
  return e.reduce((n, s, r) => r === 0 ? n + s : n + t + s, "");
}
const Br = 2;
function yl(e, t = 0, n = e.length) {
  const s = e.split(/\r?\n/);
  let r = 0;
  const o = [];
  for (let a = 0; a < s.length; a++)
    if (r += s[a].length + 1, r >= t) {
      for (let i = a - Br; i <= a + Br || n > r; i++) {
        if (i < 0 || i >= s.length)
          continue;
        const l = i + 1;
        o.push(`${l}${" ".repeat(3 - String(l).length)}|  ${s[i]}`);
        const c = s[i].length;
        if (i === a) {
          const h = t - (r - c) + 1, f = Math.max(1, n > r ? c - h : n - t);
          o.push("   |  " + " ".repeat(h) + "^".repeat(f));
        } else if (i > a) {
          if (n > r) {
            const h = Math.max(Math.min(n - r, c), 1);
            o.push("   |  " + "^".repeat(h));
          }
          r += c + 1;
        }
      }
      break;
    }
  return o.join(`
`);
}
function vl() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, s) {
      const r = e.get(n);
      r && r.push(s) || e.set(n, [s]);
    },
    off(n, s) {
      const r = e.get(n);
      r && r.splice(r.indexOf(s) >>> 0, 1);
    },
    emit(n, s) {
      (e.get(n) || []).slice().map((r) => r(s)), (e.get("*") || []).slice().map((r) => r(n, s));
    }
  };
}
const Vn = (e) => !ce(e) || Le(e);
function zn(e, t) {
  if (Vn(e) || Vn(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: s, des: r } = n.pop();
    Object.keys(s).forEach((o) => {
      o !== "__proto__" && (ce(s[o]) && !ce(r[o]) && (r[o] = Array.isArray(s[o]) ? [] : be()), Vn(r[o]) || Vn(s[o]) ? r[o] = s[o] : n.push({ src: s[o], des: r[o] }));
    });
  }
}
/*!
  * message-compiler v11.2.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function _l(e, t, n) {
  return { line: e, column: t, offset: n };
}
function Ms(e, t, n) {
  return { start: e, end: t };
}
const Z = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, xl = 17, El = {
  // tokenizer error messages
  [Z.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [Z.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [Z.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [Z.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [Z.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [Z.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [Z.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [Z.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [Z.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [Z.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [Z.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [Z.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [Z.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [Z.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [Z.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [Z.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function mn(e, t, n = {}) {
  const { domain: s, messages: r, args: o } = n, a = process.env.NODE_ENV !== "production" ? us((r || El)[e] || "", ...o || []) : e, i = new SyntaxError(String(a));
  return i.code = e, t && (i.location = t), i.domain = s, i;
}
function kl(e) {
  throw e;
}
const Cl = /<\/?[\w\s="/.':;#-\/]+>/, Tl = (e) => Cl.test(e), vt = " ", Al = "\r", je = `
`, Ol = "\u2028", Sl = "\u2029";
function Nl(e) {
  const t = e;
  let n = 0, s = 1, r = 1, o = 0;
  const a = (C) => t[C] === Al && t[C + 1] === je, i = (C) => t[C] === je, l = (C) => t[C] === Sl, c = (C) => t[C] === Ol, h = (C) => a(C) || i(C) || l(C) || c(C), f = () => n, p = () => s, b = () => r, g = () => o, m = (C) => a(C) || l(C) || c(C) ? je : t[C], y = () => m(n), d = () => m(n + o);
  function w() {
    return o = 0, h(n) && (s++, r = 0), a(n) && n++, n++, r++, t[n];
  }
  function _() {
    return a(n + o) && o++, o++, t[n + o];
  }
  function x() {
    n = 0, s = 1, r = 1, o = 0;
  }
  function A(C = 0) {
    o = C;
  }
  function L() {
    const C = n + o;
    for (; C !== n; )
      w();
    o = 0;
  }
  return {
    index: f,
    line: p,
    column: b,
    peekOffset: g,
    charAt: m,
    currentChar: y,
    currentPeek: d,
    next: w,
    peek: _,
    reset: x,
    resetPeek: A,
    skipToPeek: L
  };
}
const St = void 0, $l = ".", Ur = "'", Ll = "tokenizer";
function Il(e, t = {}) {
  const n = t.location !== !1, s = Nl(e), r = () => s.index(), o = () => _l(s.line(), s.column(), s.index()), a = o(), i = r(), l = {
    currentType: 13,
    offset: i,
    startLoc: a,
    endLoc: a,
    lastType: 13,
    lastOffset: i,
    lastStartLoc: a,
    lastEndLoc: a,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, c = () => l, { onError: h } = t;
  function f(v, E, P, ...Y) {
    const xe = c();
    if (E.column += P, E.offset += P, h) {
      const Oe = n ? Ms(xe.startLoc, E) : null, ie = mn(v, Oe, {
        domain: Ll,
        args: Y
      });
      h(ie);
    }
  }
  function p(v, E, P) {
    v.endLoc = o(), v.currentType = E;
    const Y = { type: E };
    return n && (Y.loc = Ms(v.startLoc, v.endLoc)), P != null && (Y.value = P), Y;
  }
  const b = (v) => p(
    v,
    13
    /* TokenTypes.EOF */
  );
  function g(v, E) {
    return v.currentChar() === E ? (v.next(), E) : (f(Z.EXPECTED_TOKEN, o(), 0, E), "");
  }
  function m(v) {
    let E = "";
    for (; v.currentPeek() === vt || v.currentPeek() === je; )
      E += v.currentPeek(), v.peek();
    return E;
  }
  function y(v) {
    const E = m(v);
    return v.skipToPeek(), E;
  }
  function d(v) {
    if (v === St)
      return !1;
    const E = v.charCodeAt(0);
    return E >= 97 && E <= 122 || // a-z
    E >= 65 && E <= 90 || // A-Z
    E === 95;
  }
  function w(v) {
    if (v === St)
      return !1;
    const E = v.charCodeAt(0);
    return E >= 48 && E <= 57;
  }
  function _(v, E) {
    const { currentType: P } = E;
    if (P !== 2)
      return !1;
    m(v);
    const Y = d(v.currentPeek());
    return v.resetPeek(), Y;
  }
  function x(v, E) {
    const { currentType: P } = E;
    if (P !== 2)
      return !1;
    m(v);
    const Y = v.currentPeek() === "-" ? v.peek() : v.currentPeek(), xe = w(Y);
    return v.resetPeek(), xe;
  }
  function A(v, E) {
    const { currentType: P } = E;
    if (P !== 2)
      return !1;
    m(v);
    const Y = v.currentPeek() === Ur;
    return v.resetPeek(), Y;
  }
  function L(v, E) {
    const { currentType: P } = E;
    if (P !== 7)
      return !1;
    m(v);
    const Y = v.currentPeek() === ".";
    return v.resetPeek(), Y;
  }
  function C(v, E) {
    const { currentType: P } = E;
    if (P !== 8)
      return !1;
    m(v);
    const Y = d(v.currentPeek());
    return v.resetPeek(), Y;
  }
  function F(v, E) {
    const { currentType: P } = E;
    if (!(P === 7 || P === 11))
      return !1;
    m(v);
    const Y = v.currentPeek() === ":";
    return v.resetPeek(), Y;
  }
  function D(v, E) {
    const { currentType: P } = E;
    if (P !== 9)
      return !1;
    const Y = () => {
      const Oe = v.currentPeek();
      return Oe === "{" ? d(v.peek()) : Oe === "@" || Oe === "|" || Oe === ":" || Oe === "." || Oe === vt || !Oe ? !1 : Oe === je ? (v.peek(), Y()) : q(v, !1);
    }, xe = Y();
    return v.resetPeek(), xe;
  }
  function j(v) {
    m(v);
    const E = v.currentPeek() === "|";
    return v.resetPeek(), E;
  }
  function q(v, E = !0) {
    const P = (xe = !1, Oe = "") => {
      const ie = v.currentPeek();
      return ie === "{" || ie === "@" || !ie ? xe : ie === "|" ? !(Oe === vt || Oe === je) : ie === vt ? (v.peek(), P(!0, vt)) : ie === je ? (v.peek(), P(!0, je)) : !0;
    }, Y = P();
    return E && v.resetPeek(), Y;
  }
  function ne(v, E) {
    const P = v.currentChar();
    return P === St ? St : E(P) ? (v.next(), P) : null;
  }
  function De(v) {
    const E = v.charCodeAt(0);
    return E >= 97 && E <= 122 || // a-z
    E >= 65 && E <= 90 || // A-Z
    E >= 48 && E <= 57 || // 0-9
    E === 95 || // _
    E === 36;
  }
  function V(v) {
    return ne(v, De);
  }
  function U(v) {
    const E = v.charCodeAt(0);
    return E >= 97 && E <= 122 || // a-z
    E >= 65 && E <= 90 || // A-Z
    E >= 48 && E <= 57 || // 0-9
    E === 95 || // _
    E === 36 || // $
    E === 45;
  }
  function R(v) {
    return ne(v, U);
  }
  function W(v) {
    const E = v.charCodeAt(0);
    return E >= 48 && E <= 57;
  }
  function B(v) {
    return ne(v, W);
  }
  function J(v) {
    const E = v.charCodeAt(0);
    return E >= 48 && E <= 57 || // 0-9
    E >= 65 && E <= 70 || // A-F
    E >= 97 && E <= 102;
  }
  function K(v) {
    return ne(v, J);
  }
  function ee(v) {
    let E = "", P = "";
    for (; E = B(v); )
      P += E;
    return P;
  }
  function re(v) {
    let E = "";
    for (; ; ) {
      const P = v.currentChar();
      if (P === "{" || P === "}" || P === "@" || P === "|" || !P)
        break;
      if (P === vt || P === je)
        if (q(v))
          E += P, v.next();
        else {
          if (j(v))
            break;
          E += P, v.next();
        }
      else
        E += P, v.next();
    }
    return E;
  }
  function de(v) {
    y(v);
    let E = "", P = "";
    for (; E = R(v); )
      P += E;
    const Y = v.currentChar();
    if (Y && Y !== "}" && Y !== St && Y !== vt && Y !== je && Y !== "　") {
      const xe = Ae(v);
      return f(Z.INVALID_TOKEN_IN_PLACEHOLDER, o(), 0, P + xe), P + xe;
    }
    return v.currentChar() === St && f(Z.UNTERMINATED_CLOSING_BRACE, o(), 0), P;
  }
  function ve(v) {
    y(v);
    let E = "";
    return v.currentChar() === "-" ? (v.next(), E += `-${ee(v)}`) : E += ee(v), v.currentChar() === St && f(Z.UNTERMINATED_CLOSING_BRACE, o(), 0), E;
  }
  function Te(v) {
    return v !== Ur && v !== je;
  }
  function dt(v) {
    y(v), g(v, "'");
    let E = "", P = "";
    for (; E = ne(v, Te); )
      E === "\\" ? P += st(v) : P += E;
    const Y = v.currentChar();
    return Y === je || Y === St ? (f(Z.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, o(), 0), Y === je && (v.next(), g(v, "'")), P) : (g(v, "'"), P);
  }
  function st(v) {
    const E = v.currentChar();
    switch (E) {
      case "\\":
      case "'":
        return v.next(), `\\${E}`;
      case "u":
        return ft(v, E, 4);
      case "U":
        return ft(v, E, 6);
      default:
        return f(Z.UNKNOWN_ESCAPE_SEQUENCE, o(), 0, E), "";
    }
  }
  function ft(v, E, P) {
    g(v, E);
    let Y = "";
    for (let xe = 0; xe < P; xe++) {
      const Oe = K(v);
      if (!Oe) {
        f(Z.INVALID_UNICODE_ESCAPE_SEQUENCE, o(), 0, `\\${E}${Y}${v.currentChar()}`);
        break;
      }
      Y += Oe;
    }
    return `\\${E}${Y}`;
  }
  function rt(v) {
    return v !== "{" && v !== "}" && v !== vt && v !== je;
  }
  function Ae(v) {
    y(v);
    let E = "", P = "";
    for (; E = ne(v, rt); )
      P += E;
    return P;
  }
  function oe(v) {
    let E = "", P = "";
    for (; E = V(v); )
      P += E;
    return P;
  }
  function se(v) {
    const E = (P) => {
      const Y = v.currentChar();
      return Y === "{" || Y === "@" || Y === "|" || Y === "(" || Y === ")" || !Y || Y === vt ? P : (P += Y, v.next(), E(P));
    };
    return E("");
  }
  function ae(v) {
    y(v);
    const E = g(
      v,
      "|"
      /* TokenChars.Pipe */
    );
    return y(v), E;
  }
  function Q(v, E) {
    let P = null;
    switch (v.currentChar()) {
      case "{":
        return E.braceNest >= 1 && f(Z.NOT_ALLOW_NEST_PLACEHOLDER, o(), 0), v.next(), P = p(
          E,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), y(v), E.braceNest++, P;
      case "}":
        return E.braceNest > 0 && E.currentType === 2 && f(Z.EMPTY_PLACEHOLDER, o(), 0), v.next(), P = p(
          E,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), E.braceNest--, E.braceNest > 0 && y(v), E.inLinked && E.braceNest === 0 && (E.inLinked = !1), P;
      case "@":
        return E.braceNest > 0 && f(Z.UNTERMINATED_CLOSING_BRACE, o(), 0), P = ge(v, E) || b(E), E.braceNest = 0, P;
      default: {
        let xe = !0, Oe = !0, ie = !0;
        if (j(v))
          return E.braceNest > 0 && f(Z.UNTERMINATED_CLOSING_BRACE, o(), 0), P = p(E, 1, ae(v)), E.braceNest = 0, E.inLinked = !1, P;
        if (E.braceNest > 0 && (E.currentType === 4 || E.currentType === 5 || E.currentType === 6))
          return f(Z.UNTERMINATED_CLOSING_BRACE, o(), 0), E.braceNest = 0, Ke(v, E);
        if (xe = _(v, E))
          return P = p(E, 4, de(v)), y(v), P;
        if (Oe = x(v, E))
          return P = p(E, 5, ve(v)), y(v), P;
        if (ie = A(v, E))
          return P = p(E, 6, dt(v)), y(v), P;
        if (!xe && !Oe && !ie)
          return P = p(E, 12, Ae(v)), f(Z.INVALID_TOKEN_IN_PLACEHOLDER, o(), 0, P.value), y(v), P;
        break;
      }
    }
    return P;
  }
  function ge(v, E) {
    const { currentType: P } = E;
    let Y = null;
    const xe = v.currentChar();
    switch ((P === 7 || P === 8 || P === 11 || P === 9) && (xe === je || xe === vt) && f(Z.INVALID_LINKED_FORMAT, o(), 0), xe) {
      case "@":
        return v.next(), Y = p(
          E,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), E.inLinked = !0, Y;
      case ".":
        return y(v), v.next(), p(
          E,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return y(v), v.next(), p(
          E,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return j(v) ? (Y = p(E, 1, ae(v)), E.braceNest = 0, E.inLinked = !1, Y) : L(v, E) || F(v, E) ? (y(v), ge(v, E)) : C(v, E) ? (y(v), p(E, 11, oe(v))) : D(v, E) ? (y(v), xe === "{" ? Q(v, E) || Y : p(E, 10, se(v))) : (P === 7 && f(Z.INVALID_LINKED_FORMAT, o(), 0), E.braceNest = 0, E.inLinked = !1, Ke(v, E));
    }
  }
  function Ke(v, E) {
    let P = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (E.braceNest > 0)
      return Q(v, E) || b(E);
    if (E.inLinked)
      return ge(v, E) || b(E);
    switch (v.currentChar()) {
      case "{":
        return Q(v, E) || b(E);
      case "}":
        return f(Z.UNBALANCED_CLOSING_BRACE, o(), 0), v.next(), p(
          E,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return ge(v, E) || b(E);
      default: {
        if (j(v))
          return P = p(E, 1, ae(v)), E.braceNest = 0, E.inLinked = !1, P;
        if (q(v))
          return p(E, 0, re(v));
        break;
      }
    }
    return P;
  }
  function Ve() {
    const { currentType: v, offset: E, startLoc: P, endLoc: Y } = l;
    return l.lastType = v, l.lastOffset = E, l.lastStartLoc = P, l.lastEndLoc = Y, l.offset = r(), l.startLoc = o(), s.currentChar() === St ? p(
      l,
      13
      /* TokenTypes.EOF */
    ) : Ke(s, l);
  }
  return {
    nextToken: Ve,
    currentOffset: r,
    currentPosition: o,
    context: c
  };
}
const Pl = "parser", Dl = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function Ml(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const s = parseInt(t || n, 16);
      return s <= 55295 || s >= 57344 ? String.fromCodePoint(s) : "�";
    }
  }
}
function Rl(e = {}) {
  const t = e.location !== !1, { onError: n } = e;
  function s(d, w, _, x, ...A) {
    const L = d.currentPosition();
    if (L.offset += x, L.column += x, n) {
      const C = t ? Ms(_, L) : null, F = mn(w, C, {
        domain: Pl,
        args: A
      });
      n(F);
    }
  }
  function r(d, w, _) {
    const x = { type: d };
    return t && (x.start = w, x.end = w, x.loc = { start: _, end: _ }), x;
  }
  function o(d, w, _, x) {
    t && (d.end = w, d.loc && (d.loc.end = _));
  }
  function a(d, w) {
    const _ = d.context(), x = r(3, _.offset, _.startLoc);
    return x.value = w, o(x, d.currentOffset(), d.currentPosition()), x;
  }
  function i(d, w) {
    const _ = d.context(), { lastOffset: x, lastStartLoc: A } = _, L = r(5, x, A);
    return L.index = parseInt(w, 10), d.nextToken(), o(L, d.currentOffset(), d.currentPosition()), L;
  }
  function l(d, w) {
    const _ = d.context(), { lastOffset: x, lastStartLoc: A } = _, L = r(4, x, A);
    return L.key = w, d.nextToken(), o(L, d.currentOffset(), d.currentPosition()), L;
  }
  function c(d, w) {
    const _ = d.context(), { lastOffset: x, lastStartLoc: A } = _, L = r(9, x, A);
    return L.value = w.replace(Dl, Ml), d.nextToken(), o(L, d.currentOffset(), d.currentPosition()), L;
  }
  function h(d) {
    const w = d.nextToken(), _ = d.context(), { lastOffset: x, lastStartLoc: A } = _, L = r(8, x, A);
    return w.type !== 11 ? (s(d, Z.UNEXPECTED_EMPTY_LINKED_MODIFIER, _.lastStartLoc, 0), L.value = "", o(L, x, A), {
      nextConsumeToken: w,
      node: L
    }) : (w.value == null && s(d, Z.UNEXPECTED_LEXICAL_ANALYSIS, _.lastStartLoc, 0, _t(w)), L.value = w.value || "", o(L, d.currentOffset(), d.currentPosition()), {
      node: L
    });
  }
  function f(d, w) {
    const _ = d.context(), x = r(7, _.offset, _.startLoc);
    return x.value = w, o(x, d.currentOffset(), d.currentPosition()), x;
  }
  function p(d) {
    const w = d.context(), _ = r(6, w.offset, w.startLoc);
    let x = d.nextToken();
    if (x.type === 8) {
      const A = h(d);
      _.modifier = A.node, x = A.nextConsumeToken || d.nextToken();
    }
    switch (x.type !== 9 && s(d, Z.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, _t(x)), x = d.nextToken(), x.type === 2 && (x = d.nextToken()), x.type) {
      case 10:
        x.value == null && s(d, Z.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, _t(x)), _.key = f(d, x.value || "");
        break;
      case 4:
        x.value == null && s(d, Z.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, _t(x)), _.key = l(d, x.value || "");
        break;
      case 5:
        x.value == null && s(d, Z.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, _t(x)), _.key = i(d, x.value || "");
        break;
      case 6:
        x.value == null && s(d, Z.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, _t(x)), _.key = c(d, x.value || "");
        break;
      default: {
        s(d, Z.UNEXPECTED_EMPTY_LINKED_KEY, w.lastStartLoc, 0);
        const A = d.context(), L = r(7, A.offset, A.startLoc);
        return L.value = "", o(L, A.offset, A.startLoc), _.key = L, o(_, A.offset, A.startLoc), {
          nextConsumeToken: x,
          node: _
        };
      }
    }
    return o(_, d.currentOffset(), d.currentPosition()), {
      node: _
    };
  }
  function b(d) {
    const w = d.context(), _ = w.currentType === 1 ? d.currentOffset() : w.offset, x = w.currentType === 1 ? w.endLoc : w.startLoc, A = r(2, _, x);
    A.items = [];
    let L = null;
    do {
      const D = L || d.nextToken();
      switch (L = null, D.type) {
        case 0:
          D.value == null && s(d, Z.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, _t(D)), A.items.push(a(d, D.value || ""));
          break;
        case 5:
          D.value == null && s(d, Z.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, _t(D)), A.items.push(i(d, D.value || ""));
          break;
        case 4:
          D.value == null && s(d, Z.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, _t(D)), A.items.push(l(d, D.value || ""));
          break;
        case 6:
          D.value == null && s(d, Z.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, _t(D)), A.items.push(c(d, D.value || ""));
          break;
        case 7: {
          const j = p(d);
          A.items.push(j.node), L = j.nextConsumeToken || null;
          break;
        }
      }
    } while (w.currentType !== 13 && w.currentType !== 1);
    const C = w.currentType === 1 ? w.lastOffset : d.currentOffset(), F = w.currentType === 1 ? w.lastEndLoc : d.currentPosition();
    return o(A, C, F), A;
  }
  function g(d, w, _, x) {
    const A = d.context();
    let L = x.items.length === 0;
    const C = r(1, w, _);
    C.cases = [], C.cases.push(x);
    do {
      const F = b(d);
      L || (L = F.items.length === 0), C.cases.push(F);
    } while (A.currentType !== 13);
    return L && s(d, Z.MUST_HAVE_MESSAGES_IN_PLURAL, _, 0), o(C, d.currentOffset(), d.currentPosition()), C;
  }
  function m(d) {
    const w = d.context(), { offset: _, startLoc: x } = w, A = b(d);
    return w.currentType === 13 ? A : g(d, _, x, A);
  }
  function y(d) {
    const w = Il(d, Be({}, e)), _ = w.context(), x = r(0, _.offset, _.startLoc);
    return t && x.loc && (x.loc.source = d), x.body = m(w), e.onCacheKey && (x.cacheKey = e.onCacheKey(d)), _.currentType !== 13 && s(w, Z.UNEXPECTED_LEXICAL_ANALYSIS, _.lastStartLoc, 0, d[_.offset] || ""), o(x, w.currentOffset(), w.currentPosition()), x;
  }
  return { parse: y };
}
function _t(e) {
  if (e.type === 13)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function Fl(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (o) => (n.helpers.add(o), o) };
}
function Vr(e, t) {
  for (let n = 0; n < e.length; n++)
    or(e[n], t);
}
function or(e, t) {
  switch (e.type) {
    case 1:
      Vr(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      Vr(e.items, t);
      break;
    case 6: {
      or(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function Bl(e, t = {}) {
  const n = Fl(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && or(e.body, n);
  const s = n.context();
  e.helpers = Array.from(s.helpers);
}
function Ul(e) {
  const t = e.body;
  return t.type === 2 ? Hr(t) : t.cases.forEach((n) => Hr(n)), e;
}
function Hr(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const s = e.items[n];
      if (!(s.type === 3 || s.type === 9) || s.value == null)
        break;
      t.push(s.value);
    }
    if (t.length === e.items.length) {
      e.static = rr(t);
      for (let n = 0; n < e.items.length; n++) {
        const s = e.items[n];
        (s.type === 3 || s.type === 9) && delete s.value;
      }
    }
  }
}
const Vl = "minifier";
function on(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      on(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let s = 0; s < n.length; s++)
        on(n[s]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let s = 0; s < n.length; s++)
        on(n[s]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      on(t.key), t.k = t.key, delete t.key, t.modifier && (on(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw mn(Z.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: Vl,
          args: [e.type]
        });
  }
  delete e.type;
}
const Hl = "parser";
function jl(e, t) {
  const { filename: n, breakLineCode: s, needIndent: r } = t, o = t.location !== !1, a = {
    filename: n,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: s,
    needIndent: r,
    indentLevel: 0
  };
  o && e.loc && (a.source = e.loc.source);
  const i = () => a;
  function l(m, y) {
    a.code += m;
  }
  function c(m, y = !0) {
    const d = y ? s : "";
    l(r ? d + "  ".repeat(m) : d);
  }
  function h(m = !0) {
    const y = ++a.indentLevel;
    m && c(y);
  }
  function f(m = !0) {
    const y = --a.indentLevel;
    m && c(y);
  }
  function p() {
    c(a.indentLevel);
  }
  return {
    context: i,
    push: l,
    indent: h,
    deindent: f,
    newline: p,
    helper: (m) => `_${m}`,
    needIndent: () => a.needIndent
  };
}
function ql(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), cn(e, t.key), t.modifier ? (e.push(", "), cn(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function Wl(e, t) {
  const { helper: n, needIndent: s } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(s());
  const r = t.items.length;
  for (let o = 0; o < r && (cn(e, t.items[o]), o !== r - 1); o++)
    e.push(", ");
  e.deindent(s()), e.push("])");
}
function zl(e, t) {
  const { helper: n, needIndent: s } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(s());
    const r = t.cases.length;
    for (let o = 0; o < r && (cn(e, t.cases[o]), o !== r - 1); o++)
      e.push(", ");
    e.deindent(s()), e.push("])");
  }
}
function Yl(e, t) {
  t.body ? cn(e, t.body) : e.push("null");
}
function cn(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      Yl(e, t);
      break;
    case 1:
      zl(e, t);
      break;
    case 2:
      Wl(e, t);
      break;
    case 6:
      ql(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw mn(Z.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: Hl,
          args: [t.type]
        });
  }
}
const Kl = (e, t = {}) => {
  const n = H(t.mode) ? t.mode : "normal", s = H(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const r = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, o = t.needIndent ? t.needIndent : n !== "arrow", a = e.helpers || [], i = jl(e, {
    filename: s,
    breakLineCode: r,
    needIndent: o
  });
  i.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), i.indent(o), a.length > 0 && (i.push(`const { ${rr(a.map((h) => `${h}: _${h}`), ", ")} } = ctx`), i.newline()), i.push("return "), cn(i, e), i.deindent(o), i.push("}"), delete e.helpers;
  const { code: l, map: c } = i.context();
  return {
    ast: e,
    code: l,
    map: c ? c.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function Gl(e, t = {}) {
  const n = Be({}, t), s = !!n.jit, r = !!n.minify, o = n.optimize == null ? !0 : n.optimize, i = Rl(n).parse(e);
  return s ? (o && Ul(i), r && on(i), { ast: i, code: "" }) : (Bl(i, n), Kl(i, n));
}
/*!
  * core-base v11.2.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function Xl() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (qt().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (qt().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function wt(e) {
  return ce(e) && ar(e) === 0 && (gt(e, "b") || gt(e, "body"));
}
const Xo = ["b", "body"];
function Jl(e) {
  return Bt(e, Xo);
}
const Jo = ["c", "cases"];
function Zl(e) {
  return Bt(e, Jo, []);
}
const Zo = ["s", "static"];
function Ql(e) {
  return Bt(e, Zo);
}
const Qo = ["i", "items"];
function ec(e) {
  return Bt(e, Qo, []);
}
const ea = ["t", "type"];
function ar(e) {
  return Bt(e, ea);
}
const ta = ["v", "value"];
function Hn(e, t) {
  const n = Bt(e, ta);
  if (n != null)
    return n;
  throw Cn(t);
}
const na = ["m", "modifier"];
function tc(e) {
  return Bt(e, na);
}
const sa = ["k", "key"];
function nc(e) {
  const t = Bt(e, sa);
  if (t)
    return t;
  throw Cn(
    6
    /* NodeTypes.Linked */
  );
}
function Bt(e, t, n) {
  for (let s = 0; s < t.length; s++) {
    const r = t[s];
    if (gt(e, r) && e[r] != null)
      return e[r];
  }
  return n;
}
const ra = [
  ...Xo,
  ...Jo,
  ...Zo,
  ...Qo,
  ...sa,
  ...na,
  ...ta,
  ...ea
];
function Cn(e) {
  return new Error(`unhandled node type: ${e}`);
}
function Ts(e) {
  return (n) => sc(n, e);
}
function sc(e, t) {
  const n = Jl(t);
  if (n == null)
    throw Cn(
      0
      /* NodeTypes.Resource */
    );
  if (ar(n) === 1) {
    const o = Zl(n);
    return e.plural(o.reduce((a, i) => [
      ...a,
      jr(e, i)
    ], []));
  } else
    return jr(e, n);
}
function jr(e, t) {
  const n = Ql(t);
  if (n != null)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const s = ec(t).reduce((r, o) => [...r, Rs(e, o)], []);
    return e.normalize(s);
  }
}
function Rs(e, t) {
  const n = ar(t);
  switch (n) {
    case 3:
      return Hn(t, n);
    case 9:
      return Hn(t, n);
    case 4: {
      const s = t;
      if (gt(s, "k") && s.k)
        return e.interpolate(e.named(s.k));
      if (gt(s, "key") && s.key)
        return e.interpolate(e.named(s.key));
      throw Cn(n);
    }
    case 5: {
      const s = t;
      if (gt(s, "i") && Fe(s.i))
        return e.interpolate(e.list(s.i));
      if (gt(s, "index") && Fe(s.index))
        return e.interpolate(e.list(s.index));
      throw Cn(n);
    }
    case 6: {
      const s = t, r = tc(s), o = nc(s);
      return e.linked(Rs(e, o), r ? Rs(e, r) : void 0, e.type);
    }
    case 7:
      return Hn(t, n);
    case 8:
      return Hn(t, n);
    default:
      throw new Error(`unhandled node on format message part: ${n}`);
  }
}
const rc = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function oc(e, t) {
  t && Tl(e) && Tt(us(rc, { source: e }));
}
const ac = (e) => e;
let jn = be();
function ic(e, t = {}) {
  let n = !1;
  const s = t.onError || kl;
  return t.onError = (r) => {
    n = !0, s(r);
  }, { ...Gl(e, t), detectError: n };
}
// @__NO_SIDE_EFFECTS__
function lc(e, t) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && H(e)) {
    const n = $e(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && oc(e, n);
    const r = (t.onCacheKey || ac)(e), o = jn[r];
    if (o)
      return o;
    const { ast: a, detectError: i } = ic(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), l = Ts(a);
    return i ? l : jn[r] = l;
  } else {
    if (process.env.NODE_ENV !== "production" && !wt(e))
      return Tt(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const n = e.cacheKey;
    if (n) {
      const s = jn[n];
      return s || (jn[n] = Ts(e));
    } else
      return Ts(e);
  }
}
let Tn = null;
function cc(e) {
  Tn = e;
}
function uc(e, t, n) {
  Tn && Tn.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const dc = /* @__PURE__ */ fc("function:translate");
function fc(e) {
  return (t) => Tn && Tn.emit(e, t);
}
const qe = {
  INVALID_ARGUMENT: xl,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, mc = 24;
function $t(e) {
  return mn(e, null, process.env.NODE_ENV !== "production" ? { messages: hc } : void 0);
}
const hc = {
  [qe.INVALID_ARGUMENT]: "Invalid arguments",
  [qe.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [qe.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [qe.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [qe.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [qe.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [qe.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function ir(e, t) {
  return t.locale != null ? qr(t.locale) : qr(e.locale);
}
let As;
function qr(e) {
  if (H(e))
    return e;
  if (Ee(e)) {
    if (e.resolvedOnce && As != null)
      return As;
    if (e.constructor.name === "Function") {
      const t = e();
      if (wl(t))
        throw $t(qe.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return As = t;
    } else
      throw $t(qe.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw $t(qe.NOT_SUPPORT_LOCALE_TYPE);
}
function pc(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...Le(t) ? t : ce(t) ? Object.keys(t) : H(t) ? [t] : [n]
  ])];
}
function oa(e, t, n) {
  const s = H(n) ? n : Jn, r = e;
  r.__localeChainCache || (r.__localeChainCache = /* @__PURE__ */ new Map());
  let o = r.__localeChainCache.get(s);
  if (!o) {
    o = [];
    let a = [n];
    for (; Le(a); )
      a = Wr(o, a, t);
    const i = Le(t) || !le(t) ? t : t.default ? t.default : null;
    a = H(i) ? [i] : i, Le(a) && Wr(o, a, !1), r.__localeChainCache.set(s, o);
  }
  return o;
}
function Wr(e, t, n) {
  let s = !0;
  for (let r = 0; r < t.length && $e(s); r++) {
    const o = t[r];
    H(o) && (s = gc(e, t[r], n));
  }
  return s;
}
function gc(e, t, n) {
  let s;
  const r = t.split("-");
  do {
    const o = r.join("-");
    s = wc(e, o, n), r.splice(-1, 1);
  } while (r.length && s === !0);
  return s;
}
function wc(e, t, n) {
  let s = !1;
  if (!e.includes(t) && (s = !0, t)) {
    s = t[t.length - 1] !== "!";
    const r = t.replace(/!/g, "");
    e.push(r), (Le(n) || le(n)) && n[r] && (s = n[r]);
  }
  return s;
}
const Ut = [];
Ut[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Ut[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Ut[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
Ut[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
Ut[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
Ut[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
Ut[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const bc = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function yc(e) {
  return bc.test(e);
}
function vc(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function _c(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function xc(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : yc(t) ? vc(t) : "*" + t;
}
function Ec(e) {
  const t = [];
  let n = -1, s = 0, r = 0, o, a, i, l, c, h, f;
  const p = [];
  p[
    0
    /* Actions.APPEND */
  ] = () => {
    a === void 0 ? a = i : a += i;
  }, p[
    1
    /* Actions.PUSH */
  ] = () => {
    a !== void 0 && (t.push(a), a = void 0);
  }, p[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    p[
      0
      /* Actions.APPEND */
    ](), r++;
  }, p[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (r > 0)
      r--, s = 4, p[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (r = 0, a === void 0 || (a = xc(a), a === !1))
        return !1;
      p[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function b() {
    const g = e[n + 1];
    if (s === 5 && g === "'" || s === 6 && g === '"')
      return n++, i = "\\" + g, p[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; s !== null; )
    if (n++, o = e[n], !(o === "\\" && b())) {
      if (l = _c(o), f = Ut[s], c = f[l] || f.l || 8, c === 8 || (s = c[0], c[1] !== void 0 && (h = p[c[1]], h && (i = o, h() === !1))))
        return;
      if (s === 7)
        return t;
    }
}
const zr = /* @__PURE__ */ new Map();
function kc(e, t) {
  return ce(e) ? e[t] : null;
}
function Cc(e, t) {
  if (!ce(e))
    return null;
  let n = zr.get(t);
  if (n || (n = Ec(t), n && zr.set(t, n)), !n)
    return null;
  const s = n.length;
  let r = e, o = 0;
  for (; o < s; ) {
    const a = n[o];
    if (ra.includes(a) && wt(r))
      return null;
    const i = r[a];
    if (i === void 0 || Ee(r))
      return null;
    r = i, o++;
  }
  return r;
}
const Ze = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7
}, Tc = 8, Ac = {
  [Ze.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [Ze.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [Ze.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [Ze.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [Ze.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [Ze.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [Ze.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function Gt(e, ...t) {
  return us(Ac[e], ...t);
}
const Oc = "11.2.8", fs = -1, Jn = "en-US", Zn = "", Yr = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function Sc() {
  return {
    upper: (e, t) => t === "text" && H(e) ? e.toUpperCase() : t === "vnode" && ce(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && H(e) ? e.toLowerCase() : t === "vnode" && ce(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && H(e) ? Yr(e) : t === "vnode" && ce(e) && "__v_isVNode" in e ? Yr(e.children) : e
  };
}
let aa;
function Nc(e) {
  aa = e;
}
let ia;
function $c(e) {
  ia = e;
}
let la;
function Lc(e) {
  la = e;
}
let ca = null;
const Ic = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  ca = e;
}, Pc = /* @__NO_SIDE_EFFECTS__ */ () => ca;
let ua = null;
const Kr = (e) => {
  ua = e;
}, Dc = () => ua;
let Gr = 0;
function Mc(e = {}) {
  const t = Ee(e.onWarn) ? e.onWarn : Tt, n = H(e.version) ? e.version : Oc, s = H(e.locale) || Ee(e.locale) ? e.locale : Jn, r = Ee(s) ? Jn : s, o = Le(e.fallbackLocale) || le(e.fallbackLocale) || H(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : r, a = le(e.messages) ? e.messages : Os(r), i = le(e.datetimeFormats) ? e.datetimeFormats : Os(r), l = le(e.numberFormats) ? e.numberFormats : Os(r), c = Be(be(), e.modifiers, Sc()), h = e.pluralRules || be(), f = Ee(e.missing) ? e.missing : null, p = $e(e.missingWarn) || Xn(e.missingWarn) ? e.missingWarn : !0, b = $e(e.fallbackWarn) || Xn(e.fallbackWarn) ? e.fallbackWarn : !0, g = !!e.fallbackFormat, m = !!e.unresolving, y = Ee(e.postTranslation) ? e.postTranslation : null, d = le(e.processor) ? e.processor : null, w = $e(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, _ = !!e.escapeParameter, x = Ee(e.messageCompiler) ? e.messageCompiler : aa;
  process.env.NODE_ENV !== "production" && Ee(e.messageCompiler) && cl(Gt(Ze.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const A = Ee(e.messageResolver) ? e.messageResolver : ia || kc, L = Ee(e.localeFallbacker) ? e.localeFallbacker : la || pc, C = ce(e.fallbackContext) ? e.fallbackContext : void 0, F = e, D = ce(F.__datetimeFormatters) ? F.__datetimeFormatters : /* @__PURE__ */ new Map(), j = ce(F.__numberFormatters) ? F.__numberFormatters : /* @__PURE__ */ new Map(), q = ce(F.__meta) ? F.__meta : {};
  Gr++;
  const ne = {
    version: n,
    cid: Gr,
    locale: s,
    fallbackLocale: o,
    messages: a,
    modifiers: c,
    pluralRules: h,
    missing: f,
    missingWarn: p,
    fallbackWarn: b,
    fallbackFormat: g,
    unresolving: m,
    postTranslation: y,
    processor: d,
    warnHtmlMessage: w,
    escapeParameter: _,
    messageCompiler: x,
    messageResolver: A,
    localeFallbacker: L,
    fallbackContext: C,
    onWarn: t,
    __meta: q
  };
  return ne.datetimeFormats = i, ne.numberFormats = l, ne.__datetimeFormatters = D, ne.__numberFormatters = j, process.env.NODE_ENV !== "production" && (ne.__v_emitter = F.__v_emitter != null ? F.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && uc(ne, n, q), ne;
}
const Os = (e) => ({ [e]: be() });
function ms(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function da(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function lr(e, t, n, s, r) {
  const { missing: o, onWarn: a } = e;
  if (process.env.NODE_ENV !== "production") {
    const i = e.__v_emitter;
    i && i.emit("missing", {
      locale: n,
      key: t,
      type: r,
      groupId: `${r}:${t}`
    });
  }
  if (o !== null) {
    const i = o(e, n, t, r);
    return H(i) ? i : t;
  } else
    return process.env.NODE_ENV !== "production" && da(s, t) && a(Gt(Ze.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function _n(e, t, n) {
  const s = e;
  s.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function fa(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function Rc(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let s = n + 1; s < t.length; s++)
    if (fa(e, t[s]))
      return !0;
  return !1;
}
const Xr = typeof Intl < "u", ma = {
  dateTimeFormat: Xr && typeof Intl.DateTimeFormat < "u",
  numberFormat: Xr && typeof Intl.NumberFormat < "u"
};
function Jr(e, ...t) {
  const { datetimeFormats: n, unresolving: s, fallbackLocale: r, onWarn: o, localeFallbacker: a } = e, { __datetimeFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !ma.dateTimeFormat)
    return o(Gt(Ze.CANNOT_FORMAT_DATE)), Zn;
  const [l, c, h, f] = Fs(...t), p = $e(h.missingWarn) ? h.missingWarn : e.missingWarn, b = $e(h.fallbackWarn) ? h.fallbackWarn : e.fallbackWarn, g = !!h.part, m = ir(e, h), y = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    r,
    m
  );
  if (!H(l) || l === "")
    return new Intl.DateTimeFormat(m, f).format(c);
  let d = {}, w, _ = null, x = m, A = null;
  const L = "datetime format";
  for (let D = 0; D < y.length; D++) {
    if (w = A = y[D], process.env.NODE_ENV !== "production" && m !== w && ms(b, l) && o(Gt(Ze.FALLBACK_TO_DATE_FORMAT, {
      key: l,
      target: w
    })), process.env.NODE_ENV !== "production" && m !== w) {
      const j = e.__v_emitter;
      j && j.emit("fallback", {
        type: L,
        key: l,
        from: x,
        to: A,
        groupId: `${L}:${l}`
      });
    }
    if (d = n[w] || {}, _ = d[l], le(_))
      break;
    lr(e, l, w, p, L), x = A;
  }
  if (!le(_) || !H(w))
    return s ? fs : l;
  let C = `${w}__${l}`;
  ds(f) || (C = `${C}__${JSON.stringify(f)}`);
  let F = i.get(C);
  return F || (F = new Intl.DateTimeFormat(w, Be({}, _, f)), i.set(C, F)), g ? F.formatToParts(c) : F.format(c);
}
const ha = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function Fs(...e) {
  const [t, n, s, r] = e, o = be();
  let a = be(), i;
  if (H(t)) {
    const l = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw $t(qe.INVALID_ISO_DATE_ARGUMENT);
    const c = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    i = new Date(c);
    try {
      i.toISOString();
    } catch {
      throw $t(qe.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (ml(t)) {
    if (isNaN(t.getTime()))
      throw $t(qe.INVALID_DATE_ARGUMENT);
    i = t;
  } else if (Fe(t))
    i = t;
  else
    throw $t(qe.INVALID_ARGUMENT);
  return H(n) ? o.key = n : le(n) && Object.keys(n).forEach((l) => {
    ha.includes(l) ? a[l] = n[l] : o[l] = n[l];
  }), H(s) ? o.locale = s : le(s) && (a = s), le(r) && (a = r), [o.key || "", i, o, a];
}
function Zr(e, t, n) {
  const s = e;
  for (const r in n) {
    const o = `${t}__${r}`;
    s.__datetimeFormatters.has(o) && s.__datetimeFormatters.delete(o);
  }
}
function Qr(e, ...t) {
  const { numberFormats: n, unresolving: s, fallbackLocale: r, onWarn: o, localeFallbacker: a } = e, { __numberFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !ma.numberFormat)
    return o(Gt(Ze.CANNOT_FORMAT_NUMBER)), Zn;
  const [l, c, h, f] = Bs(...t), p = $e(h.missingWarn) ? h.missingWarn : e.missingWarn, b = $e(h.fallbackWarn) ? h.fallbackWarn : e.fallbackWarn, g = !!h.part, m = ir(e, h), y = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    r,
    m
  );
  if (!H(l) || l === "")
    return new Intl.NumberFormat(m, f).format(c);
  let d = {}, w, _ = null, x = m, A = null;
  const L = "number format";
  for (let D = 0; D < y.length; D++) {
    if (w = A = y[D], process.env.NODE_ENV !== "production" && m !== w && ms(b, l) && o(Gt(Ze.FALLBACK_TO_NUMBER_FORMAT, {
      key: l,
      target: w
    })), process.env.NODE_ENV !== "production" && m !== w) {
      const j = e.__v_emitter;
      j && j.emit("fallback", {
        type: L,
        key: l,
        from: x,
        to: A,
        groupId: `${L}:${l}`
      });
    }
    if (d = n[w] || {}, _ = d[l], le(_))
      break;
    lr(e, l, w, p, L), x = A;
  }
  if (!le(_) || !H(w))
    return s ? fs : l;
  let C = `${w}__${l}`;
  ds(f) || (C = `${C}__${JSON.stringify(f)}`);
  let F = i.get(C);
  return F || (F = new Intl.NumberFormat(w, Be({}, _, f)), i.set(C, F)), g ? F.formatToParts(c) : F.format(c);
}
const pa = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function Bs(...e) {
  const [t, n, s, r] = e, o = be();
  let a = be();
  if (!Fe(t))
    throw $t(qe.INVALID_ARGUMENT);
  const i = t;
  return H(n) ? o.key = n : le(n) && Object.keys(n).forEach((l) => {
    pa.includes(l) ? a[l] = n[l] : o[l] = n[l];
  }), H(s) ? o.locale = s : le(s) && (a = s), le(r) && (a = r), [o.key || "", i, o, a];
}
function eo(e, t, n) {
  const s = e;
  for (const r in n) {
    const o = `${t}__${r}`;
    s.__numberFormatters.has(o) && s.__numberFormatters.delete(o);
  }
}
const Fc = (e) => e, Bc = (e) => "", Uc = "text", Vc = (e) => e.length === 0 ? "" : rr(e), Hc = bl;
function to(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function jc(e) {
  const t = Fe(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (Fe(e.named.count) || Fe(e.named.n)) ? Fe(e.named.count) ? e.named.count : Fe(e.named.n) ? e.named.n : t : t;
}
function qc(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function Wc(e = {}) {
  const t = e.locale, n = jc(e), s = ce(e.pluralRules) && H(t) && Ee(e.pluralRules[t]) ? e.pluralRules[t] : to, r = ce(e.pluralRules) && H(t) && Ee(e.pluralRules[t]) ? to : void 0, o = (d) => d[s(n, d.length, r)], a = e.list || [], i = (d) => a[d], l = e.named || be();
  Fe(e.pluralIndex) && qc(n, l);
  const c = (d) => l[d];
  function h(d, w) {
    const _ = Ee(e.messages) ? e.messages(d, !!w) : ce(e.messages) ? e.messages[d] : !1;
    return _ || (e.parent ? e.parent.message(d) : Bc);
  }
  const f = (d) => e.modifiers ? e.modifiers[d] : Fc, p = le(e.processor) && Ee(e.processor.normalize) ? e.processor.normalize : Vc, b = le(e.processor) && Ee(e.processor.interpolate) ? e.processor.interpolate : Hc, g = le(e.processor) && H(e.processor.type) ? e.processor.type : Uc, y = {
    list: i,
    named: c,
    plural: o,
    linked: (d, ...w) => {
      const [_, x] = w;
      let A = "text", L = "";
      w.length === 1 ? ce(_) ? (L = _.modifier || L, A = _.type || A) : H(_) && (L = _ || L) : w.length === 2 && (H(_) && (L = _ || L), H(x) && (A = x || A));
      const C = h(d, !0)(y), F = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        A === "vnode" && Le(C) && L ? C[0] : C
      );
      return L ? f(L)(F, A) : F;
    },
    message: h,
    type: g,
    interpolate: b,
    normalize: p,
    values: Be(be(), a, l)
  };
  return y;
}
const no = () => "", mt = (e) => Ee(e);
function so(e, ...t) {
  const { fallbackFormat: n, postTranslation: s, unresolving: r, messageCompiler: o, fallbackLocale: a, messages: i } = e, [l, c] = Us(...t), h = $e(c.missingWarn) ? c.missingWarn : e.missingWarn, f = $e(c.fallbackWarn) ? c.fallbackWarn : e.fallbackWarn, p = $e(c.escapeParameter) ? c.escapeParameter : e.escapeParameter, b = !!c.resolvedMessage, g = H(c.default) || $e(c.default) ? $e(c.default) ? o ? l : () => l : c.default : n ? o ? l : () => l : null, m = n || g != null && (H(g) || Ee(g)), y = ir(e, c);
  p && zc(c);
  let [d, w, _] = b ? [
    l,
    y,
    i[y] || be()
  ] : ga(e, l, y, a, f, h), x = d, A = l;
  if (!b && !(H(x) || wt(x) || mt(x)) && m && (x = g, A = x), !b && (!(H(x) || wt(x) || mt(x)) || !H(w)))
    return r ? fs : l;
  if (process.env.NODE_ENV !== "production" && H(x) && e.messageCompiler == null)
    return Tt(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${l}'.`), l;
  let L = !1;
  const C = () => {
    L = !0;
  }, F = mt(x) ? x : wa(e, l, w, x, A, C);
  if (L)
    return x;
  const D = Xc(e, w, _, c), j = Wc(D), q = Yc(e, F, j);
  let ne = s ? s(q, l) : q;
  if (p && H(ne) && (ne = pl(ne)), process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const De = {
      timestamp: Date.now(),
      key: H(l) ? l : mt(x) ? x.key : "",
      locale: w || (mt(x) ? x.locale : ""),
      format: H(x) ? x : mt(x) ? x.source : "",
      message: ne
    };
    De.meta = Be({}, e.__meta, /* @__PURE__ */ Pc() || {}), dc(De);
  }
  return ne;
}
function zc(e) {
  Le(e.list) ? e.list = e.list.map((t) => H(t) ? Rr(t) : t) : ce(e.named) && Object.keys(e.named).forEach((t) => {
    H(e.named[t]) && (e.named[t] = Rr(e.named[t]));
  });
}
function ga(e, t, n, s, r, o) {
  const { messages: a, onWarn: i, messageResolver: l, localeFallbacker: c } = e, h = c(e, s, n);
  let f = be(), p, b = null, g = n, m = null;
  const y = "translate";
  for (let d = 0; d < h.length; d++) {
    if (p = m = h[d], process.env.NODE_ENV !== "production" && n !== p && !fa(n, p) && ms(r, t) && i(Gt(Ze.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: p
    })), process.env.NODE_ENV !== "production" && n !== p) {
      const A = e.__v_emitter;
      A && A.emit("fallback", {
        type: y,
        key: t,
        from: g,
        to: m,
        groupId: `${y}:${t}`
      });
    }
    f = a[p] || be();
    let w = null, _, x;
    if (process.env.NODE_ENV !== "production" && It && (w = window.performance.now(), _ = "intlify-message-resolve-start", x = "intlify-message-resolve-end", at && at(_)), (b = l(f, t)) === null && (b = f[t]), process.env.NODE_ENV !== "production" && It) {
      const A = window.performance.now(), L = e.__v_emitter;
      L && w && b && L.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: b,
        time: A - w,
        groupId: `${y}:${t}`
      }), _ && x && at && Kt && (at(x), Kt("intlify message resolve", _, x));
    }
    if (H(b) || wt(b) || mt(b))
      break;
    if (!Rc(p, h)) {
      const A = lr(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        p,
        o,
        y
      );
      A !== t && (b = A);
    }
    g = m;
  }
  return [b, p, f];
}
function wa(e, t, n, s, r, o) {
  const { messageCompiler: a, warnHtmlMessage: i } = e;
  if (mt(s)) {
    const p = s;
    return p.locale = p.locale || n, p.key = p.key || t, p;
  }
  if (a == null) {
    const p = () => s;
    return p.locale = n, p.key = t, p;
  }
  let l = null, c, h;
  process.env.NODE_ENV !== "production" && It && (l = window.performance.now(), c = "intlify-message-compilation-start", h = "intlify-message-compilation-end", at && at(c));
  const f = a(s, Kc(e, n, r, s, i, o));
  if (process.env.NODE_ENV !== "production" && It) {
    const p = window.performance.now(), b = e.__v_emitter;
    b && l && b.emit("message-compilation", {
      type: "message-compilation",
      message: s,
      time: p - l,
      groupId: `translate:${t}`
    }), c && h && at && Kt && (at(h), Kt("intlify message compilation", c, h));
  }
  return f.locale = n, f.key = t, f.source = s, f;
}
function Yc(e, t, n) {
  let s = null, r, o;
  process.env.NODE_ENV !== "production" && It && (s = window.performance.now(), r = "intlify-message-evaluation-start", o = "intlify-message-evaluation-end", at && at(r));
  const a = t(n);
  if (process.env.NODE_ENV !== "production" && It) {
    const i = window.performance.now(), l = e.__v_emitter;
    l && s && l.emit("message-evaluation", {
      type: "message-evaluation",
      value: a,
      time: i - s,
      groupId: `translate:${t.key}`
    }), r && o && at && Kt && (at(o), Kt("intlify message evaluation", r, o));
  }
  return a;
}
function Us(...e) {
  const [t, n, s] = e, r = be();
  if (!H(t) && !Fe(t) && !mt(t) && !wt(t))
    throw $t(qe.INVALID_ARGUMENT);
  const o = Fe(t) ? String(t) : (mt(t), t);
  return Fe(n) ? r.plural = n : H(n) ? r.default = n : le(n) && !ds(n) ? r.named = n : Le(n) && (r.list = n), Fe(s) ? r.plural = s : H(s) ? r.default = s : le(s) && Be(r, s), [o, r];
}
function Kc(e, t, n, s, r, o) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: r,
    onError: (a) => {
      if (o && o(a), process.env.NODE_ENV !== "production") {
        const i = Gc(s), l = `Message compilation error: ${a.message}`, c = a.location && i && yl(i, a.location.start.offset, a.location.end.offset), h = e.__v_emitter;
        h && i && h.emit("compile-error", {
          message: i,
          error: a.message,
          start: a.location && a.location.start.offset,
          end: a.location && a.location.end.offset,
          groupId: `translate:${n}`
        }), console.error(c ? `${l}
${c}` : l);
      } else
        throw a;
    },
    onCacheKey: (a) => dl(t, n, a)
  };
}
function Gc(e) {
  if (H(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function Xc(e, t, n, s) {
  const { modifiers: r, pluralRules: o, messageResolver: a, fallbackLocale: i, fallbackWarn: l, missingWarn: c, fallbackContext: h } = e, p = {
    locale: t,
    modifiers: r,
    pluralRules: o,
    messages: (b, g) => {
      let m = a(n, b);
      if (m == null && (h || g)) {
        const [, , y] = ga(
          h || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          b,
          t,
          i,
          l,
          c
        );
        m = a(y, b);
      }
      if (H(m) || wt(m)) {
        let y = !1;
        const w = wa(e, b, t, m, b, () => {
          y = !0;
        });
        return y ? no : w;
      } else return mt(m) ? m : no;
    }
  };
  return e.processor && (p.processor = e.processor), s.list && (p.list = s.list), s.named && (p.named = s.named), Fe(s.plural) && (p.pluralIndex = s.plural), p;
}
Xl();
/*!
  * vue-i18n v11.2.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
const Jc = "11.2.8";
function Zc() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (qt().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (qt().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (qt().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (qt().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const He = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: mc,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function An(e, ...t) {
  return mn(e, null, process.env.NODE_ENV !== "production" ? { messages: Qc, args: t } : void 0);
}
const Qc = {
  [He.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [He.INVALID_ARGUMENT]: "Invalid argument",
  [He.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [He.NOT_INSTALLED]: "Need to install with `app.use` function",
  [He.UNEXPECTED_ERROR]: "Unexpected error",
  [He.REQUIRED_VALUE]: "Required in value: {0}",
  [He.INVALID_VALUE]: "Invalid value",
  [He.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [He.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [He.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [He.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, Vs = /* @__PURE__ */ Mt("__translateVNode"), Hs = /* @__PURE__ */ Mt("__datetimeParts"), js = /* @__PURE__ */ Mt("__numberParts"), qs = /* @__PURE__ */ Mt("__enableEmitter"), Ws = /* @__PURE__ */ Mt("__disableEmitter"), eu = Mt("__setPluralRules"), ba = /* @__PURE__ */ Mt("__injectWithOption"), zs = /* @__PURE__ */ Mt("__dispose"), kt = {
  FALLBACK_TO_ROOT: Tc,
  // 8
  NOT_FOUND_PARENT_SCOPE: 9,
  IGNORE_OBJ_FLATTEN: 10,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_LEGACY_MODE: 11,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE: 12,
  // duplicate `useI18n` calling
  DUPLICATE_USE_I18N_CALLING: 13
}, tu = {
  [kt.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [kt.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [kt.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [kt.DEPRECATE_LEGACY_MODE]: `Legacy API mode has been deprecated in v11. Use Composition API mode instead.
About how to use the Composition API mode, see https://vue-i18n.intlify.dev/guide/advanced/composition.html`,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [kt.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE]: "'v-t' has been deprecated in v11. Use translate APIs ('t' or '$t') instead.",
  [kt.DUPLICATE_USE_I18N_CALLING]: "Duplicate `useI18n` calling by local scope. Please don't call it on local scope, due to it does not work properly in component."
};
function Qn(e, ...t) {
  return us(tu[e], ...t);
}
function On(e) {
  if (!ce(e) || wt(e))
    return e;
  for (const t in e)
    if (gt(e, t))
      if (!t.includes("."))
        ce(e[t]) && On(e[t]);
      else {
        const n = t.split("."), s = n.length - 1;
        let r = e, o = !1;
        for (let a = 0; a < s; a++) {
          if (n[a] === "__proto__")
            throw new Error(`unsafe key: ${n[a]}`);
          if (n[a] in r || (r[n[a]] = be()), !ce(r[n[a]])) {
            process.env.NODE_ENV !== "production" && Tt(Qn(kt.IGNORE_OBJ_FLATTEN, {
              key: n[a]
            })), o = !0;
            break;
          }
          r = r[n[a]];
        }
        if (o || (wt(r) ? ra.includes(n[s]) || delete e[t] : (r[n[s]] = e[t], delete e[t])), !wt(r)) {
          const a = r[n[s]];
          ce(a) && On(a);
        }
      }
  return e;
}
function ya(e, t) {
  const { messages: n, __i18n: s, messageResolver: r, flatJson: o } = t, a = le(n) ? n : Le(s) ? be() : { [e]: be() };
  if (Le(s) && s.forEach((i) => {
    if ("locale" in i && "resource" in i) {
      const { locale: l, resource: c } = i;
      l ? (a[l] = a[l] || be(), zn(c, a[l])) : zn(c, a);
    } else
      H(i) && zn(JSON.parse(i), a);
  }), r == null && o)
    for (const i in a)
      gt(a, i) && On(a[i]);
  return a;
}
function va(e) {
  return e.type;
}
function nu(e, t, n) {
  let s = ce(t.messages) ? t.messages : be();
  "__i18nGlobal" in n && (s = ya(e.locale.value, {
    messages: s,
    __i18n: n.__i18nGlobal
  }));
  const r = Object.keys(s);
  r.length && r.forEach((o) => {
    e.mergeLocaleMessage(o, s[o]);
  });
  {
    if (ce(t.datetimeFormats)) {
      const o = Object.keys(t.datetimeFormats);
      o.length && o.forEach((a) => {
        e.mergeDateTimeFormat(a, t.datetimeFormats[a]);
      });
    }
    if (ce(t.numberFormats)) {
      const o = Object.keys(t.numberFormats);
      o.length && o.forEach((a) => {
        e.mergeNumberFormat(a, t.numberFormats[a]);
      });
    }
  }
}
function ro(e) {
  return ot(nl, null, e, 0);
}
function cr() {
  const e = "currentInstance";
  return e in Cs ? Cs[e] : Cs.getCurrentInstance();
}
const oo = "__INTLIFY_META__", ao = () => [], su = () => !1;
let io = 0;
function lo(e) {
  return (t, n, s, r) => e(n, s, cr() || void 0, r);
}
const ru = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = cr();
  let t = null;
  return e && (t = va(e)[oo]) ? { [oo]: t } : null;
};
function ou(e = {}) {
  const { __root: t, __injectWithOption: n } = e, s = t === void 0, r = e.flatJson, o = It ? z : tl;
  let a = $e(e.inheritLocale) ? e.inheritLocale : !0;
  const i = o(
    // prettier-ignore
    t && a ? t.locale.value : H(e.locale) ? e.locale : Jn
  ), l = o(
    // prettier-ignore
    t && a ? t.fallbackLocale.value : H(e.fallbackLocale) || Le(e.fallbackLocale) || le(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : i.value
  ), c = o(ya(i.value, e)), h = o(le(e.datetimeFormats) ? e.datetimeFormats : { [i.value]: {} }), f = o(le(e.numberFormats) ? e.numberFormats : { [i.value]: {} });
  let p = t ? t.missingWarn : $e(e.missingWarn) || Xn(e.missingWarn) ? e.missingWarn : !0, b = t ? t.fallbackWarn : $e(e.fallbackWarn) || Xn(e.fallbackWarn) ? e.fallbackWarn : !0, g = t ? t.fallbackRoot : $e(e.fallbackRoot) ? e.fallbackRoot : !0, m = !!e.fallbackFormat, y = Ee(e.missing) ? e.missing : null, d = Ee(e.missing) ? lo(e.missing) : null, w = Ee(e.postTranslation) ? e.postTranslation : null, _ = t ? t.warnHtmlMessage : $e(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, x = !!e.escapeParameter;
  const A = t ? t.modifiers : le(e.modifiers) ? e.modifiers : {};
  let L = e.pluralRules || t && t.pluralRules, C;
  C = (() => {
    s && Kr(null);
    const N = {
      version: Jc,
      locale: i.value,
      fallbackLocale: l.value,
      messages: c.value,
      modifiers: A,
      pluralRules: L,
      missing: d === null ? void 0 : d,
      missingWarn: p,
      fallbackWarn: b,
      fallbackFormat: m,
      unresolving: !0,
      postTranslation: w === null ? void 0 : w,
      warnHtmlMessage: _,
      escapeParameter: x,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    N.datetimeFormats = h.value, N.numberFormats = f.value, N.__datetimeFormatters = le(C) ? C.__datetimeFormatters : void 0, N.__numberFormatters = le(C) ? C.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (N.__v_emitter = le(C) ? C.__v_emitter : void 0);
    const M = Mc(N);
    return s && Kr(M), M;
  })(), _n(C, i.value, l.value);
  function D() {
    return [
      i.value,
      l.value,
      c.value,
      h.value,
      f.value
    ];
  }
  const j = me({
    get: () => i.value,
    set: (N) => {
      C.locale = N, i.value = N;
    }
  }), q = me({
    get: () => l.value,
    set: (N) => {
      C.fallbackLocale = N, l.value = N, _n(C, i.value, N);
    }
  }), ne = me(() => c.value), De = /* @__PURE__ */ me(() => h.value), V = /* @__PURE__ */ me(() => f.value);
  function U() {
    return Ee(w) ? w : null;
  }
  function R(N) {
    w = N, C.postTranslation = N;
  }
  function W() {
    return y;
  }
  function B(N) {
    N !== null && (d = lo(N)), y = N, C.missing = d;
  }
  function J(N, M) {
    return N !== "translate" || !M.resolvedMessage;
  }
  const K = (N, M, fe, Se, Vt, Un) => {
    D();
    let rn;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, s || (C.fallbackContext = t ? Dc() : void 0), rn = N(C);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, s || (C.fallbackContext = void 0);
    }
    if (fe !== "translate exists" && // for not `te` (e.g `t`)
    Fe(rn) && rn === fs || fe === "translate exists" && !rn) {
      const [Ht, Qi] = M();
      if (process.env.NODE_ENV !== "production" && t && H(Ht) && J(fe, Qi) && (g && (ms(b, Ht) || da(p, Ht)) && Tt(Qn(kt.FALLBACK_TO_ROOT, {
        key: Ht,
        type: fe
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: Ir } = C;
        Ir && g && Ir.emit("fallback", {
          type: fe,
          key: Ht,
          to: "global",
          groupId: `${fe}:${Ht}`
        });
      }
      return t && g ? Se(t) : Vt(Ht);
    } else {
      if (Un(rn))
        return rn;
      throw An(He.UNEXPECTED_RETURN_TYPE);
    }
  };
  function ee(...N) {
    return K((M) => Reflect.apply(so, null, [M, ...N]), () => Us(...N), "translate", (M) => Reflect.apply(M.t, M, [...N]), (M) => M, (M) => H(M));
  }
  function re(...N) {
    const [M, fe, Se] = N;
    if (Se && !ce(Se))
      throw An(He.INVALID_ARGUMENT);
    return ee(M, fe, Be({ resolvedMessage: !0 }, Se || {}));
  }
  function de(...N) {
    return K((M) => Reflect.apply(Jr, null, [M, ...N]), () => Fs(...N), "datetime format", (M) => Reflect.apply(M.d, M, [...N]), () => Zn, (M) => H(M) || Le(M));
  }
  function ve(...N) {
    return K((M) => Reflect.apply(Qr, null, [M, ...N]), () => Bs(...N), "number format", (M) => Reflect.apply(M.n, M, [...N]), () => Zn, (M) => H(M) || Le(M));
  }
  function Te(N) {
    return N.map((M) => H(M) || Fe(M) || $e(M) ? ro(String(M)) : M);
  }
  const st = {
    normalize: Te,
    interpolate: (N) => N,
    type: "vnode"
  };
  function ft(...N) {
    return K((M) => {
      let fe;
      const Se = M;
      try {
        Se.processor = st, fe = Reflect.apply(so, null, [Se, ...N]);
      } finally {
        Se.processor = null;
      }
      return fe;
    }, () => Us(...N), "translate", (M) => M[Vs](...N), (M) => [ro(M)], (M) => Le(M));
  }
  function rt(...N) {
    return K((M) => Reflect.apply(Qr, null, [M, ...N]), () => Bs(...N), "number format", (M) => M[js](...N), ao, (M) => H(M) || Le(M));
  }
  function Ae(...N) {
    return K((M) => Reflect.apply(Jr, null, [M, ...N]), () => Fs(...N), "datetime format", (M) => M[Hs](...N), ao, (M) => H(M) || Le(M));
  }
  function oe(N) {
    L = N, C.pluralRules = L;
  }
  function se(N, M) {
    return K(() => {
      if (!N)
        return !1;
      const fe = H(M) ? M : i.value, Se = ge(fe), Vt = C.messageResolver(Se, N);
      return wt(Vt) || mt(Vt) || H(Vt);
    }, () => [N], "translate exists", (fe) => Reflect.apply(fe.te, fe, [N, M]), su, (fe) => $e(fe));
  }
  function ae(N) {
    let M = null;
    const fe = oa(C, l.value, i.value);
    for (let Se = 0; Se < fe.length; Se++) {
      const Vt = c.value[fe[Se]] || {}, Un = C.messageResolver(Vt, N);
      if (Un != null) {
        M = Un;
        break;
      }
    }
    return M;
  }
  function Q(N) {
    const M = ae(N);
    return M ?? (t ? t.tm(N) || {} : {});
  }
  function ge(N) {
    return c.value[N] || {};
  }
  function Ke(N, M) {
    if (r) {
      const fe = { [N]: M };
      for (const Se in fe)
        gt(fe, Se) && On(fe[Se]);
      M = fe[N];
    }
    c.value[N] = M, C.messages = c.value;
  }
  function Ve(N, M) {
    c.value[N] = c.value[N] || {};
    const fe = { [N]: M };
    if (r)
      for (const Se in fe)
        gt(fe, Se) && On(fe[Se]);
    M = fe[N], zn(M, c.value[N]), C.messages = c.value;
  }
  function v(N) {
    return h.value[N] || {};
  }
  function E(N, M) {
    h.value[N] = M, C.datetimeFormats = h.value, Zr(C, N, M);
  }
  function P(N, M) {
    h.value[N] = Be(h.value[N] || {}, M), C.datetimeFormats = h.value, Zr(C, N, M);
  }
  function Y(N) {
    return f.value[N] || {};
  }
  function xe(N, M) {
    f.value[N] = M, C.numberFormats = f.value, eo(C, N, M);
  }
  function Oe(N, M) {
    f.value[N] = Be(f.value[N] || {}, M), C.numberFormats = f.value, eo(C, N, M);
  }
  io++, t && It && (bt(t.locale, (N) => {
    a && (i.value = N, C.locale = N, _n(C, i.value, l.value));
  }), bt(t.fallbackLocale, (N) => {
    a && (l.value = N, C.fallbackLocale = N, _n(C, i.value, l.value));
  }));
  const ie = {
    id: io,
    locale: j,
    fallbackLocale: q,
    get inheritLocale() {
      return a;
    },
    set inheritLocale(N) {
      a = N, N && t && (i.value = t.locale.value, l.value = t.fallbackLocale.value, _n(C, i.value, l.value));
    },
    get availableLocales() {
      return Object.keys(c.value).sort();
    },
    messages: ne,
    get modifiers() {
      return A;
    },
    get pluralRules() {
      return L || {};
    },
    get isGlobal() {
      return s;
    },
    get missingWarn() {
      return p;
    },
    set missingWarn(N) {
      p = N, C.missingWarn = p;
    },
    get fallbackWarn() {
      return b;
    },
    set fallbackWarn(N) {
      b = N, C.fallbackWarn = b;
    },
    get fallbackRoot() {
      return g;
    },
    set fallbackRoot(N) {
      g = N;
    },
    get fallbackFormat() {
      return m;
    },
    set fallbackFormat(N) {
      m = N, C.fallbackFormat = m;
    },
    get warnHtmlMessage() {
      return _;
    },
    set warnHtmlMessage(N) {
      _ = N, C.warnHtmlMessage = N;
    },
    get escapeParameter() {
      return x;
    },
    set escapeParameter(N) {
      x = N, C.escapeParameter = N;
    },
    t: ee,
    getLocaleMessage: ge,
    setLocaleMessage: Ke,
    mergeLocaleMessage: Ve,
    getPostTranslationHandler: U,
    setPostTranslationHandler: R,
    getMissingHandler: W,
    setMissingHandler: B,
    [eu]: oe
  };
  return ie.datetimeFormats = De, ie.numberFormats = V, ie.rt = re, ie.te = se, ie.tm = Q, ie.d = de, ie.n = ve, ie.getDateTimeFormat = v, ie.setDateTimeFormat = E, ie.mergeDateTimeFormat = P, ie.getNumberFormat = Y, ie.setNumberFormat = xe, ie.mergeNumberFormat = Oe, ie[ba] = n, ie[Vs] = ft, ie[Hs] = Ae, ie[js] = rt, process.env.NODE_ENV !== "production" && (ie[qs] = (N) => {
    C.__v_emitter = N;
  }, ie[Ws] = () => {
    C.__v_emitter = void 0;
  }), ie;
}
function co(e, t) {
}
const ur = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function au({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((s, r) => [
    ...s,
    // prettier-ignore
    ...r.type === Me ? r.children : [r]
  ], []) : t.reduce((n, s) => {
    const r = e[s];
    return r && (n[s] = r()), n;
  }, be());
}
function _a() {
  return Me;
}
Be({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    validator: (e) => Fe(e) || !isNaN(e)
  }
}, ur);
function iu(e) {
  return Le(e) && !H(e[0]);
}
function xa(e, t, n, s) {
  const { slots: r, attrs: o } = t;
  return () => {
    const a = { part: !0 };
    let i = be();
    e.locale && (a.locale = e.locale), H(e.format) ? a.key = e.format : ce(e.format) && (H(e.format.key) && (a.key = e.format.key), i = Object.keys(e.format).reduce((p, b) => n.includes(b) ? Be(be(), p, { [b]: e.format[b] }) : p, be()));
    const l = s(e.value, a, i);
    let c = [a.key];
    Le(l) ? c = l.map((p, b) => {
      const g = r[p.type], m = g ? g({ [p.type]: p.value, index: b, parts: l }) : [p.value];
      return iu(m) && (m[0].key = `${p.type}-${b}`), m;
    }) : H(l) && (c = [l]);
    const h = Be(be(), o), f = H(e.tag) || ce(e.tag) ? e.tag : _a();
    return jo(f, h, c);
  };
}
Be({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, ur);
const lu = /* @__PURE__ */ Mt("global-vue-i18n");
function Ot(e = {}) {
  const t = cr();
  if (t == null)
    throw An(He.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw An(He.NOT_INSTALLED);
  const n = cu(t), s = du(n), r = va(t), o = uu(e, r);
  if (o === "global")
    return nu(s, e, r), s;
  if (o === "parent") {
    let l = fu(n, t, e.__useComponent);
    return l == null && (process.env.NODE_ENV !== "production" && Tt(Qn(kt.NOT_FOUND_PARENT_SCOPE)), l = s), l;
  }
  const a = n;
  let i = a.__getInstance(t);
  if (i == null) {
    const l = Be({}, e);
    "__i18n" in r && (l.__i18n = r.__i18n), s && (l.__root = s), i = ou(l), a.__composerExtend && (i[zs] = a.__composerExtend(i)), hu(a, t, i), a.__setInstance(t, i);
  } else
    process.env.NODE_ENV !== "production" && o === "local" && Tt(Qn(kt.DUPLICATE_USE_I18N_CALLING));
  return i;
}
function cu(e) {
  const t = el(e.isCE ? lu : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw An(e.isCE ? He.NOT_INSTALLED_WITH_PROVIDE : He.UNEXPECTED_ERROR);
  return t;
}
function uu(e, t) {
  return ds(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function du(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function fu(e, t, n = !1) {
  let s = null;
  const r = t.root;
  let o = mu(t, n);
  for (; o != null; ) {
    const a = e;
    if (e.mode === "composition")
      s = a.__getInstance(o);
    else if (__VUE_I18N_LEGACY_API__) {
      const i = a.__getInstance(o);
      i != null && (s = i.__composer, n && s && !s[ba] && (s = null));
    }
    if (s != null || r === o)
      break;
    o = o.parent;
  }
  return s;
}
function mu(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function hu(e, t, n) {
  let s = null;
  Dt(() => {
    if (process.env.NODE_ENV !== "production") {
      t.__VUE_I18N__ = n, s = vl();
      const r = n;
      r[qs] && r[qs](s), s.on("*", co);
    }
  }, t), qo(() => {
    const r = n;
    process.env.NODE_ENV !== "production" && (s && s.off("*", co), r[Ws] && r[Ws](), delete t.__VUE_I18N__), e.__deleteInstance(t);
    const o = r[zs];
    o && (o(), delete r[zs]);
  }, t);
}
Be({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, ur);
Zc();
Nc(lc);
$c(Cc);
Lc(oa);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = qt();
  e.__INTLIFY__ = !0, cc(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
function pu(e) {
  const t = z([]), n = z(!1), s = z(null);
  return { items: t, loading: n, error: s, load: async () => {
    n.value = !0, s.value = null;
    try {
      t.value = await e.getMenu();
    } catch (a) {
      s.value = a.message || "Unknown error";
    } finally {
      n.value = !1;
    }
  }, addItems: async (a) => {
    if (!e.createMenuItems)
      throw new Error("createMenuItems API not implemented");
    n.value = !0, s.value = null;
    try {
      const i = await e.createMenuItems(a);
      t.value.push(...i), t.value.sort((l, c) => l.order - c.order);
    } catch (i) {
      s.value = i.message || "Unknown error";
    } finally {
      n.value = !1;
    }
  } };
}
const gu = (e) => {
  if (!e.trim()) return { payload: [], error: !1 };
  const t = e.split(`
`).map((r) => r.trim()).filter((r) => r), n = /* @__PURE__ */ new Map();
  let s = !1;
  return t.forEach((r, o) => {
    const a = r.split(",").map((h) => h.trim());
    if (a.length !== 3 || Number.isNaN(Number(a[1]))) {
      s = !0;
      return;
    }
    const i = a[0], l = a[1], c = a[2];
    n.has(i) || n.set(i, { name: i, price: l, description: c, order: o + 1 });
  }), {
    payload: Array.from(n.values()),
    error: s
  };
}, wu = (e, t, n) => `
    <div class="text-left space-y-4">
      <div class="p-3.5 border-none rounded-2xl bg-gray-100 shadow-inner">
        <p class="text-xs font-bold text-gray-700/70 mb-1 uppercase tracking-wider">
          ${n("order.selectedOrders")}: ${e}
        </p>
        <p class="text-3xl font-black text-blue-700">$${t}</p>
      </div>

      <div class="grid gap-3 text-left">
        <div>
          <label for="checkout-carrier-num" class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1.5">
            手機條碼
          </label>
          <input id="checkout-carrier-num" type="text" maxlength="8" placeholder="/ABC1234" 
            class="swal2-input !m-0 !w-full !h-auto !px-4 !py-3 !rounded-xl !border !border-gray-200 !shadow-none !text-sm font-mono" />
        </div>

        <div>
          <label for="checkout-customer-identifier" class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1.5">
            統一編號
          </label>
          <input id="checkout-customer-identifier" type="text" inputmode="numeric" maxlength="8" placeholder="8 碼統一編號" 
            class="swal2-input !m-0 !w-full !h-auto !px-4 !py-3 !rounded-xl !border !border-gray-200 !shadow-none !text-sm font-mono" />
        </div>

        <div>
          <label for="checkout-customer-name" class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1.5">
            公司全名
          </label>
          <input id="checkout-customer-name" type="text" placeholder="公司全名" 
            class="swal2-input !m-0 !w-full !h-auto !px-4 !py-3 !rounded-xl !border !border-gray-200 !shadow-none !text-sm" />
        </div>

        <div>
          <label for="checkout-customer-email" class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1.5">
            Email
          </label>
          <input id="checkout-customer-email" type="email" placeholder="name@example.com" 
            class="swal2-input !m-0 !w-full !h-auto !px-4 !py-3 !rounded-xl !border !border-gray-200 !shadow-none !text-sm" />
        </div>
      </div>
    </div>
  `;
/*!
* sweetalert2 v11.26.10
* Released under the MIT License.
*/
function Ea(e, t, n) {
  if (typeof e == "function" ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
function bu(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function uo(e, t) {
  return e.get(Ea(e, t));
}
function yu(e, t, n) {
  bu(e, t), t.set(e, n);
}
function vu(e, t, n) {
  return e.set(Ea(e, t), n), n;
}
const _u = 100, G = {}, xu = () => {
  G.previousActiveElement instanceof HTMLElement ? (G.previousActiveElement.focus(), G.previousActiveElement = null) : document.body && document.body.focus();
}, Eu = (e) => new Promise((t) => {
  if (!e)
    return t();
  const n = window.scrollX, s = window.scrollY;
  G.restoreFocusTimeout = setTimeout(() => {
    xu(), t();
  }, _u), window.scrollTo(n, s);
}), ka = "swal2-", ku = ["container", "shown", "height-auto", "iosfix", "popup", "modal", "no-backdrop", "no-transition", "toast", "toast-shown", "show", "hide", "close", "title", "html-container", "actions", "confirm", "deny", "cancel", "footer", "icon", "icon-content", "image", "input", "file", "range", "select", "radio", "checkbox", "label", "textarea", "inputerror", "input-label", "validation-message", "progress-steps", "active-progress-step", "progress-step", "progress-step-line", "loader", "loading", "styled", "top", "top-start", "top-end", "top-left", "top-right", "center", "center-start", "center-end", "center-left", "center-right", "bottom", "bottom-start", "bottom-end", "bottom-left", "bottom-right", "grow-row", "grow-column", "grow-fullscreen", "rtl", "timer-progress-bar", "timer-progress-bar-container", "scrollbar-measure", "icon-success", "icon-warning", "icon-info", "icon-question", "icon-error", "draggable", "dragging"], S = ku.reduce(
  (e, t) => (e[t] = ka + t, e),
  /** @type {SwalClasses} */
  {}
), Cu = ["success", "warning", "info", "question", "error"], es = Cu.reduce(
  (e, t) => (e[t] = ka + t, e),
  /** @type {SwalIcons} */
  {}
), Ca = "SweetAlert2:", dr = (e) => e.charAt(0).toUpperCase() + e.slice(1), Xe = (e) => {
  console.warn(`${Ca} ${typeof e == "object" ? e.join(" ") : e}`);
}, Qt = (e) => {
  console.error(`${Ca} ${e}`);
}, fo = [], Tu = (e) => {
  fo.includes(e) || (fo.push(e), Xe(e));
}, Ta = (e, t = null) => {
  Tu(`"${e}" is deprecated and will be removed in the next major release.${t ? ` Use "${t}" instead.` : ""}`);
}, hs = (e) => typeof e == "function" ? e() : e, fr = (e) => e && typeof e.toPromise == "function", Sn = (e) => fr(e) ? e.toPromise() : Promise.resolve(e), mr = (e) => e && Promise.resolve(e) === e, Je = () => document.body.querySelector(`.${S.container}`), Nn = (e) => {
  const t = Je();
  return t ? t.querySelector(e) : null;
}, ct = (e) => Nn(`.${e}`), ue = () => ct(S.popup), hn = () => ct(S.icon), Au = () => ct(S["icon-content"]), Aa = () => ct(S.title), hr = () => ct(S["html-container"]), Oa = () => ct(S.image), pr = () => ct(S["progress-steps"]), ps = () => ct(S["validation-message"]), At = () => (
  /** @type {HTMLButtonElement} */
  Nn(`.${S.actions} .${S.confirm}`)
), pn = () => (
  /** @type {HTMLButtonElement} */
  Nn(`.${S.actions} .${S.cancel}`)
), en = () => (
  /** @type {HTMLButtonElement} */
  Nn(`.${S.actions} .${S.deny}`)
), Ou = () => ct(S["input-label"]), gn = () => Nn(`.${S.loader}`), $n = () => ct(S.actions), Sa = () => ct(S.footer), gs = () => ct(S["timer-progress-bar"]), gr = () => ct(S.close), Su = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`, wr = () => {
  const e = ue();
  if (!e)
    return [];
  const t = e.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'), n = Array.from(t).sort((o, a) => {
    const i = parseInt(o.getAttribute("tabindex") || "0"), l = parseInt(a.getAttribute("tabindex") || "0");
    return i > l ? 1 : i < l ? -1 : 0;
  }), s = e.querySelectorAll(Su), r = Array.from(s).filter((o) => o.getAttribute("tabindex") !== "-1");
  return [...new Set(n.concat(r))].filter((o) => et(o));
}, br = () => Lt(document.body, S.shown) && !Lt(document.body, S["toast-shown"]) && !Lt(document.body, S["no-backdrop"]), ws = () => {
  const e = ue();
  return e ? Lt(e, S.toast) : !1;
}, Nu = () => {
  const e = ue();
  return e ? e.hasAttribute("data-loading") : !1;
}, ut = (e, t) => {
  if (e.textContent = "", t) {
    const s = new DOMParser().parseFromString(t, "text/html"), r = s.querySelector("head");
    r && Array.from(r.childNodes).forEach((a) => {
      e.appendChild(a);
    });
    const o = s.querySelector("body");
    o && Array.from(o.childNodes).forEach((a) => {
      a instanceof HTMLVideoElement || a instanceof HTMLAudioElement ? e.appendChild(a.cloneNode(!0)) : e.appendChild(a);
    });
  }
}, Lt = (e, t) => {
  if (!t)
    return !1;
  const n = t.split(/\s+/);
  for (let s = 0; s < n.length; s++)
    if (!e.classList.contains(n[s]))
      return !1;
  return !0;
}, $u = (e, t) => {
  Array.from(e.classList).forEach((n) => {
    !Object.values(S).includes(n) && !Object.values(es).includes(n) && !Object.values(t.showClass || {}).includes(n) && e.classList.remove(n);
  });
}, lt = (e, t, n) => {
  if ($u(e, t), !t.customClass)
    return;
  const s = t.customClass[
    /** @type {keyof SweetAlertCustomClass} */
    n
  ];
  if (s) {
    if (typeof s != "string" && !s.forEach) {
      Xe(`Invalid type of customClass.${n}! Expected string or iterable object, got "${typeof s}"`);
      return;
    }
    he(e, s);
  }
}, bs = (e, t) => {
  if (!t)
    return null;
  switch (t) {
    case "select":
    case "textarea":
    case "file":
      return e.querySelector(`.${S.popup} > .${S[t]}`);
    case "checkbox":
      return e.querySelector(`.${S.popup} > .${S.checkbox} input`);
    case "radio":
      return e.querySelector(`.${S.popup} > .${S.radio} input:checked`) || e.querySelector(`.${S.popup} > .${S.radio} input:first-child`);
    case "range":
      return e.querySelector(`.${S.popup} > .${S.range} input`);
    default:
      return e.querySelector(`.${S.popup} > .${S.input}`);
  }
}, Na = (e) => {
  if (e.focus(), e.type !== "file") {
    const t = e.value;
    e.value = "", e.value = t;
  }
}, $a = (e, t, n) => {
  !e || !t || (typeof t == "string" && (t = t.split(/\s+/).filter(Boolean)), t.forEach((s) => {
    Array.isArray(e) ? e.forEach((r) => {
      n ? r.classList.add(s) : r.classList.remove(s);
    }) : n ? e.classList.add(s) : e.classList.remove(s);
  }));
}, he = (e, t) => {
  $a(e, t, !0);
}, ht = (e, t) => {
  $a(e, t, !1);
}, Rt = (e, t) => {
  const n = Array.from(e.children);
  for (let s = 0; s < n.length; s++) {
    const r = n[s];
    if (r instanceof HTMLElement && Lt(r, t))
      return r;
  }
}, zt = (e, t, n) => {
  n === `${parseInt(`${n}`)}` && (n = parseInt(n)), n || parseInt(`${n}`) === 0 ? e.style.setProperty(t, typeof n == "number" ? `${n}px` : n) : e.style.removeProperty(t);
}, Ue = (e, t = "flex") => {
  e && (e.style.display = t);
}, Ye = (e) => {
  e && (e.style.display = "none");
}, yr = (e, t = "block") => {
  e && new MutationObserver(() => {
    Ln(e, e.innerHTML, t);
  }).observe(e, {
    childList: !0,
    subtree: !0
  });
}, mo = (e, t, n, s) => {
  const r = e.querySelector(t);
  r && r.style.setProperty(n, s);
}, Ln = (e, t, n = "flex") => {
  t ? Ue(e, n) : Ye(e);
}, et = (e) => !!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length)), Lu = () => !et(At()) && !et(en()) && !et(pn()), Ys = (e) => e.scrollHeight > e.clientHeight, Iu = (e, t) => {
  let n = e;
  for (; n && n !== t; ) {
    if (Ys(n))
      return !0;
    n = n.parentElement;
  }
  return !1;
}, La = (e) => {
  const t = window.getComputedStyle(e), n = parseFloat(t.getPropertyValue("animation-duration") || "0"), s = parseFloat(t.getPropertyValue("transition-duration") || "0");
  return n > 0 || s > 0;
}, vr = (e, t = !1) => {
  const n = gs();
  n && et(n) && (t && (n.style.transition = "none", n.style.width = "100%"), setTimeout(() => {
    n.style.transition = `width ${e / 1e3}s linear`, n.style.width = "0%";
  }, 10));
}, Pu = () => {
  const e = gs();
  if (!e)
    return;
  const t = parseInt(window.getComputedStyle(e).width);
  e.style.removeProperty("transition"), e.style.width = "100%";
  const n = parseInt(window.getComputedStyle(e).width), s = t / n * 100;
  e.style.width = `${s}%`;
}, Du = () => typeof window > "u" || typeof document > "u", Mu = `
 <div aria-labelledby="${S.title}" aria-describedby="${S["html-container"]}" class="${S.popup}" tabindex="-1">
   <button type="button" class="${S.close}"></button>
   <ul class="${S["progress-steps"]}"></ul>
   <div class="${S.icon}"></div>
   <img class="${S.image}" />
   <h2 class="${S.title}" id="${S.title}"></h2>
   <div class="${S["html-container"]}" id="${S["html-container"]}"></div>
   <input class="${S.input}" id="${S.input}" />
   <input type="file" class="${S.file}" />
   <div class="${S.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${S.select}" id="${S.select}"></select>
   <div class="${S.radio}"></div>
   <label class="${S.checkbox}">
     <input type="checkbox" id="${S.checkbox}" />
     <span class="${S.label}"></span>
   </label>
   <textarea class="${S.textarea}" id="${S.textarea}"></textarea>
   <div class="${S["validation-message"]}" id="${S["validation-message"]}"></div>
   <div class="${S.actions}">
     <div class="${S.loader}"></div>
     <button type="button" class="${S.confirm}"></button>
     <button type="button" class="${S.deny}"></button>
     <button type="button" class="${S.cancel}"></button>
   </div>
   <div class="${S.footer}"></div>
   <div class="${S["timer-progress-bar-container"]}">
     <div class="${S["timer-progress-bar"]}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, ""), Ru = () => {
  const e = Je();
  return e ? (e.remove(), ht([document.documentElement, document.body], [S["no-backdrop"], S["toast-shown"], S["has-column"]]), !0) : !1;
}, jt = () => {
  G.currentInstance.resetValidationMessage();
}, Fu = () => {
  const e = ue(), t = Rt(e, S.input), n = Rt(e, S.file), s = e.querySelector(`.${S.range} input`), r = e.querySelector(`.${S.range} output`), o = Rt(e, S.select), a = e.querySelector(`.${S.checkbox} input`), i = Rt(e, S.textarea);
  t.oninput = jt, n.onchange = jt, o.onchange = jt, a.onchange = jt, i.oninput = jt, s.oninput = () => {
    jt(), r.value = s.value;
  }, s.onchange = () => {
    jt(), r.value = s.value;
  };
}, Bu = (e) => typeof e == "string" ? document.querySelector(e) : e, Uu = (e) => {
  const t = ue();
  t.setAttribute("role", e.toast ? "alert" : "dialog"), t.setAttribute("aria-live", e.toast ? "polite" : "assertive"), e.toast || t.setAttribute("aria-modal", "true");
}, Vu = (e) => {
  window.getComputedStyle(e).direction === "rtl" && (he(Je(), S.rtl), G.isRTL = !0);
}, Hu = (e) => {
  const t = Ru();
  if (Du()) {
    Qt("SweetAlert2 requires document to initialize");
    return;
  }
  const n = document.createElement("div");
  n.className = S.container, t && he(n, S["no-transition"]), ut(n, Mu), n.dataset.swal2Theme = e.theme;
  const s = Bu(e.target);
  s.appendChild(n), e.topLayer && (n.setAttribute("popover", ""), n.showPopover()), Uu(e), Vu(s), Fu();
}, _r = (e, t) => {
  e instanceof HTMLElement ? t.appendChild(e) : typeof e == "object" ? ju(e, t) : e && ut(t, e);
}, ju = (e, t) => {
  e.jquery ? qu(t, e) : ut(t, e.toString());
}, qu = (e, t) => {
  if (e.textContent = "", 0 in t)
    for (let n = 0; n in t; n++)
      e.appendChild(t[n].cloneNode(!0));
  else
    e.appendChild(t.cloneNode(!0));
}, Wu = (e, t) => {
  const n = $n(), s = gn();
  !n || !s || (!t.showConfirmButton && !t.showDenyButton && !t.showCancelButton ? Ye(n) : Ue(n), lt(n, t, "actions"), zu(n, s, t), ut(s, t.loaderHtml || ""), lt(s, t, "loader"));
};
function zu(e, t, n) {
  const s = At(), r = en(), o = pn();
  !s || !r || !o || (Ns(s, "confirm", n), Ns(r, "deny", n), Ns(o, "cancel", n), Yu(s, r, o, n), n.reverseButtons && (n.toast ? (e.insertBefore(o, s), e.insertBefore(r, s)) : (e.insertBefore(o, t), e.insertBefore(r, t), e.insertBefore(s, t))));
}
function Yu(e, t, n, s) {
  if (!s.buttonsStyling) {
    ht([e, t, n], S.styled);
    return;
  }
  he([e, t, n], S.styled), s.confirmButtonColor && e.style.setProperty("--swal2-confirm-button-background-color", s.confirmButtonColor), s.denyButtonColor && t.style.setProperty("--swal2-deny-button-background-color", s.denyButtonColor), s.cancelButtonColor && n.style.setProperty("--swal2-cancel-button-background-color", s.cancelButtonColor), Ss(e), Ss(t), Ss(n);
}
function Ss(e) {
  const t = window.getComputedStyle(e);
  if (t.getPropertyValue("--swal2-action-button-focus-box-shadow"))
    return;
  const n = t.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, "rgba($1, $2, $3, 0.5)");
  e.style.setProperty("--swal2-action-button-focus-box-shadow", t.getPropertyValue("--swal2-outline").replace(/ rgba\(.*/, ` ${n}`));
}
function Ns(e, t, n) {
  const s = (
    /** @type {'Confirm' | 'Deny' | 'Cancel'} */
    dr(t)
  );
  Ln(e, n[`show${s}Button`], "inline-block"), ut(e, n[`${t}ButtonText`] || ""), e.setAttribute("aria-label", n[`${t}ButtonAriaLabel`] || ""), e.className = S[t], lt(e, n, `${t}Button`);
}
const Ku = (e, t) => {
  const n = gr();
  n && (ut(n, t.closeButtonHtml || ""), lt(n, t, "closeButton"), Ln(n, t.showCloseButton), n.setAttribute("aria-label", t.closeButtonAriaLabel || ""));
}, Gu = (e, t) => {
  const n = Je();
  n && (Xu(n, t.backdrop), Ju(n, t.position), Zu(n, t.grow), lt(n, t, "container"));
};
function Xu(e, t) {
  typeof t == "string" ? e.style.background = t : t || he([document.documentElement, document.body], S["no-backdrop"]);
}
function Ju(e, t) {
  t && (t in S ? he(e, S[t]) : (Xe('The "position" parameter is not valid, defaulting to "center"'), he(e, S.center)));
}
function Zu(e, t) {
  t && he(e, S[`grow-${t}`]);
}
var _e = {
  innerParams: /* @__PURE__ */ new WeakMap(),
  domCache: /* @__PURE__ */ new WeakMap()
};
const Qu = ["input", "file", "range", "select", "radio", "checkbox", "textarea"], ed = (e, t) => {
  const n = ue();
  if (!n)
    return;
  const s = _e.innerParams.get(e), r = !s || t.input !== s.input;
  Qu.forEach((o) => {
    const a = Rt(n, S[o]);
    a && (sd(o, t.inputAttributes), a.className = S[o], r && Ye(a));
  }), t.input && (r && td(t), rd(t));
}, td = (e) => {
  if (!e.input)
    return;
  if (!Ne[e.input]) {
    Qt(`Unexpected type of input! Expected ${Object.keys(Ne).join(" | ")}, got "${e.input}"`);
    return;
  }
  const t = Ia(e.input);
  if (!t)
    return;
  const n = Ne[e.input](t, e);
  Ue(t), e.inputAutoFocus && setTimeout(() => {
    Na(n);
  });
}, nd = (e) => {
  for (let t = 0; t < e.attributes.length; t++) {
    const n = e.attributes[t].name;
    ["id", "type", "value", "style"].includes(n) || e.removeAttribute(n);
  }
}, sd = (e, t) => {
  const n = ue();
  if (!n)
    return;
  const s = bs(n, e);
  if (s) {
    nd(s);
    for (const r in t)
      s.setAttribute(r, t[r]);
  }
}, rd = (e) => {
  if (!e.input)
    return;
  const t = Ia(e.input);
  t && lt(t, e, "input");
}, xr = (e, t) => {
  !e.placeholder && t.inputPlaceholder && (e.placeholder = t.inputPlaceholder);
}, In = (e, t, n) => {
  if (n.inputLabel) {
    const s = document.createElement("label"), r = S["input-label"];
    s.setAttribute("for", e.id), s.className = r, typeof n.customClass == "object" && he(s, n.customClass.inputLabel), s.innerText = n.inputLabel, t.insertAdjacentElement("beforebegin", s);
  }
}, Ia = (e) => {
  const t = ue();
  if (t)
    return Rt(t, S[
      /** @type {SwalClass} */
      e
    ] || S.input);
}, ts = (e, t) => {
  ["string", "number"].includes(typeof t) ? e.value = `${t}` : mr(t) || Xe(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t}"`);
}, Ne = {};
Ne.text = Ne.email = Ne.password = Ne.number = Ne.tel = Ne.url = Ne.search = Ne.date = Ne["datetime-local"] = Ne.time = Ne.week = Ne.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */
(e, t) => (ts(e, t.inputValue), In(e, e, t), xr(e, t), e.type = t.input, e);
Ne.file = (e, t) => (In(e, e, t), xr(e, t), e);
Ne.range = (e, t) => {
  const n = e.querySelector("input"), s = e.querySelector("output");
  return ts(n, t.inputValue), n.type = t.input, ts(s, t.inputValue), In(n, e, t), e;
};
Ne.select = (e, t) => {
  if (e.textContent = "", t.inputPlaceholder) {
    const n = document.createElement("option");
    ut(n, t.inputPlaceholder), n.value = "", n.disabled = !0, n.selected = !0, e.appendChild(n);
  }
  return In(e, e, t), e;
};
Ne.radio = (e) => (e.textContent = "", e);
Ne.checkbox = (e, t) => {
  const n = bs(ue(), "checkbox");
  n.value = "1", n.checked = !!t.inputValue;
  const s = e.querySelector("span");
  return ut(s, t.inputPlaceholder || t.inputLabel), n;
};
Ne.textarea = (e, t) => {
  ts(e, t.inputValue), xr(e, t), In(e, e, t);
  const n = (s) => parseInt(window.getComputedStyle(s).marginLeft) + parseInt(window.getComputedStyle(s).marginRight);
  return setTimeout(() => {
    if ("MutationObserver" in window) {
      const s = parseInt(window.getComputedStyle(ue()).width), r = () => {
        if (!document.body.contains(e))
          return;
        const o = e.offsetWidth + n(e);
        o > s ? ue().style.width = `${o}px` : zt(ue(), "width", t.width);
      };
      new MutationObserver(r).observe(e, {
        attributes: !0,
        attributeFilter: ["style"]
      });
    }
  }), e;
};
const od = (e, t) => {
  const n = hr();
  n && (yr(n), lt(n, t, "htmlContainer"), t.html ? (_r(t.html, n), Ue(n, "block")) : t.text ? (n.textContent = t.text, Ue(n, "block")) : Ye(n), ed(e, t));
}, ad = (e, t) => {
  const n = Sa();
  n && (yr(n), Ln(n, !!t.footer, "block"), t.footer && _r(t.footer, n), lt(n, t, "footer"));
}, id = (e, t) => {
  const n = _e.innerParams.get(e), s = hn();
  if (!s)
    return;
  if (n && t.icon === n.icon) {
    po(s, t), ho(s, t);
    return;
  }
  if (!t.icon && !t.iconHtml) {
    Ye(s);
    return;
  }
  if (t.icon && Object.keys(es).indexOf(t.icon) === -1) {
    Qt(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`), Ye(s);
    return;
  }
  Ue(s), po(s, t), ho(s, t), he(s, t.showClass && t.showClass.icon), window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", Pa);
}, ho = (e, t) => {
  for (const [n, s] of Object.entries(es))
    t.icon !== n && ht(e, s);
  he(e, t.icon && es[t.icon]), ud(e, t), Pa(), lt(e, t, "icon");
}, Pa = () => {
  const e = ue();
  if (!e)
    return;
  const t = window.getComputedStyle(e).getPropertyValue("background-color"), n = e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix");
  for (let s = 0; s < n.length; s++)
    n[s].style.backgroundColor = t;
}, ld = (e) => `
  ${e.animation ? '<div class="swal2-success-circular-line-left"></div>' : ""}
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div>
  ${e.animation ? '<div class="swal2-success-fix"></div>' : ""}
  ${e.animation ? '<div class="swal2-success-circular-line-right"></div>' : ""}
`, cd = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`, po = (e, t) => {
  if (!t.icon && !t.iconHtml)
    return;
  let n = e.innerHTML, s = "";
  t.iconHtml ? s = go(t.iconHtml) : t.icon === "success" ? (s = ld(t), n = n.replace(/ style=".*?"/g, "")) : t.icon === "error" ? s = cd : t.icon && (s = go({
    question: "?",
    warning: "!",
    info: "i"
  }[t.icon])), n.trim() !== s.trim() && ut(e, s);
}, ud = (e, t) => {
  if (t.iconColor) {
    e.style.color = t.iconColor, e.style.borderColor = t.iconColor;
    for (const n of [".swal2-success-line-tip", ".swal2-success-line-long", ".swal2-x-mark-line-left", ".swal2-x-mark-line-right"])
      mo(e, n, "background-color", t.iconColor);
    mo(e, ".swal2-success-ring", "border-color", t.iconColor);
  }
}, go = (e) => `<div class="${S["icon-content"]}">${e}</div>`, dd = (e, t) => {
  const n = Oa();
  if (n) {
    if (!t.imageUrl) {
      Ye(n);
      return;
    }
    Ue(n, ""), n.setAttribute("src", t.imageUrl), n.setAttribute("alt", t.imageAlt || ""), zt(n, "width", t.imageWidth), zt(n, "height", t.imageHeight), n.className = S.image, lt(n, t, "image");
  }
};
let Er = !1, Da = 0, Ma = 0, Ra = 0, Fa = 0;
const fd = (e) => {
  e.addEventListener("mousedown", ns), document.body.addEventListener("mousemove", ss), e.addEventListener("mouseup", rs), e.addEventListener("touchstart", ns), document.body.addEventListener("touchmove", ss), e.addEventListener("touchend", rs);
}, md = (e) => {
  e.removeEventListener("mousedown", ns), document.body.removeEventListener("mousemove", ss), e.removeEventListener("mouseup", rs), e.removeEventListener("touchstart", ns), document.body.removeEventListener("touchmove", ss), e.removeEventListener("touchend", rs);
}, ns = (e) => {
  const t = ue();
  if (e.target === t || hn().contains(
    /** @type {HTMLElement} */
    e.target
  )) {
    Er = !0;
    const n = Ba(e);
    Da = n.clientX, Ma = n.clientY, Ra = parseInt(t.style.insetInlineStart) || 0, Fa = parseInt(t.style.insetBlockStart) || 0, he(t, "swal2-dragging");
  }
}, ss = (e) => {
  const t = ue();
  if (Er) {
    let {
      clientX: n,
      clientY: s
    } = Ba(e);
    const r = n - Da;
    t.style.insetInlineStart = `${Ra + (G.isRTL ? -r : r)}px`, t.style.insetBlockStart = `${Fa + (s - Ma)}px`;
  }
}, rs = () => {
  const e = ue();
  Er = !1, ht(e, "swal2-dragging");
}, Ba = (e) => {
  let t = 0, n = 0;
  return e.type.startsWith("mouse") ? (t = /** @type {MouseEvent} */
  e.clientX, n = /** @type {MouseEvent} */
  e.clientY) : e.type.startsWith("touch") && (t = /** @type {TouchEvent} */
  e.touches[0].clientX, n = /** @type {TouchEvent} */
  e.touches[0].clientY), {
    clientX: t,
    clientY: n
  };
}, hd = (e, t) => {
  const n = Je(), s = ue();
  if (!(!n || !s)) {
    if (t.toast) {
      zt(n, "width", t.width), s.style.width = "100%";
      const r = gn();
      r && s.insertBefore(r, hn());
    } else
      zt(s, "width", t.width);
    zt(s, "padding", t.padding), t.color && (s.style.color = t.color), t.background && (s.style.background = t.background), Ye(ps()), pd(s, t), t.draggable && !t.toast ? (he(s, S.draggable), fd(s)) : (ht(s, S.draggable), md(s));
  }
}, pd = (e, t) => {
  const n = t.showClass || {};
  e.className = `${S.popup} ${et(e) ? n.popup : ""}`, t.toast ? (he([document.documentElement, document.body], S["toast-shown"]), he(e, S.toast)) : he(e, S.modal), lt(e, t, "popup"), typeof t.customClass == "string" && he(e, t.customClass), t.icon && he(e, S[`icon-${t.icon}`]);
}, gd = (e, t) => {
  const n = pr();
  if (!n)
    return;
  const {
    progressSteps: s,
    currentProgressStep: r
  } = t;
  if (!s || s.length === 0 || r === void 0) {
    Ye(n);
    return;
  }
  Ue(n), n.textContent = "", r >= s.length && Xe("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), s.forEach((o, a) => {
    const i = wd(o);
    if (n.appendChild(i), a === r && he(i, S["active-progress-step"]), a !== s.length - 1) {
      const l = bd(t);
      n.appendChild(l);
    }
  });
}, wd = (e) => {
  const t = document.createElement("li");
  return he(t, S["progress-step"]), ut(t, e), t;
}, bd = (e) => {
  const t = document.createElement("li");
  return he(t, S["progress-step-line"]), e.progressStepsDistance && zt(t, "width", e.progressStepsDistance), t;
}, yd = (e, t) => {
  const n = Aa();
  n && (yr(n), Ln(n, !!(t.title || t.titleText), "block"), t.title && _r(t.title, n), t.titleText && (n.innerText = t.titleText), lt(n, t, "title"));
}, Ua = (e, t) => {
  hd(e, t), Gu(e, t), gd(e, t), id(e, t), dd(e, t), yd(e, t), Ku(e, t), od(e, t), Wu(e, t), ad(e, t);
  const n = ue();
  typeof t.didRender == "function" && n && t.didRender(n), G.eventEmitter.emit("didRender", n);
}, vd = () => et(ue()), Va = () => {
  var e;
  return (e = At()) === null || e === void 0 ? void 0 : e.click();
}, _d = () => {
  var e;
  return (e = en()) === null || e === void 0 ? void 0 : e.click();
}, xd = () => {
  var e;
  return (e = pn()) === null || e === void 0 ? void 0 : e.click();
}, wn = Object.freeze({
  cancel: "cancel",
  backdrop: "backdrop",
  close: "close",
  esc: "esc",
  timer: "timer"
}), Ha = (e) => {
  e.keydownTarget && e.keydownHandlerAdded && (e.keydownTarget.removeEventListener("keydown", e.keydownHandler, {
    capture: e.keydownListenerCapture
  }), e.keydownHandlerAdded = !1);
}, Ed = (e, t, n) => {
  Ha(e), t.toast || (e.keydownHandler = (s) => Cd(t, s, n), e.keydownTarget = t.keydownListenerCapture ? window : ue(), e.keydownListenerCapture = t.keydownListenerCapture, e.keydownTarget.addEventListener("keydown", e.keydownHandler, {
    capture: e.keydownListenerCapture
  }), e.keydownHandlerAdded = !0);
}, Ks = (e, t) => {
  var n;
  const s = wr();
  if (s.length) {
    e = e + t, e === -2 && (e = s.length - 1), e === s.length ? e = 0 : e === -1 && (e = s.length - 1), s[e].focus();
    return;
  }
  (n = ue()) === null || n === void 0 || n.focus();
}, ja = ["ArrowRight", "ArrowDown"], kd = ["ArrowLeft", "ArrowUp"], Cd = (e, t, n) => {
  e && (t.isComposing || t.keyCode === 229 || (e.stopKeydownPropagation && t.stopPropagation(), t.key === "Enter" ? Td(t, e) : t.key === "Tab" ? Ad(t) : [...ja, ...kd].includes(t.key) ? Od(t.key) : t.key === "Escape" && Sd(t, e, n)));
}, Td = (e, t) => {
  if (!hs(t.allowEnterKey))
    return;
  const n = bs(ue(), t.input);
  if (e.target && n && e.target instanceof HTMLElement && e.target.outerHTML === n.outerHTML) {
    if (["textarea", "file"].includes(t.input))
      return;
    Va(), e.preventDefault();
  }
}, Ad = (e) => {
  const t = e.target, n = wr();
  let s = -1;
  for (let r = 0; r < n.length; r++)
    if (t === n[r]) {
      s = r;
      break;
    }
  e.shiftKey ? Ks(s, -1) : Ks(s, 1), e.stopPropagation(), e.preventDefault();
}, Od = (e) => {
  const t = $n(), n = At(), s = en(), r = pn();
  if (!t || !n || !s || !r)
    return;
  const o = [n, s, r];
  if (document.activeElement instanceof HTMLElement && !o.includes(document.activeElement))
    return;
  const a = ja.includes(e) ? "nextElementSibling" : "previousElementSibling";
  let i = document.activeElement;
  if (i) {
    for (let l = 0; l < t.children.length; l++) {
      if (i = i[a], !i)
        return;
      if (i instanceof HTMLButtonElement && et(i))
        break;
    }
    i instanceof HTMLButtonElement && i.focus();
  }
}, Sd = (e, t, n) => {
  e.preventDefault(), hs(t.allowEscapeKey) && n(wn.esc);
};
var un = {
  swalPromiseResolve: /* @__PURE__ */ new WeakMap(),
  swalPromiseReject: /* @__PURE__ */ new WeakMap()
};
const Nd = () => {
  const e = Je();
  Array.from(document.body.children).forEach((n) => {
    n.contains(e) || (n.hasAttribute("aria-hidden") && n.setAttribute("data-previous-aria-hidden", n.getAttribute("aria-hidden") || ""), n.setAttribute("aria-hidden", "true"));
  });
}, qa = () => {
  Array.from(document.body.children).forEach((t) => {
    t.hasAttribute("data-previous-aria-hidden") ? (t.setAttribute("aria-hidden", t.getAttribute("data-previous-aria-hidden") || ""), t.removeAttribute("data-previous-aria-hidden")) : t.removeAttribute("aria-hidden");
  });
}, Wa = typeof window < "u" && !!window.GestureEvent, $d = () => {
  if (Wa && !Lt(document.body, S.iosfix)) {
    const e = document.body.scrollTop;
    document.body.style.top = `${e * -1}px`, he(document.body, S.iosfix), Ld();
  }
}, Ld = () => {
  const e = Je();
  if (!e)
    return;
  let t;
  e.ontouchstart = (n) => {
    t = Id(n);
  }, e.ontouchmove = (n) => {
    t && (n.preventDefault(), n.stopPropagation());
  };
}, Id = (e) => {
  const t = e.target, n = Je(), s = hr();
  return !n || !s || Pd(e) || Dd(e) ? !1 : t === n || !Ys(n) && t instanceof HTMLElement && !Iu(t, s) && // #2823
  t.tagName !== "INPUT" && // #1603
  t.tagName !== "TEXTAREA" && // #2266
  !(Ys(s) && // #1944
  s.contains(t));
}, Pd = (e) => e.touches && e.touches.length && e.touches[0].touchType === "stylus", Dd = (e) => e.touches && e.touches.length > 1, Md = () => {
  if (Lt(document.body, S.iosfix)) {
    const e = parseInt(document.body.style.top, 10);
    ht(document.body, S.iosfix), document.body.style.top = "", document.body.scrollTop = e * -1;
  }
}, Rd = () => {
  const e = document.createElement("div");
  e.className = S["scrollbar-measure"], document.body.appendChild(e);
  const t = e.getBoundingClientRect().width - e.clientWidth;
  return document.body.removeChild(e), t;
};
let an = null;
const Fd = (e) => {
  an === null && (document.body.scrollHeight > window.innerHeight || e === "scroll") && (an = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = `${an + Rd()}px`);
}, Bd = () => {
  an !== null && (document.body.style.paddingRight = `${an}px`, an = null);
};
function za(e, t, n, s) {
  ws() ? wo(e, s) : (Eu(n).then(() => wo(e, s)), Ha(G)), Wa ? (t.setAttribute("style", "display:none !important"), t.removeAttribute("class"), t.innerHTML = "") : t.remove(), br() && (Bd(), Md(), qa()), Ud();
}
function Ud() {
  ht([document.documentElement, document.body], [S.shown, S["height-auto"], S["no-backdrop"], S["toast-shown"]]);
}
function Ft(e) {
  e = Hd(e);
  const t = un.swalPromiseResolve.get(this), n = Vd(this);
  this.isAwaitingPromise ? e.isDismissed || (Pn(this), t(e)) : n && t(e);
}
const Vd = (e) => {
  const t = ue();
  if (!t)
    return !1;
  const n = _e.innerParams.get(e);
  if (!n || Lt(t, n.hideClass.popup))
    return !1;
  ht(t, n.showClass.popup), he(t, n.hideClass.popup);
  const s = Je();
  return ht(s, n.showClass.backdrop), he(s, n.hideClass.backdrop), jd(e, t, n), !0;
};
function Ya(e) {
  const t = un.swalPromiseReject.get(this);
  Pn(this), t && t(e);
}
const Pn = (e) => {
  e.isAwaitingPromise && (delete e.isAwaitingPromise, _e.innerParams.get(e) || e._destroy());
}, Hd = (e) => typeof e > "u" ? {
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !0
} : Object.assign({
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !1
}, e), jd = (e, t, n) => {
  var s;
  const r = Je(), o = La(t);
  typeof n.willClose == "function" && n.willClose(t), (s = G.eventEmitter) === null || s === void 0 || s.emit("willClose", t), o ? qd(e, t, r, n.returnFocus, n.didClose) : za(e, r, n.returnFocus, n.didClose);
}, qd = (e, t, n, s, r) => {
  G.swalCloseEventFinishedCallback = za.bind(null, e, n, s, r);
  const o = function(a) {
    if (a.target === t) {
      var i;
      (i = G.swalCloseEventFinishedCallback) === null || i === void 0 || i.call(G), delete G.swalCloseEventFinishedCallback, t.removeEventListener("animationend", o), t.removeEventListener("transitionend", o);
    }
  };
  t.addEventListener("animationend", o), t.addEventListener("transitionend", o);
}, wo = (e, t) => {
  setTimeout(() => {
    var n;
    typeof t == "function" && t.bind(e.params)(), (n = G.eventEmitter) === null || n === void 0 || n.emit("didClose"), e._destroy && e._destroy();
  });
}, dn = (e) => {
  let t = ue();
  if (t || new we(), t = ue(), !t)
    return;
  const n = gn();
  ws() ? Ye(hn()) : Wd(t, e), Ue(n), t.setAttribute("data-loading", "true"), t.setAttribute("aria-busy", "true"), t.focus();
}, Wd = (e, t) => {
  const n = $n(), s = gn();
  !n || !s || (!t && et(At()) && (t = At()), Ue(n), t && (Ye(t), s.setAttribute("data-button-to-replace", t.className), n.insertBefore(s, t)), he([e, n], S.loading));
}, zd = (e, t) => {
  t.input === "select" || t.input === "radio" ? Jd(e, t) : ["text", "email", "number", "tel", "textarea"].some((n) => n === t.input) && (fr(t.inputValue) || mr(t.inputValue)) && (dn(At()), Zd(e, t));
}, Yd = (e, t) => {
  const n = e.getInput();
  if (!n)
    return null;
  switch (t.input) {
    case "checkbox":
      return Kd(n);
    case "radio":
      return Gd(n);
    case "file":
      return Xd(n);
    default:
      return t.inputAutoTrim ? n.value.trim() : n.value;
  }
}, Kd = (e) => e.checked ? 1 : 0, Gd = (e) => e.checked ? e.value : null, Xd = (e) => e.files && e.files.length ? e.getAttribute("multiple") !== null ? e.files : e.files[0] : null, Jd = (e, t) => {
  const n = ue();
  if (!n)
    return;
  const s = (r) => {
    t.input === "select" ? Qd(n, os(r), t) : t.input === "radio" && ef(n, os(r), t);
  };
  fr(t.inputOptions) || mr(t.inputOptions) ? (dn(At()), Sn(t.inputOptions).then((r) => {
    e.hideLoading(), s(r);
  })) : typeof t.inputOptions == "object" ? s(t.inputOptions) : Qt(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof t.inputOptions}`);
}, Zd = (e, t) => {
  const n = e.getInput();
  n && (Ye(n), Sn(t.inputValue).then((s) => {
    n.value = t.input === "number" ? `${parseFloat(s) || 0}` : `${s}`, Ue(n), n.focus(), e.hideLoading();
  }).catch((s) => {
    Qt(`Error in inputValue promise: ${s}`), n.value = "", Ue(n), n.focus(), e.hideLoading();
  }));
};
function Qd(e, t, n) {
  const s = Rt(e, S.select);
  if (!s)
    return;
  const r = (o, a, i) => {
    const l = document.createElement("option");
    l.value = i, ut(l, a), l.selected = Ka(i, n.inputValue), o.appendChild(l);
  };
  t.forEach((o) => {
    const a = o[0], i = o[1];
    if (Array.isArray(i)) {
      const l = document.createElement("optgroup");
      l.label = a, l.disabled = !1, s.appendChild(l), i.forEach((c) => r(l, c[1], c[0]));
    } else
      r(s, i, a);
  }), s.focus();
}
function ef(e, t, n) {
  const s = Rt(e, S.radio);
  if (!s)
    return;
  t.forEach((o) => {
    const a = o[0], i = o[1], l = document.createElement("input"), c = document.createElement("label");
    l.type = "radio", l.name = S.radio, l.value = a, Ka(a, n.inputValue) && (l.checked = !0);
    const h = document.createElement("span");
    ut(h, i), h.className = S.label, c.appendChild(l), c.appendChild(h), s.appendChild(c);
  });
  const r = s.querySelectorAll("input");
  r.length && r[0].focus();
}
const os = (e) => {
  const t = [];
  return e instanceof Map ? e.forEach((n, s) => {
    let r = n;
    typeof r == "object" && (r = os(r)), t.push([s, r]);
  }) : Object.keys(e).forEach((n) => {
    let s = e[n];
    typeof s == "object" && (s = os(s)), t.push([n, s]);
  }), t;
}, Ka = (e, t) => !!t && t.toString() === e.toString(), tf = (e) => {
  const t = _e.innerParams.get(e);
  e.disableButtons(), t.input ? Ga(e, "confirm") : Cr(e, !0);
}, nf = (e) => {
  const t = _e.innerParams.get(e);
  e.disableButtons(), t.returnInputValueOnDeny ? Ga(e, "deny") : kr(e, !1);
}, sf = (e, t) => {
  e.disableButtons(), t(wn.cancel);
}, Ga = (e, t) => {
  const n = _e.innerParams.get(e);
  if (!n.input) {
    Qt(`The "input" parameter is needed to be set when using returnInputValueOn${dr(t)}`);
    return;
  }
  const s = e.getInput(), r = Yd(e, n);
  n.inputValidator ? rf(e, r, t) : s && !s.checkValidity() ? (e.enableButtons(), e.showValidationMessage(n.validationMessage || s.validationMessage)) : t === "deny" ? kr(e, r) : Cr(e, r);
}, rf = (e, t, n) => {
  const s = _e.innerParams.get(e);
  e.disableInput(), Promise.resolve().then(() => Sn(s.inputValidator(t, s.validationMessage))).then((o) => {
    e.enableButtons(), e.enableInput(), o ? e.showValidationMessage(o) : n === "deny" ? kr(e, t) : Cr(e, t);
  });
}, kr = (e, t) => {
  const n = _e.innerParams.get(e || void 0);
  n.showLoaderOnDeny && dn(en()), n.preDeny ? (e.isAwaitingPromise = !0, Promise.resolve().then(() => Sn(n.preDeny(t, n.validationMessage))).then((r) => {
    r === !1 ? (e.hideLoading(), Pn(e)) : e.close(
      /** @type SweetAlertResult */
      {
        isDenied: !0,
        value: typeof r > "u" ? t : r
      }
    );
  }).catch((r) => Xa(e || void 0, r))) : e.close(
    /** @type SweetAlertResult */
    {
      isDenied: !0,
      value: t
    }
  );
}, bo = (e, t) => {
  e.close(
    /** @type SweetAlertResult */
    {
      isConfirmed: !0,
      value: t
    }
  );
}, Xa = (e, t) => {
  e.rejectPromise(t);
}, Cr = (e, t) => {
  const n = _e.innerParams.get(e || void 0);
  n.showLoaderOnConfirm && dn(), n.preConfirm ? (e.resetValidationMessage(), e.isAwaitingPromise = !0, Promise.resolve().then(() => Sn(n.preConfirm(t, n.validationMessage))).then((r) => {
    et(ps()) || r === !1 ? (e.hideLoading(), Pn(e)) : bo(e, typeof r > "u" ? t : r);
  }).catch((r) => Xa(e || void 0, r))) : bo(e, t);
};
function as() {
  const e = _e.innerParams.get(this);
  if (!e)
    return;
  const t = _e.domCache.get(this);
  Ye(t.loader), ws() ? e.icon && Ue(hn()) : of(t), ht([t.popup, t.actions], S.loading), t.popup.removeAttribute("aria-busy"), t.popup.removeAttribute("data-loading"), t.confirmButton.disabled = !1, t.denyButton.disabled = !1, t.cancelButton.disabled = !1;
}
const of = (e) => {
  const t = e.popup.getElementsByClassName(e.loader.getAttribute("data-button-to-replace"));
  t.length ? Ue(t[0], "inline-block") : Lu() && Ye(e.actions);
};
function Ja() {
  const e = _e.innerParams.get(this), t = _e.domCache.get(this);
  return t ? bs(t.popup, e.input) : null;
}
function Za(e, t, n) {
  const s = _e.domCache.get(e);
  t.forEach((r) => {
    s[r].disabled = n;
  });
}
function Qa(e, t) {
  const n = ue();
  if (!(!n || !e))
    if (e.type === "radio") {
      const s = n.querySelectorAll(`[name="${S.radio}"]`);
      for (let r = 0; r < s.length; r++)
        s[r].disabled = t;
    } else
      e.disabled = t;
}
function ei() {
  Za(this, ["confirmButton", "denyButton", "cancelButton"], !1);
}
function ti() {
  Za(this, ["confirmButton", "denyButton", "cancelButton"], !0);
}
function ni() {
  Qa(this.getInput(), !1);
}
function si() {
  Qa(this.getInput(), !0);
}
function ri(e) {
  const t = _e.domCache.get(this), n = _e.innerParams.get(this);
  ut(t.validationMessage, e), t.validationMessage.className = S["validation-message"], n.customClass && n.customClass.validationMessage && he(t.validationMessage, n.customClass.validationMessage), Ue(t.validationMessage);
  const s = this.getInput();
  s && (s.setAttribute("aria-invalid", "true"), s.setAttribute("aria-describedby", S["validation-message"]), Na(s), he(s, S.inputerror));
}
function oi() {
  const e = _e.domCache.get(this);
  e.validationMessage && Ye(e.validationMessage);
  const t = this.getInput();
  t && (t.removeAttribute("aria-invalid"), t.removeAttribute("aria-describedby"), ht(t, S.inputerror));
}
const ln = {
  title: "",
  titleText: "",
  text: "",
  html: "",
  footer: "",
  icon: void 0,
  iconColor: void 0,
  iconHtml: void 0,
  template: void 0,
  toast: !1,
  draggable: !1,
  animation: !0,
  theme: "light",
  showClass: {
    popup: "swal2-show",
    backdrop: "swal2-backdrop-show",
    icon: "swal2-icon-show"
  },
  hideClass: {
    popup: "swal2-hide",
    backdrop: "swal2-backdrop-hide",
    icon: "swal2-icon-hide"
  },
  customClass: {},
  target: "body",
  color: void 0,
  backdrop: !0,
  heightAuto: !0,
  allowOutsideClick: !0,
  allowEscapeKey: !0,
  allowEnterKey: !0,
  stopKeydownPropagation: !0,
  keydownListenerCapture: !1,
  showConfirmButton: !0,
  showDenyButton: !1,
  showCancelButton: !1,
  preConfirm: void 0,
  preDeny: void 0,
  confirmButtonText: "OK",
  confirmButtonAriaLabel: "",
  confirmButtonColor: void 0,
  denyButtonText: "No",
  denyButtonAriaLabel: "",
  denyButtonColor: void 0,
  cancelButtonText: "Cancel",
  cancelButtonAriaLabel: "",
  cancelButtonColor: void 0,
  buttonsStyling: !0,
  reverseButtons: !1,
  focusConfirm: !0,
  focusDeny: !1,
  focusCancel: !1,
  returnFocus: !0,
  showCloseButton: !1,
  closeButtonHtml: "&times;",
  closeButtonAriaLabel: "Close this dialog",
  loaderHtml: "",
  showLoaderOnConfirm: !1,
  showLoaderOnDeny: !1,
  imageUrl: void 0,
  imageWidth: void 0,
  imageHeight: void 0,
  imageAlt: "",
  timer: void 0,
  timerProgressBar: !1,
  width: void 0,
  padding: void 0,
  background: void 0,
  input: void 0,
  inputPlaceholder: "",
  inputLabel: "",
  inputValue: "",
  inputOptions: {},
  inputAutoFocus: !0,
  inputAutoTrim: !0,
  inputAttributes: {},
  inputValidator: void 0,
  returnInputValueOnDeny: !1,
  validationMessage: void 0,
  grow: !1,
  position: "center",
  progressSteps: [],
  currentProgressStep: void 0,
  progressStepsDistance: void 0,
  willOpen: void 0,
  didOpen: void 0,
  didRender: void 0,
  willClose: void 0,
  didClose: void 0,
  didDestroy: void 0,
  scrollbarPadding: !0,
  topLayer: !1
}, af = ["allowEscapeKey", "allowOutsideClick", "background", "buttonsStyling", "cancelButtonAriaLabel", "cancelButtonColor", "cancelButtonText", "closeButtonAriaLabel", "closeButtonHtml", "color", "confirmButtonAriaLabel", "confirmButtonColor", "confirmButtonText", "currentProgressStep", "customClass", "denyButtonAriaLabel", "denyButtonColor", "denyButtonText", "didClose", "didDestroy", "draggable", "footer", "hideClass", "html", "icon", "iconColor", "iconHtml", "imageAlt", "imageHeight", "imageUrl", "imageWidth", "preConfirm", "preDeny", "progressSteps", "returnFocus", "reverseButtons", "showCancelButton", "showCloseButton", "showConfirmButton", "showDenyButton", "text", "title", "titleText", "theme", "willClose"], lf = {
  allowEnterKey: void 0
}, cf = ["allowOutsideClick", "allowEnterKey", "backdrop", "draggable", "focusConfirm", "focusDeny", "focusCancel", "returnFocus", "heightAuto", "keydownListenerCapture"], ai = (e) => Object.prototype.hasOwnProperty.call(ln, e), ii = (e) => af.indexOf(e) !== -1, li = (e) => lf[e], uf = (e) => {
  ai(e) || Xe(`Unknown parameter "${e}"`);
}, df = (e) => {
  cf.includes(e) && Xe(`The parameter "${e}" is incompatible with toasts`);
}, ff = (e) => {
  const t = li(e);
  t && Ta(e, t);
}, ci = (e) => {
  e.backdrop === !1 && e.allowOutsideClick && Xe('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'), e.theme && !["light", "dark", "auto", "minimal", "borderless", "bootstrap-4", "bootstrap-4-light", "bootstrap-4-dark", "bootstrap-5", "bootstrap-5-light", "bootstrap-5-dark", "material-ui", "material-ui-light", "material-ui-dark", "embed-iframe", "bulma", "bulma-light", "bulma-dark"].includes(e.theme) && Xe(`Invalid theme "${e.theme}"`);
  for (const t in e)
    uf(t), e.toast && df(t), ff(t);
};
function ui(e) {
  const t = Je(), n = ue(), s = _e.innerParams.get(this);
  if (!n || Lt(n, s.hideClass.popup)) {
    Xe("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
    return;
  }
  const r = mf(e), o = Object.assign({}, s, r);
  ci(o), t.dataset.swal2Theme = o.theme, Ua(this, o), _e.innerParams.set(this, o), Object.defineProperties(this, {
    params: {
      value: Object.assign({}, this.params, e),
      writable: !1,
      enumerable: !0
    }
  });
}
const mf = (e) => {
  const t = {};
  return Object.keys(e).forEach((n) => {
    ii(n) ? t[n] = e[n] : Xe(`Invalid parameter to update: ${n}`);
  }), t;
};
function di() {
  const e = _e.domCache.get(this), t = _e.innerParams.get(this);
  if (!t) {
    fi(this);
    return;
  }
  e.popup && G.swalCloseEventFinishedCallback && (G.swalCloseEventFinishedCallback(), delete G.swalCloseEventFinishedCallback), typeof t.didDestroy == "function" && t.didDestroy(), G.eventEmitter.emit("didDestroy"), hf(this);
}
const hf = (e) => {
  fi(e), delete e.params, delete G.keydownHandler, delete G.keydownTarget, delete G.currentInstance;
}, fi = (e) => {
  e.isAwaitingPromise ? ($s(_e, e), e.isAwaitingPromise = !0) : ($s(un, e), $s(_e, e), delete e.isAwaitingPromise, delete e.disableButtons, delete e.enableButtons, delete e.getInput, delete e.disableInput, delete e.enableInput, delete e.hideLoading, delete e.disableLoading, delete e.showValidationMessage, delete e.resetValidationMessage, delete e.close, delete e.closePopup, delete e.closeModal, delete e.closeToast, delete e.rejectPromise, delete e.update, delete e._destroy);
}, $s = (e, t) => {
  for (const n in e)
    e[n].delete(t);
};
var pf = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  _destroy: di,
  close: Ft,
  closeModal: Ft,
  closePopup: Ft,
  closeToast: Ft,
  disableButtons: ti,
  disableInput: si,
  disableLoading: as,
  enableButtons: ei,
  enableInput: ni,
  getInput: Ja,
  handleAwaitingPromise: Pn,
  hideLoading: as,
  rejectPromise: Ya,
  resetValidationMessage: oi,
  showValidationMessage: ri,
  update: ui
});
const gf = (e, t, n) => {
  e.toast ? wf(e, t, n) : (yf(t), vf(t), _f(e, t, n));
}, wf = (e, t, n) => {
  t.popup.onclick = () => {
    e && (bf(e) || e.timer || e.input) || n(wn.close);
  };
}, bf = (e) => !!(e.showConfirmButton || e.showDenyButton || e.showCancelButton || e.showCloseButton);
let is = !1;
const yf = (e) => {
  e.popup.onmousedown = () => {
    e.container.onmouseup = function(t) {
      e.container.onmouseup = () => {
      }, t.target === e.container && (is = !0);
    };
  };
}, vf = (e) => {
  e.container.onmousedown = (t) => {
    t.target === e.container && t.preventDefault(), e.popup.onmouseup = function(n) {
      e.popup.onmouseup = () => {
      }, (n.target === e.popup || n.target instanceof HTMLElement && e.popup.contains(n.target)) && (is = !0);
    };
  };
}, _f = (e, t, n) => {
  t.container.onclick = (s) => {
    if (is) {
      is = !1;
      return;
    }
    s.target === t.container && hs(e.allowOutsideClick) && n(wn.backdrop);
  };
}, xf = (e) => typeof e == "object" && e.jquery, yo = (e) => e instanceof Element || xf(e), Ef = (e) => {
  const t = {};
  return typeof e[0] == "object" && !yo(e[0]) ? Object.assign(t, e[0]) : ["title", "html", "icon"].forEach((n, s) => {
    const r = e[s];
    typeof r == "string" || yo(r) ? t[n] = r : r !== void 0 && Qt(`Unexpected type of ${n}! Expected "string" or "Element", got ${typeof r}`);
  }), t;
};
function kf(...e) {
  return new this(...e);
}
function Cf(e) {
  class t extends this {
    _main(s, r) {
      return super._main(s, Object.assign({}, e, r));
    }
  }
  return t;
}
const Tf = () => G.timeout && G.timeout.getTimerLeft(), mi = () => {
  if (G.timeout)
    return Pu(), G.timeout.stop();
}, hi = () => {
  if (G.timeout) {
    const e = G.timeout.start();
    return vr(e), e;
  }
}, Af = () => {
  const e = G.timeout;
  return e && (e.running ? mi() : hi());
}, Of = (e) => {
  if (G.timeout) {
    const t = G.timeout.increase(e);
    return vr(t, !0), t;
  }
}, Sf = () => !!(G.timeout && G.timeout.isRunning());
let vo = !1;
const Gs = {};
function Nf(e = "data-swal-template") {
  Gs[e] = this, vo || (document.body.addEventListener("click", $f), vo = !0);
}
const $f = (e) => {
  for (let t = e.target; t && t !== document; t = t.parentNode)
    for (const n in Gs) {
      const s = t.getAttribute(n);
      if (s) {
        Gs[n].fire({
          template: s
        });
        return;
      }
    }
};
class Lf {
  constructor() {
    this.events = {};
  }
  /**
   * @param {string} eventName
   * @returns {EventHandlers}
   */
  _getHandlersByEventName(t) {
    return typeof this.events[t] > "u" && (this.events[t] = []), this.events[t];
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  on(t, n) {
    const s = this._getHandlersByEventName(t);
    s.includes(n) || s.push(n);
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  once(t, n) {
    const s = (...r) => {
      this.removeListener(t, s), n.apply(this, r);
    };
    this.on(t, s);
  }
  /**
   * @param {string} eventName
   * @param {Array} args
   */
  emit(t, ...n) {
    this._getHandlersByEventName(t).forEach(
      /**
       * @param {EventHandler} eventHandler
       */
      (s) => {
        try {
          s.apply(this, n);
        } catch (r) {
          console.error(r);
        }
      }
    );
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  removeListener(t, n) {
    const s = this._getHandlersByEventName(t), r = s.indexOf(n);
    r > -1 && s.splice(r, 1);
  }
  /**
   * @param {string} eventName
   */
  removeAllListeners(t) {
    this.events[t] !== void 0 && (this.events[t].length = 0);
  }
  reset() {
    this.events = {};
  }
}
G.eventEmitter = new Lf();
const If = (e, t) => {
  G.eventEmitter.on(e, t);
}, Pf = (e, t) => {
  G.eventEmitter.once(e, t);
}, Df = (e, t) => {
  if (!e) {
    G.eventEmitter.reset();
    return;
  }
  t ? G.eventEmitter.removeListener(e, t) : G.eventEmitter.removeAllListeners(e);
};
var Mf = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  argsToParams: Ef,
  bindClickHandler: Nf,
  clickCancel: xd,
  clickConfirm: Va,
  clickDeny: _d,
  enableLoading: dn,
  fire: kf,
  getActions: $n,
  getCancelButton: pn,
  getCloseButton: gr,
  getConfirmButton: At,
  getContainer: Je,
  getDenyButton: en,
  getFocusableElements: wr,
  getFooter: Sa,
  getHtmlContainer: hr,
  getIcon: hn,
  getIconContent: Au,
  getImage: Oa,
  getInputLabel: Ou,
  getLoader: gn,
  getPopup: ue,
  getProgressSteps: pr,
  getTimerLeft: Tf,
  getTimerProgressBar: gs,
  getTitle: Aa,
  getValidationMessage: ps,
  increaseTimer: Of,
  isDeprecatedParameter: li,
  isLoading: Nu,
  isTimerRunning: Sf,
  isUpdatableParameter: ii,
  isValidParameter: ai,
  isVisible: vd,
  mixin: Cf,
  off: Df,
  on: If,
  once: Pf,
  resumeTimer: hi,
  showLoading: dn,
  stopTimer: mi,
  toggleTimer: Af
});
class Rf {
  /**
   * @param {() => void} callback
   * @param {number} delay
   */
  constructor(t, n) {
    this.callback = t, this.remaining = n, this.running = !1, this.start();
  }
  /**
   * @returns {number}
   */
  start() {
    return this.running || (this.running = !0, this.started = /* @__PURE__ */ new Date(), this.id = setTimeout(this.callback, this.remaining)), this.remaining;
  }
  /**
   * @returns {number}
   */
  stop() {
    return this.started && this.running && (this.running = !1, clearTimeout(this.id), this.remaining -= (/* @__PURE__ */ new Date()).getTime() - this.started.getTime()), this.remaining;
  }
  /**
   * @param {number} n
   * @returns {number}
   */
  increase(t) {
    const n = this.running;
    return n && this.stop(), this.remaining += t, n && this.start(), this.remaining;
  }
  /**
   * @returns {number}
   */
  getTimerLeft() {
    return this.running && (this.stop(), this.start()), this.remaining;
  }
  /**
   * @returns {boolean}
   */
  isRunning() {
    return this.running;
  }
}
const pi = ["swal-title", "swal-html", "swal-footer"], Ff = (e) => {
  const t = typeof e.template == "string" ? (
    /** @type {HTMLTemplateElement} */
    document.querySelector(e.template)
  ) : e.template;
  if (!t)
    return {};
  const n = t.content;
  return zf(n), Object.assign(Bf(n), Uf(n), Vf(n), Hf(n), jf(n), qf(n), Wf(n, pi));
}, Bf = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-param")).forEach((s) => {
    Xt(s, ["name", "value"]);
    const r = (
      /** @type {keyof SweetAlertOptions} */
      s.getAttribute("name")
    ), o = s.getAttribute("value");
    !r || !o || (typeof ln[r] == "boolean" ? t[r] = o !== "false" : typeof ln[r] == "object" ? t[r] = JSON.parse(o) : t[r] = o);
  }), t;
}, Uf = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-function-param")).forEach((s) => {
    const r = (
      /** @type {keyof SweetAlertOptions} */
      s.getAttribute("name")
    ), o = s.getAttribute("value");
    !r || !o || (t[r] = new Function(`return ${o}`)());
  }), t;
}, Vf = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-button")).forEach((s) => {
    Xt(s, ["type", "color", "aria-label"]);
    const r = s.getAttribute("type");
    !r || !["confirm", "cancel", "deny"].includes(r) || (t[`${r}ButtonText`] = s.innerHTML, t[`show${dr(r)}Button`] = !0, s.hasAttribute("color") && (t[`${r}ButtonColor`] = s.getAttribute("color")), s.hasAttribute("aria-label") && (t[`${r}ButtonAriaLabel`] = s.getAttribute("aria-label")));
  }), t;
}, Hf = (e) => {
  const t = {}, n = e.querySelector("swal-image");
  return n && (Xt(n, ["src", "width", "height", "alt"]), n.hasAttribute("src") && (t.imageUrl = n.getAttribute("src") || void 0), n.hasAttribute("width") && (t.imageWidth = n.getAttribute("width") || void 0), n.hasAttribute("height") && (t.imageHeight = n.getAttribute("height") || void 0), n.hasAttribute("alt") && (t.imageAlt = n.getAttribute("alt") || void 0)), t;
}, jf = (e) => {
  const t = {}, n = e.querySelector("swal-icon");
  return n && (Xt(n, ["type", "color"]), n.hasAttribute("type") && (t.icon = n.getAttribute("type")), n.hasAttribute("color") && (t.iconColor = n.getAttribute("color")), t.iconHtml = n.innerHTML), t;
}, qf = (e) => {
  const t = {}, n = e.querySelector("swal-input");
  n && (Xt(n, ["type", "label", "placeholder", "value"]), t.input = n.getAttribute("type") || "text", n.hasAttribute("label") && (t.inputLabel = n.getAttribute("label")), n.hasAttribute("placeholder") && (t.inputPlaceholder = n.getAttribute("placeholder")), n.hasAttribute("value") && (t.inputValue = n.getAttribute("value")));
  const s = Array.from(e.querySelectorAll("swal-input-option"));
  return s.length && (t.inputOptions = {}, s.forEach((r) => {
    Xt(r, ["value"]);
    const o = r.getAttribute("value");
    if (!o)
      return;
    const a = r.innerHTML;
    t.inputOptions[o] = a;
  })), t;
}, Wf = (e, t) => {
  const n = {};
  for (const s in t) {
    const r = t[s], o = e.querySelector(r);
    o && (Xt(o, []), n[r.replace(/^swal-/, "")] = o.innerHTML.trim());
  }
  return n;
}, zf = (e) => {
  const t = pi.concat(["swal-param", "swal-function-param", "swal-button", "swal-image", "swal-icon", "swal-input", "swal-input-option"]);
  Array.from(e.children).forEach((n) => {
    const s = n.tagName.toLowerCase();
    t.includes(s) || Xe(`Unrecognized element <${s}>`);
  });
}, Xt = (e, t) => {
  Array.from(e.attributes).forEach((n) => {
    t.indexOf(n.name) === -1 && Xe([`Unrecognized attribute "${n.name}" on <${e.tagName.toLowerCase()}>.`, `${t.length ? `Allowed attributes are: ${t.join(", ")}` : "To set the value, use HTML within the element."}`]);
  });
}, gi = 10, Yf = (e) => {
  const t = Je(), n = ue();
  typeof e.willOpen == "function" && e.willOpen(n), G.eventEmitter.emit("willOpen", n);
  const r = window.getComputedStyle(document.body).overflowY;
  Xf(t, n, e), setTimeout(() => {
    Kf(t, n);
  }, gi), br() && (Gf(t, e.scrollbarPadding, r), Nd()), !ws() && !G.previousActiveElement && (G.previousActiveElement = document.activeElement), typeof e.didOpen == "function" && setTimeout(() => e.didOpen(n)), G.eventEmitter.emit("didOpen", n);
}, ls = (e) => {
  const t = ue();
  if (e.target !== t)
    return;
  const n = Je();
  t.removeEventListener("animationend", ls), t.removeEventListener("transitionend", ls), n.style.overflowY = "auto", ht(n, S["no-transition"]);
}, Kf = (e, t) => {
  La(t) ? (e.style.overflowY = "hidden", t.addEventListener("animationend", ls), t.addEventListener("transitionend", ls)) : e.style.overflowY = "auto";
}, Gf = (e, t, n) => {
  $d(), t && n !== "hidden" && Fd(n), setTimeout(() => {
    e.scrollTop = 0;
  });
}, Xf = (e, t, n) => {
  he(e, n.showClass.backdrop), n.animation ? (t.style.setProperty("opacity", "0", "important"), Ue(t, "grid"), setTimeout(() => {
    he(t, n.showClass.popup), t.style.removeProperty("opacity");
  }, gi)) : Ue(t, "grid"), he([document.documentElement, document.body], S.shown), n.heightAuto && n.backdrop && !n.toast && he([document.documentElement, document.body], S["height-auto"]);
};
var _o = {
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  email: (e, t) => /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid email address"),
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  url: (e, t) => /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid URL")
};
function Jf(e) {
  e.inputValidator || (e.input === "email" && (e.inputValidator = _o.email), e.input === "url" && (e.inputValidator = _o.url));
}
function Zf(e) {
  (!e.target || typeof e.target == "string" && !document.querySelector(e.target) || typeof e.target != "string" && !e.target.appendChild) && (Xe('Target parameter is not valid, defaulting to "body"'), e.target = "body");
}
function Qf(e) {
  Jf(e), e.showLoaderOnConfirm && !e.preConfirm && Xe(`showLoaderOnConfirm is set to true, but preConfirm is not defined.
showLoaderOnConfirm should be used together with preConfirm, see usage example:
https://sweetalert2.github.io/#ajax-request`), Zf(e), typeof e.title == "string" && (e.title = e.title.split(`
`).join("<br />")), Hu(e);
}
let Et;
var qn = /* @__PURE__ */ new WeakMap();
class Pe {
  /**
   * @param {...(SweetAlertOptions | string)} args
   * @this {SweetAlert}
   */
  constructor(...t) {
    if (yu(this, qn, void 0), typeof window > "u")
      return;
    Et = this;
    const n = Object.freeze(this.constructor.argsToParams(t));
    this.params = n, this.isAwaitingPromise = !1, vu(qn, this, this._main(Et.params));
  }
  _main(t, n = {}) {
    if (ci(Object.assign({}, n, t)), G.currentInstance) {
      const o = un.swalPromiseResolve.get(G.currentInstance), {
        isAwaitingPromise: a
      } = G.currentInstance;
      G.currentInstance._destroy(), a || o({
        isDismissed: !0
      }), br() && qa();
    }
    G.currentInstance = Et;
    const s = tm(t, n);
    Qf(s), Object.freeze(s), G.timeout && (G.timeout.stop(), delete G.timeout), clearTimeout(G.restoreFocusTimeout);
    const r = nm(Et);
    return Ua(Et, s), _e.innerParams.set(Et, s), em(Et, r, s);
  }
  // `catch` cannot be the name of a module export, so we define our thenable methods here instead
  then(t) {
    return uo(qn, this).then(t);
  }
  finally(t) {
    return uo(qn, this).finally(t);
  }
}
const em = (e, t, n) => new Promise((s, r) => {
  const o = (a) => {
    e.close({
      isDismissed: !0,
      dismiss: a,
      isConfirmed: !1,
      isDenied: !1
    });
  };
  un.swalPromiseResolve.set(e, s), un.swalPromiseReject.set(e, r), t.confirmButton.onclick = () => {
    tf(e);
  }, t.denyButton.onclick = () => {
    nf(e);
  }, t.cancelButton.onclick = () => {
    sf(e, o);
  }, t.closeButton.onclick = () => {
    o(wn.close);
  }, gf(n, t, o), Ed(G, n, o), zd(e, n), Yf(n), sm(G, n, o), rm(t, n), setTimeout(() => {
    t.container.scrollTop = 0;
  });
}), tm = (e, t) => {
  const n = Ff(e), s = Object.assign({}, ln, t, n, e);
  return s.showClass = Object.assign({}, ln.showClass, s.showClass), s.hideClass = Object.assign({}, ln.hideClass, s.hideClass), s.animation === !1 && (s.showClass = {
    backdrop: "swal2-noanimation"
  }, s.hideClass = {}), s;
}, nm = (e) => {
  const t = {
    popup: ue(),
    container: Je(),
    actions: $n(),
    confirmButton: At(),
    denyButton: en(),
    cancelButton: pn(),
    loader: gn(),
    closeButton: gr(),
    validationMessage: ps(),
    progressSteps: pr()
  };
  return _e.domCache.set(e, t), t;
}, sm = (e, t, n) => {
  const s = gs();
  Ye(s), t.timer && (e.timeout = new Rf(() => {
    n("timer"), delete e.timeout;
  }, t.timer), t.timerProgressBar && (Ue(s), lt(s, t, "timerProgressBar"), setTimeout(() => {
    e.timeout && e.timeout.running && vr(t.timer);
  })));
}, rm = (e, t) => {
  if (!t.toast) {
    if (!hs(t.allowEnterKey)) {
      Ta("allowEnterKey"), im();
      return;
    }
    om(e) || am(e, t) || Ks(-1, 1);
  }
}, om = (e) => {
  const t = Array.from(e.popup.querySelectorAll("[autofocus]"));
  for (const n of t)
    if (n instanceof HTMLElement && et(n))
      return n.focus(), !0;
  return !1;
}, am = (e, t) => t.focusDeny && et(e.denyButton) ? (e.denyButton.focus(), !0) : t.focusCancel && et(e.cancelButton) ? (e.cancelButton.focus(), !0) : t.focusConfirm && et(e.confirmButton) ? (e.confirmButton.focus(), !0) : !1, im = () => {
  document.activeElement instanceof HTMLElement && typeof document.activeElement.blur == "function" && document.activeElement.blur();
};
Pe.prototype.disableButtons = ti;
Pe.prototype.enableButtons = ei;
Pe.prototype.getInput = Ja;
Pe.prototype.disableInput = si;
Pe.prototype.enableInput = ni;
Pe.prototype.hideLoading = as;
Pe.prototype.disableLoading = as;
Pe.prototype.showValidationMessage = ri;
Pe.prototype.resetValidationMessage = oi;
Pe.prototype.close = Ft;
Pe.prototype.closePopup = Ft;
Pe.prototype.closeModal = Ft;
Pe.prototype.closeToast = Ft;
Pe.prototype.rejectPromise = Ya;
Pe.prototype.update = ui;
Pe.prototype._destroy = di;
Object.assign(Pe, Mf);
Object.keys(pf).forEach((e) => {
  Pe[e] = function(...t) {
    return Et && Et[e] ? Et[e](...t) : null;
  };
});
Pe.DismissReason = wn;
Pe.version = "11.26.10";
const we = Pe;
we.default = we;
typeof document < "u" && function(e, t) {
  var n = e.createElement("style");
  if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
  else try {
    n.innerHTML = t;
  } catch {
    n.innerText = t;
  }
}(document, ':root{--swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-container-padding: 0.625em;--swal2-backdrop: rgba(0, 0, 0, 0.4);--swal2-backdrop-transition: background-color 0.15s;--swal2-width: 32em;--swal2-padding: 0 0 1.25em;--swal2-border: none;--swal2-border-radius: 0.3125rem;--swal2-background: white;--swal2-color: #545454;--swal2-show-animation: swal2-show 0.3s;--swal2-hide-animation: swal2-hide 0.15s forwards;--swal2-icon-zoom: 1;--swal2-icon-animations: true;--swal2-title-padding: 0.8em 1em 0;--swal2-html-container-padding: 1em 1.6em 0.3em;--swal2-input-border: 1px solid #d9d9d9;--swal2-input-border-radius: 0.1875em;--swal2-input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-background: transparent;--swal2-input-transition: border-color 0.2s, box-shadow 0.2s;--swal2-input-hover-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-focus-border: 1px solid #b4dbed;--swal2-input-focus-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-progress-step-background: #add8e6;--swal2-validation-message-background: #f0f0f0;--swal2-validation-message-color: #666;--swal2-footer-border-color: #eee;--swal2-footer-background: transparent;--swal2-footer-color: inherit;--swal2-timer-progress-bar-background: rgba(0, 0, 0, 0.3);--swal2-close-button-position: initial;--swal2-close-button-inset: auto;--swal2-close-button-font-size: 2.5em;--swal2-close-button-color: #ccc;--swal2-close-button-transition: color 0.2s, box-shadow 0.2s;--swal2-close-button-outline: initial;--swal2-close-button-box-shadow: inset 0 0 0 3px transparent;--swal2-close-button-focus-box-shadow: inset var(--swal2-outline);--swal2-close-button-hover-transform: none;--swal2-actions-justify-content: center;--swal2-actions-width: auto;--swal2-actions-margin: 1.25em auto 0;--swal2-actions-padding: 0;--swal2-actions-border-radius: 0;--swal2-actions-background: transparent;--swal2-action-button-transition: background-color 0.2s, box-shadow 0.2s;--swal2-action-button-hover: black 10%;--swal2-action-button-active: black 10%;--swal2-confirm-button-box-shadow: none;--swal2-confirm-button-border-radius: 0.25em;--swal2-confirm-button-background-color: #7066e0;--swal2-confirm-button-color: #fff;--swal2-deny-button-box-shadow: none;--swal2-deny-button-border-radius: 0.25em;--swal2-deny-button-background-color: #dc3741;--swal2-deny-button-color: #fff;--swal2-cancel-button-box-shadow: none;--swal2-cancel-button-border-radius: 0.25em;--swal2-cancel-button-background-color: #6e7881;--swal2-cancel-button-color: #fff;--swal2-toast-show-animation: swal2-toast-show 0.5s;--swal2-toast-hide-animation: swal2-toast-hide 0.1s forwards;--swal2-toast-border: none;--swal2-toast-box-shadow: 0 0 1px hsl(0deg 0% 0% / 0.075), 0 1px 2px hsl(0deg 0% 0% / 0.075), 1px 2px 4px hsl(0deg 0% 0% / 0.075), 1px 3px 8px hsl(0deg 0% 0% / 0.075), 2px 4px 16px hsl(0deg 0% 0% / 0.075)}[data-swal2-theme=dark]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}@media(prefers-color-scheme: dark){[data-swal2-theme=auto]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:all}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px var(--swal2-backdrop)}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}@media print{body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown) .swal2-container{position:static !important}}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:"top-start     top            top-end" "center-start  center         center-end" "bottom-start  bottom-center  bottom-end";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:var(--swal2-container-padding);overflow-x:hidden;transition:var(--swal2-backdrop-transition);-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:var(--swal2-backdrop)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container)[popover]{width:auto;border:0}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:var(--swal2-width);max-width:100%;padding:var(--swal2-padding);border:var(--swal2-border);border-radius:var(--swal2-border-radius);background:var(--swal2-background);color:var(--swal2-color);font-family:inherit;font-size:1rem;container-name:swal2-popup}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable{cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon){cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging{cursor:grabbing}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon){cursor:grabbing}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:var(--swal2-title-padding);color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;overflow-wrap:break-word;cursor:initial}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:var(--swal2-actions-justify-content);width:var(--swal2-actions-width);margin:var(--swal2-actions-margin);padding:var(--swal2-actions-padding);border-radius:var(--swal2-actions-border-radius);background:var(--swal2-actions-background)}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:var(--swal2-action-button-transition);border:none;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border-radius:var(--swal2-confirm-button-border-radius);background:initial;background-color:var(--swal2-confirm-button-background-color);box-shadow:var(--swal2-confirm-button-box-shadow);color:var(--swal2-confirm-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):hover{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):active{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border-radius:var(--swal2-deny-button-border-radius);background:initial;background-color:var(--swal2-deny-button-background-color);box-shadow:var(--swal2-deny-button-box-shadow);color:var(--swal2-deny-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):hover{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):active{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border-radius:var(--swal2-cancel-button-border-radius);background:initial;background-color:var(--swal2-cancel-button-background-color);box-shadow:var(--swal2-cancel-button-box-shadow);color:var(--swal2-cancel-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):hover{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):active{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none;box-shadow:var(--swal2-action-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-styled)[disabled]:not(.swal2-loading){opacity:.4}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid var(--swal2-footer-border-color);background:var(--swal2-footer-background);color:var(--swal2-footer-color);font-size:1em;text-align:center;cursor:initial}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:var(--swal2-border-radius);border-bottom-left-radius:var(--swal2-border-radius)}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:var(--swal2-timer-progress-bar-background)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em;cursor:initial}div:where(.swal2-container) button:where(.swal2-close){position:var(--swal2-close-button-position);inset:var(--swal2-close-button-inset);z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:var(--swal2-close-button-transition);border:none;border-radius:var(--swal2-border-radius);outline:var(--swal2-close-button-outline);background:rgba(0,0,0,0);color:var(--swal2-close-button-color);font-family:monospace;font-size:var(--swal2-close-button-font-size);cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:var(--swal2-close-button-hover-transform);background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:var(--swal2-close-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-html-container){z-index:1;justify-content:center;margin:0;padding:var(--swal2-html-container-padding);overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;overflow-wrap:break-word;word-break:break-word;cursor:initial}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:var(--swal2-input-transition);border:var(--swal2-input-border);border-radius:var(--swal2-input-border-radius);background:var(--swal2-input-background);box-shadow:var(--swal2-input-box-shadow);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):hover,div:where(.swal2-container) input:where(.swal2-file):hover,div:where(.swal2-container) textarea:where(.swal2-textarea):hover{box-shadow:var(--swal2-input-hover-box-shadow)}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:var(--swal2-input-focus-border);outline:none;box-shadow:var(--swal2-input-focus-box-shadow)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:var(--swal2-background)}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:var(--swal2-input-background);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:var(--swal2-input-background);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:var(--swal2-background);color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:var(--swal2-validation-message-background);color:var(--swal2-validation-message-color);font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:"!";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:var(--swal2-progress-step-background);color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:var(--swal2-progress-step-background)}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;zoom:var(--swal2-icon-zoom);border:.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}}div:where(.swal2-icon).swal2-warning{border-color:#f8bb86;color:#f8bb86}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}}div:where(.swal2-icon).swal2-info{border-color:#3fc3ee;color:#3fc3ee}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}}div:where(.swal2-icon).swal2-question{border-color:#87adbd;color:#87adbd}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:var(--swal2-show-animation)}.swal2-hide{animation:var(--swal2-hide-animation)}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;border:var(--swal2-toast-border);background:var(--swal2-background);box-shadow:var(--swal2-toast-box-shadow);pointer-events:all}.swal2-toast>*{grid-column:2}.swal2-toast h2:where(.swal2-title){margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-toast .swal2-loading{justify-content:center}.swal2-toast input:where(.swal2-input){height:2em;margin:.5em;font-size:1em}.swal2-toast .swal2-validation-message{font-size:1em}.swal2-toast div:where(.swal2-footer){margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-toast button:where(.swal2-close){grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-toast div:where(.swal2-html-container){margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-toast div:where(.swal2-html-container):empty{padding:0}.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-toast div:where(.swal2-actions){justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-toast button:where(.swal2-styled){margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}@container swal2-popup style(--swal2-icon-animations:true){.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}}.swal2-toast.swal2-show{animation:var(--swal2-toast-show-animation)}.swal2-toast.swal2-hide{animation:var(--swal2-toast-hide-animation)}@keyframes swal2-show{0%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}100%{transform:translate3d(0, 0, 0) scale(1);opacity:1}}@keyframes swal2-hide{0%{transform:translate3d(0, 0, 0) scale(1);opacity:1}100%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}');
const lm = { class: "menu-lib-container" }, cm = { class: "lib-header" }, um = { class: "lib-title" }, dm = {
  key: 0,
  class: "lib-status-loading"
}, fm = {
  key: 1,
  class: "lib-status-error"
}, mm = { class: "lib-label" }, hm = { class: "lib-label-text" }, pm = { class: "lib-instruction-box" }, gm = { class: "whitespace-pre-line" }, wm = { class: "text-accent" }, bm = ["placeholder"], ym = ["disabled"], vm = { class: "lib-grid" }, _m = { class: "card-body" }, xm = { class: "card-title" }, Em = { class: "card-footer" }, km = { class: "price-tag" }, Cm = { class: "price-tag" }, Tm = { class: "order-tag" }, Am = { class: "lib-footer-actions" }, Om = /* @__PURE__ */ ye({
  __name: "MenuEditorPage",
  props: {
    api: {},
    items: {}
  },
  emits: ["refresh"],
  setup(e, { emit: t }) {
    const { t: n } = Ot(), s = e, r = t, { items: o, loading: a, error: i, load: l, addItems: c } = pu(s.api), h = z("");
    bt(o, (b) => {
      h.value || (h.value = [...b].sort((g, m) => g.order - m.order).map((g) => `${g.name},${g.price},${g.description}`).join(`
`));
    }, { immediate: !0 });
    const f = me(() => [...o.value].sort((b, g) => b.order - g.order));
    Dt(() => {
      l();
    });
    const p = async () => {
      const { payload: b, error: g } = gu(h.value);
      if (g) {
        we.fire({
          icon: "error",
          title: n("menu.invalidFormatTitle"),
          text: n("menu.invalidFormatText"),
          confirmButtonColor: "#2563eb"
        });
        return;
      }
      if (b.length !== 0)
        try {
          a.value = !0, await c(b), await we.fire({
            title: n("menu.saveSuccessTitle"),
            icon: "success",
            confirmButtonColor: "#2563eb",
            timer: 1500
          }), h.value = "", r("refresh"), l();
        } catch (m) {
          console.error(m);
        } finally {
          a.value = !1;
        }
    };
    return (b, g) => ($(), I("section", lm, [
      u("header", cm, [
        u("h1", um, T(k(n)("menu.editorTitle")), 1)
      ]),
      k(a) ? ($(), I("div", dm, T(k(n)("common.loading")), 1)) : k(i) ? ($(), I("div", fm, T(k(i)), 1)) : X("", !0),
      u("form", {
        onSubmit: Wo(p, ["prevent"]),
        class: "lib-form"
      }, [
        u("label", mm, [
          u("span", hm, T(k(n)("menu.inputLabel")), 1),
          u("div", pm, [
            Ge(T(k(n)("menu.formatInstruction")), 1),
            g[2] || (g[2] = u("br", null, null, -1)),
            Ge(" " + T(k(n)("menu.exampleTitle")), 1),
            g[3] || (g[3] = u("br", null, null, -1)),
            u("div", gm, T(k(n)("menu.exampleList")), 1),
            u("span", wm, T(k(n)("menu.copyPasteNote")), 1)
          ])
        ]),
        Qe(u("textarea", {
          "onUpdate:modelValue": g[0] || (g[0] = (m) => h.value = m),
          class: "lib-textarea",
          placeholder: k(n)("menu.placeholder")
        }, null, 8, bm), [
          [pt, h.value]
        ]),
        u("button", {
          type: "submit",
          disabled: k(a),
          class: "lib-btn-primary"
        }, T(k(a) ? k(n)("common.saving") : k(n)("menu.submitBtn")), 9, ym)
      ], 32),
      u("div", vm, [
        ($(!0), I(Me, null, ze(f.value, (m) => ($(), I("div", {
          key: m.id,
          class: ke(["lib-card", m.order % 2 === 0 ? "card-even" : "card-odd"])
        }, [
          u("div", _m, [
            u("h2", xm, T(m.name), 1)
          ]),
          u("div", Em, [
            u("p", km, T(k(n)("menu.pricePrefix")) + ": " + T(m.price), 1),
            u("p", Cm, T(k(n)("menu.categoryPrefix")) + ": " + T(m.category || ""), 1),
            u("p", Tm, T(k(n)("menu.orderPrefix")) + ": " + T(m.order), 1)
          ])
        ], 2))), 128))
      ]),
      u("div", Am, [
        u("button", {
          onClick: g[1] || (g[1] = //@ts-ignore
          (...m) => k(l) && k(l)(...m)),
          class: "lib-btn-secondary"
        }, T(k(n)("menu.reloadBtn")), 1)
      ])
    ]));
  }
}), bn = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [s, r] of t)
    n[s] = r;
  return n;
}, Vy = /* @__PURE__ */ bn(Om, [["__scopeId", "data-v-8d6c0c66"]]);
var Sm = 20, Nm = 1, Jt = 1e6, xo = 1e6, $m = -7, Lm = 21, Im = !1, Dn = "[big.js] ", tn = Dn + "Invalid ", ys = tn + "decimal places", Pm = tn + "rounding mode", wi = Dn + "Division by zero", pe = {}, Ct = void 0, Dm = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
function bi() {
  function e(t) {
    var n = this;
    if (!(n instanceof e))
      return t === Ct && arguments.length === 0 ? bi() : new e(t);
    if (t instanceof e)
      n.s = t.s, n.e = t.e, n.c = t.c.slice();
    else {
      if (typeof t != "string") {
        if (e.strict === !0 && typeof t != "bigint")
          throw TypeError(tn + "value");
        t = t === 0 && 1 / t < 0 ? "-0" : String(t);
      }
      Mm(n, t);
    }
    n.constructor = e;
  }
  return e.prototype = pe, e.DP = Sm, e.RM = Nm, e.NE = $m, e.PE = Lm, e.strict = Im, e.roundDown = 0, e.roundHalfUp = 1, e.roundHalfEven = 2, e.roundUp = 3, e;
}
function Mm(e, t) {
  var n, s, r;
  if (!Dm.test(t))
    throw Error(tn + "number");
  for (e.s = t.charAt(0) == "-" ? (t = t.slice(1), -1) : 1, (n = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (s = t.search(/e/i)) > 0 ? (n < 0 && (n = s), n += +t.slice(s + 1), t = t.substring(0, s)) : n < 0 && (n = t.length), r = t.length, s = 0; s < r && t.charAt(s) == "0"; ) ++s;
  if (s == r)
    e.c = [e.e = 0];
  else {
    for (; r > 0 && t.charAt(--r) == "0"; ) ;
    for (e.e = n - s - 1, e.c = [], n = 0; s <= r; ) e.c[n++] = +t.charAt(s++);
  }
  return e;
}
function nn(e, t, n, s) {
  var r = e.c;
  if (n === Ct && (n = e.constructor.RM), n !== 0 && n !== 1 && n !== 2 && n !== 3)
    throw Error(Pm);
  if (t < 1)
    s = n === 3 && (s || !!r[0]) || t === 0 && (n === 1 && r[0] >= 5 || n === 2 && (r[0] > 5 || r[0] === 5 && (s || r[1] !== Ct))), r.length = 1, s ? (e.e = e.e - t + 1, r[0] = 1) : r[0] = e.e = 0;
  else if (t < r.length) {
    if (s = n === 1 && r[t] >= 5 || n === 2 && (r[t] > 5 || r[t] === 5 && (s || r[t + 1] !== Ct || r[t - 1] & 1)) || n === 3 && (s || !!r[0]), r.length = t, s) {
      for (; ++r[--t] > 9; )
        if (r[t] = 0, t === 0) {
          ++e.e, r.unshift(1);
          break;
        }
    }
    for (t = r.length; !r[--t]; ) r.pop();
  }
  return e;
}
function sn(e, t, n) {
  var s = e.e, r = e.c.join(""), o = r.length;
  if (t)
    r = r.charAt(0) + (o > 1 ? "." + r.slice(1) : "") + (s < 0 ? "e" : "e+") + s;
  else if (s < 0) {
    for (; ++s; ) r = "0" + r;
    r = "0." + r;
  } else if (s > 0)
    if (++s > o)
      for (s -= o; s--; ) r += "0";
    else s < o && (r = r.slice(0, s) + "." + r.slice(s));
  else o > 1 && (r = r.charAt(0) + "." + r.slice(1));
  return e.s < 0 && n ? "-" + r : r;
}
pe.abs = function() {
  var e = new this.constructor(this);
  return e.s = 1, e;
};
pe.cmp = function(e) {
  var t, n = this, s = n.c, r = (e = new n.constructor(e)).c, o = n.s, a = e.s, i = n.e, l = e.e;
  if (!s[0] || !r[0]) return s[0] ? o : r[0] ? -a : 0;
  if (o != a) return o;
  if (t = o < 0, i != l) return i > l ^ t ? 1 : -1;
  for (a = (i = s.length) < (l = r.length) ? i : l, o = -1; ++o < a; )
    if (s[o] != r[o]) return s[o] > r[o] ^ t ? 1 : -1;
  return i == l ? 0 : i > l ^ t ? 1 : -1;
};
pe.div = function(e) {
  var t = this, n = t.constructor, s = t.c, r = (e = new n(e)).c, o = t.s == e.s ? 1 : -1, a = n.DP;
  if (a !== ~~a || a < 0 || a > Jt)
    throw Error(ys);
  if (!r[0])
    throw Error(wi);
  if (!s[0])
    return e.s = o, e.c = [e.e = 0], e;
  var i, l, c, h, f, p = r.slice(), b = i = r.length, g = s.length, m = s.slice(0, i), y = m.length, d = e, w = d.c = [], _ = 0, x = a + (d.e = t.e - e.e) + 1;
  for (d.s = o, o = x < 0 ? 0 : x, p.unshift(0); y++ < i; ) m.push(0);
  do {
    for (c = 0; c < 10; c++) {
      if (i != (y = m.length))
        h = i > y ? 1 : -1;
      else
        for (f = -1, h = 0; ++f < i; )
          if (r[f] != m[f]) {
            h = r[f] > m[f] ? 1 : -1;
            break;
          }
      if (h < 0) {
        for (l = y == i ? r : p; y; ) {
          if (m[--y] < l[y]) {
            for (f = y; f && !m[--f]; ) m[f] = 9;
            --m[f], m[y] += 10;
          }
          m[y] -= l[y];
        }
        for (; !m[0]; ) m.shift();
      } else
        break;
    }
    w[_++] = h ? c : ++c, m[0] && h ? m[y] = s[b] || 0 : m = [s[b]];
  } while ((b++ < g || m[0] !== Ct) && o--);
  return !w[0] && _ != 1 && (w.shift(), d.e--, x--), _ > x && nn(d, x, n.RM, m[0] !== Ct), d;
};
pe.eq = function(e) {
  return this.cmp(e) === 0;
};
pe.gt = function(e) {
  return this.cmp(e) > 0;
};
pe.gte = function(e) {
  return this.cmp(e) > -1;
};
pe.lt = function(e) {
  return this.cmp(e) < 0;
};
pe.lte = function(e) {
  return this.cmp(e) < 1;
};
pe.minus = pe.sub = function(e) {
  var t, n, s, r, o = this, a = o.constructor, i = o.s, l = (e = new a(e)).s;
  if (i != l)
    return e.s = -l, o.plus(e);
  var c = o.c.slice(), h = o.e, f = e.c, p = e.e;
  if (!c[0] || !f[0])
    return f[0] ? e.s = -l : c[0] ? e = new a(o) : e.s = 1, e;
  if (i = h - p) {
    for ((r = i < 0) ? (i = -i, s = c) : (p = h, s = f), s.reverse(), l = i; l--; ) s.push(0);
    s.reverse();
  } else
    for (n = ((r = c.length < f.length) ? c : f).length, i = l = 0; l < n; l++)
      if (c[l] != f[l]) {
        r = c[l] < f[l];
        break;
      }
  if (r && (s = c, c = f, f = s, e.s = -e.s), (l = (n = f.length) - (t = c.length)) > 0) for (; l--; ) c[t++] = 0;
  for (l = t; n > i; ) {
    if (c[--n] < f[n]) {
      for (t = n; t && !c[--t]; ) c[t] = 9;
      --c[t], c[n] += 10;
    }
    c[n] -= f[n];
  }
  for (; c[--l] === 0; ) c.pop();
  for (; c[0] === 0; )
    c.shift(), --p;
  return c[0] || (e.s = 1, c = [p = 0]), e.c = c, e.e = p, e;
};
pe.mod = function(e) {
  var t, n = this, s = n.constructor, r = n.s, o = (e = new s(e)).s;
  if (!e.c[0])
    throw Error(wi);
  return n.s = e.s = 1, t = e.cmp(n) == 1, n.s = r, e.s = o, t ? new s(n) : (r = s.DP, o = s.RM, s.DP = s.RM = 0, n = n.div(e), s.DP = r, s.RM = o, this.minus(n.times(e)));
};
pe.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s, e;
};
pe.plus = pe.add = function(e) {
  var t, n, s, r = this, o = r.constructor;
  if (e = new o(e), r.s != e.s)
    return e.s = -e.s, r.minus(e);
  var a = r.e, i = r.c, l = e.e, c = e.c;
  if (!i[0] || !c[0])
    return c[0] || (i[0] ? e = new o(r) : e.s = r.s), e;
  if (i = i.slice(), t = a - l) {
    for (t > 0 ? (l = a, s = c) : (t = -t, s = i), s.reverse(); t--; ) s.push(0);
    s.reverse();
  }
  for (i.length - c.length < 0 && (s = c, c = i, i = s), t = c.length, n = 0; t; i[t] %= 10) n = (i[--t] = i[t] + c[t] + n) / 10 | 0;
  for (n && (i.unshift(n), ++l), t = i.length; i[--t] === 0; ) i.pop();
  return e.c = i, e.e = l, e;
};
pe.pow = function(e) {
  var t = this, n = new t.constructor("1"), s = n, r = e < 0;
  if (e !== ~~e || e < -xo || e > xo)
    throw Error(tn + "exponent");
  for (r && (e = -e); e & 1 && (s = s.times(t)), e >>= 1, !!e; )
    t = t.times(t);
  return r ? n.div(s) : s;
};
pe.prec = function(e, t) {
  if (e !== ~~e || e < 1 || e > Jt)
    throw Error(tn + "precision");
  return nn(new this.constructor(this), e, t);
};
pe.round = function(e, t) {
  if (e === Ct) e = 0;
  else if (e !== ~~e || e < -Jt || e > Jt)
    throw Error(ys);
  return nn(new this.constructor(this), e + this.e + 1, t);
};
pe.sqrt = function() {
  var e, t, n, s = this, r = s.constructor, o = s.s, a = s.e, i = new r("0.5");
  if (!s.c[0]) return new r(s);
  if (o < 0)
    throw Error(Dn + "No square root");
  o = Math.sqrt(+sn(s, !0, !0)), o === 0 || o === 1 / 0 ? (t = s.c.join(""), t.length + a & 1 || (t += "0"), o = Math.sqrt(t), a = ((a + 1) / 2 | 0) - (a < 0 || a & 1), e = new r((o == 1 / 0 ? "5e" : (o = o.toExponential()).slice(0, o.indexOf("e") + 1)) + a)) : e = new r(o + ""), a = e.e + (r.DP += 4);
  do
    n = e, e = i.times(n.plus(s.div(n)));
  while (n.c.slice(0, a).join("") !== e.c.slice(0, a).join(""));
  return nn(e, (r.DP -= 4) + e.e + 1, r.RM);
};
pe.times = pe.mul = function(e) {
  var t, n = this, s = n.constructor, r = n.c, o = (e = new s(e)).c, a = r.length, i = o.length, l = n.e, c = e.e;
  if (e.s = n.s == e.s ? 1 : -1, !r[0] || !o[0])
    return e.c = [e.e = 0], e;
  for (e.e = l + c, a < i && (t = r, r = o, o = t, c = a, a = i, i = c), t = new Array(c = a + i); c--; ) t[c] = 0;
  for (l = i; l--; ) {
    for (i = 0, c = a + l; c > l; )
      i = t[c] + o[l] * r[c - l - 1] + i, t[c--] = i % 10, i = i / 10 | 0;
    t[c] = i;
  }
  for (i ? ++e.e : t.shift(), l = t.length; !t[--l]; ) t.pop();
  return e.c = t, e;
};
pe.toExponential = function(e, t) {
  var n = this, s = n.c[0];
  if (e !== Ct) {
    if (e !== ~~e || e < 0 || e > Jt)
      throw Error(ys);
    for (n = nn(new n.constructor(n), ++e, t); n.c.length < e; ) n.c.push(0);
  }
  return sn(n, !0, !!s);
};
pe.toFixed = function(e, t) {
  var n = this, s = n.c[0];
  if (e !== Ct) {
    if (e !== ~~e || e < 0 || e > Jt)
      throw Error(ys);
    for (n = nn(new n.constructor(n), e + n.e + 1, t), e = e + n.e + 1; n.c.length < e; ) n.c.push(0);
  }
  return sn(n, !1, !!s);
};
pe.toJSON = pe.toString = function() {
  var e = this, t = e.constructor;
  return sn(e, e.e <= t.NE || e.e >= t.PE, !!e.c[0]);
};
typeof Symbol < "u" && (pe[Symbol.for("nodejs.util.inspect.custom")] = pe.toJSON);
pe.toNumber = function() {
  var e = +sn(this, !0, !0);
  if (this.constructor.strict === !0 && !this.eq(e.toString()))
    throw Error(Dn + "Imprecise conversion");
  return e;
};
pe.toPrecision = function(e, t) {
  var n = this, s = n.constructor, r = n.c[0];
  if (e !== Ct) {
    if (e !== ~~e || e < 1 || e > Jt)
      throw Error(tn + "precision");
    for (n = nn(new s(n), e, t); n.c.length < e; ) n.c.push(0);
  }
  return sn(n, e <= n.e || n.e <= s.NE || n.e >= s.PE, !!r);
};
pe.valueOf = function() {
  var e = this, t = e.constructor;
  if (t.strict === !0)
    throw Error(Dn + "valueOf disallowed");
  return sn(e, e.e <= t.NE || e.e >= t.PE, !0);
};
var Pt = bi();
function yi(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Rm } = Object.prototype, { getPrototypeOf: Tr } = Object, { iterator: vs, toStringTag: vi } = Symbol, _s = /* @__PURE__ */ ((e) => (t) => {
  const n = Rm.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), yt = (e) => (e = e.toLowerCase(), (t) => _s(t) === e), xs = (e) => (t) => typeof t === e, { isArray: yn } = Array, fn = xs("undefined");
function Mn(e) {
  return e !== null && !fn(e) && e.constructor !== null && !fn(e.constructor) && tt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const _i = yt("ArrayBuffer");
function Fm(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && _i(e.buffer), t;
}
const Bm = xs("string"), tt = xs("function"), xi = xs("number"), Rn = (e) => e !== null && typeof e == "object", Um = (e) => e === !0 || e === !1, Yn = (e) => {
  if (_s(e) !== "object")
    return !1;
  const t = Tr(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(vi in e) && !(vs in e);
}, Vm = (e) => {
  if (!Rn(e) || Mn(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, Hm = yt("Date"), jm = yt("File"), qm = yt("Blob"), Wm = yt("FileList"), zm = (e) => Rn(e) && tt(e.pipe), Ym = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || tt(e.append) && ((t = _s(e)) === "formdata" || // detect form-data instance
  t === "object" && tt(e.toString) && e.toString() === "[object FormData]"));
}, Km = yt("URLSearchParams"), [Gm, Xm, Jm, Zm] = ["ReadableStream", "Request", "Response", "Headers"].map(yt), Qm = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Fn(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let s, r;
  if (typeof e != "object" && (e = [e]), yn(e))
    for (s = 0, r = e.length; s < r; s++)
      t.call(null, e[s], s, e);
  else {
    if (Mn(e))
      return;
    const o = n ? Object.getOwnPropertyNames(e) : Object.keys(e), a = o.length;
    let i;
    for (s = 0; s < a; s++)
      i = o[s], t.call(null, e[i], i, e);
  }
}
function Ei(e, t) {
  if (Mn(e))
    return null;
  t = t.toLowerCase();
  const n = Object.keys(e);
  let s = n.length, r;
  for (; s-- > 0; )
    if (r = n[s], t === r.toLowerCase())
      return r;
  return null;
}
const Wt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, ki = (e) => !fn(e) && e !== Wt;
function Xs() {
  const { caseless: e, skipUndefined: t } = ki(this) && this || {}, n = {}, s = (r, o) => {
    const a = e && Ei(n, o) || o;
    Yn(n[a]) && Yn(r) ? n[a] = Xs(n[a], r) : Yn(r) ? n[a] = Xs({}, r) : yn(r) ? n[a] = r.slice() : (!t || !fn(r)) && (n[a] = r);
  };
  for (let r = 0, o = arguments.length; r < o; r++)
    arguments[r] && Fn(arguments[r], s);
  return n;
}
const eh = (e, t, n, { allOwnKeys: s } = {}) => (Fn(t, (r, o) => {
  n && tt(r) ? e[o] = yi(r, n) : e[o] = r;
}, { allOwnKeys: s }), e), th = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), nh = (e, t, n, s) => {
  e.prototype = Object.create(t.prototype, s), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, sh = (e, t, n, s) => {
  let r, o, a;
  const i = {};
  if (t = t || {}, e == null) return t;
  do {
    for (r = Object.getOwnPropertyNames(e), o = r.length; o-- > 0; )
      a = r[o], (!s || s(a, e, t)) && !i[a] && (t[a] = e[a], i[a] = !0);
    e = n !== !1 && Tr(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, rh = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const s = e.indexOf(t, n);
  return s !== -1 && s === n;
}, oh = (e) => {
  if (!e) return null;
  if (yn(e)) return e;
  let t = e.length;
  if (!xi(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, ah = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Tr(Uint8Array)), ih = (e, t) => {
  const s = (e && e[vs]).call(e);
  let r;
  for (; (r = s.next()) && !r.done; ) {
    const o = r.value;
    t.call(e, o[0], o[1]);
  }
}, lh = (e, t) => {
  let n;
  const s = [];
  for (; (n = e.exec(t)) !== null; )
    s.push(n);
  return s;
}, ch = yt("HTMLFormElement"), uh = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, s, r) {
    return s.toUpperCase() + r;
  }
), Eo = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), dh = yt("RegExp"), Ci = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), s = {};
  Fn(n, (r, o) => {
    let a;
    (a = t(r, o, e)) !== !1 && (s[o] = a || r);
  }), Object.defineProperties(e, s);
}, fh = (e) => {
  Ci(e, (t, n) => {
    if (tt(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const s = e[n];
    if (tt(s)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, mh = (e, t) => {
  const n = {}, s = (r) => {
    r.forEach((o) => {
      n[o] = !0;
    });
  };
  return yn(e) ? s(e) : s(String(e).split(t)), n;
}, hh = () => {
}, ph = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function gh(e) {
  return !!(e && tt(e.append) && e[vi] === "FormData" && e[vs]);
}
const wh = (e) => {
  const t = new Array(10), n = (s, r) => {
    if (Rn(s)) {
      if (t.indexOf(s) >= 0)
        return;
      if (Mn(s))
        return s;
      if (!("toJSON" in s)) {
        t[r] = s;
        const o = yn(s) ? [] : {};
        return Fn(s, (a, i) => {
          const l = n(a, r + 1);
          !fn(l) && (o[i] = l);
        }), t[r] = void 0, o;
      }
    }
    return s;
  };
  return n(e, 0);
}, bh = yt("AsyncFunction"), yh = (e) => e && (Rn(e) || tt(e)) && tt(e.then) && tt(e.catch), Ti = ((e, t) => e ? setImmediate : t ? ((n, s) => (Wt.addEventListener("message", ({ source: r, data: o }) => {
  r === Wt && o === n && s.length && s.shift()();
}, !1), (r) => {
  s.push(r), Wt.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  tt(Wt.postMessage)
), vh = typeof queueMicrotask < "u" ? queueMicrotask.bind(Wt) : typeof process < "u" && process.nextTick || Ti, _h = (e) => e != null && tt(e[vs]), O = {
  isArray: yn,
  isArrayBuffer: _i,
  isBuffer: Mn,
  isFormData: Ym,
  isArrayBufferView: Fm,
  isString: Bm,
  isNumber: xi,
  isBoolean: Um,
  isObject: Rn,
  isPlainObject: Yn,
  isEmptyObject: Vm,
  isReadableStream: Gm,
  isRequest: Xm,
  isResponse: Jm,
  isHeaders: Zm,
  isUndefined: fn,
  isDate: Hm,
  isFile: jm,
  isBlob: qm,
  isRegExp: dh,
  isFunction: tt,
  isStream: zm,
  isURLSearchParams: Km,
  isTypedArray: ah,
  isFileList: Wm,
  forEach: Fn,
  merge: Xs,
  extend: eh,
  trim: Qm,
  stripBOM: th,
  inherits: nh,
  toFlatObject: sh,
  kindOf: _s,
  kindOfTest: yt,
  endsWith: rh,
  toArray: oh,
  forEachEntry: ih,
  matchAll: lh,
  isHTMLForm: ch,
  hasOwnProperty: Eo,
  hasOwnProp: Eo,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Ci,
  freezeMethods: fh,
  toObjectSet: mh,
  toCamelCase: uh,
  noop: hh,
  toFiniteNumber: ph,
  findKey: Ei,
  global: Wt,
  isContextDefined: ki,
  isSpecCompliantForm: gh,
  toJSONObject: wh,
  isAsyncFn: bh,
  isThenable: yh,
  setImmediate: Ti,
  asap: vh,
  isIterable: _h
};
function te(e, t, n, s, r) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), s && (this.request = s), r && (this.response = r, this.status = r.status ? r.status : null);
}
O.inherits(te, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: O.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Ai = te.prototype, Oi = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Oi[e] = { value: e };
});
Object.defineProperties(te, Oi);
Object.defineProperty(Ai, "isAxiosError", { value: !0 });
te.from = (e, t, n, s, r, o) => {
  const a = Object.create(Ai);
  O.toFlatObject(e, a, function(h) {
    return h !== Error.prototype;
  }, (c) => c !== "isAxiosError");
  const i = e && e.message ? e.message : "Error", l = t == null && e ? e.code : t;
  return te.call(a, i, l, n, s, r), e && a.cause == null && Object.defineProperty(a, "cause", { value: e, configurable: !0 }), a.name = e && e.name || "Error", o && Object.assign(a, o), a;
};
const xh = null;
function Js(e) {
  return O.isPlainObject(e) || O.isArray(e);
}
function Si(e) {
  return O.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function ko(e, t, n) {
  return e ? e.concat(t).map(function(r, o) {
    return r = Si(r), !n && o ? "[" + r + "]" : r;
  }).join(n ? "." : "") : t;
}
function Eh(e) {
  return O.isArray(e) && !e.some(Js);
}
const kh = O.toFlatObject(O, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Es(e, t, n) {
  if (!O.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = O.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(m, y) {
    return !O.isUndefined(y[m]);
  });
  const s = n.metaTokens, r = n.visitor || h, o = n.dots, a = n.indexes, l = (n.Blob || typeof Blob < "u" && Blob) && O.isSpecCompliantForm(t);
  if (!O.isFunction(r))
    throw new TypeError("visitor must be a function");
  function c(g) {
    if (g === null) return "";
    if (O.isDate(g))
      return g.toISOString();
    if (O.isBoolean(g))
      return g.toString();
    if (!l && O.isBlob(g))
      throw new te("Blob is not supported. Use a Buffer instead.");
    return O.isArrayBuffer(g) || O.isTypedArray(g) ? l && typeof Blob == "function" ? new Blob([g]) : Buffer.from(g) : g;
  }
  function h(g, m, y) {
    let d = g;
    if (g && !y && typeof g == "object") {
      if (O.endsWith(m, "{}"))
        m = s ? m : m.slice(0, -2), g = JSON.stringify(g);
      else if (O.isArray(g) && Eh(g) || (O.isFileList(g) || O.endsWith(m, "[]")) && (d = O.toArray(g)))
        return m = Si(m), d.forEach(function(_, x) {
          !(O.isUndefined(_) || _ === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? ko([m], x, o) : a === null ? m : m + "[]",
            c(_)
          );
        }), !1;
    }
    return Js(g) ? !0 : (t.append(ko(y, m, o), c(g)), !1);
  }
  const f = [], p = Object.assign(kh, {
    defaultVisitor: h,
    convertValue: c,
    isVisitable: Js
  });
  function b(g, m) {
    if (!O.isUndefined(g)) {
      if (f.indexOf(g) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      f.push(g), O.forEach(g, function(d, w) {
        (!(O.isUndefined(d) || d === null) && r.call(
          t,
          d,
          O.isString(w) ? w.trim() : w,
          m,
          p
        )) === !0 && b(d, m ? m.concat(w) : [w]);
      }), f.pop();
    }
  }
  if (!O.isObject(e))
    throw new TypeError("data must be an object");
  return b(e), t;
}
function Co(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(s) {
    return t[s];
  });
}
function Ar(e, t) {
  this._pairs = [], e && Es(e, this, t);
}
const Ni = Ar.prototype;
Ni.append = function(t, n) {
  this._pairs.push([t, n]);
};
Ni.toString = function(t) {
  const n = t ? function(s) {
    return t.call(this, s, Co);
  } : Co;
  return this._pairs.map(function(r) {
    return n(r[0]) + "=" + n(r[1]);
  }, "").join("&");
};
function Ch(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function $i(e, t, n) {
  if (!t)
    return e;
  const s = n && n.encode || Ch;
  O.isFunction(n) && (n = {
    serialize: n
  });
  const r = n && n.serialize;
  let o;
  if (r ? o = r(t, n) : o = O.isURLSearchParams(t) ? t.toString() : new Ar(t, n).toString(s), o) {
    const a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class To {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, s) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: s ? s.synchronous : !1,
      runWhen: s ? s.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    O.forEach(this.handlers, function(s) {
      s !== null && t(s);
    });
  }
}
const Li = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Th = typeof URLSearchParams < "u" ? URLSearchParams : Ar, Ah = typeof FormData < "u" ? FormData : null, Oh = typeof Blob < "u" ? Blob : null, Sh = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Th,
    FormData: Ah,
    Blob: Oh
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Or = typeof window < "u" && typeof document < "u", Zs = typeof navigator == "object" && navigator || void 0, Nh = Or && (!Zs || ["ReactNative", "NativeScript", "NS"].indexOf(Zs.product) < 0), $h = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Lh = Or && window.location.href || "http://localhost", Ih = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Or,
  hasStandardBrowserEnv: Nh,
  hasStandardBrowserWebWorkerEnv: $h,
  navigator: Zs,
  origin: Lh
}, Symbol.toStringTag, { value: "Module" })), We = {
  ...Ih,
  ...Sh
};
function Ph(e, t) {
  return Es(e, new We.classes.URLSearchParams(), {
    visitor: function(n, s, r, o) {
      return We.isNode && O.isBuffer(n) ? (this.append(s, n.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function Dh(e) {
  return O.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Mh(e) {
  const t = {}, n = Object.keys(e);
  let s;
  const r = n.length;
  let o;
  for (s = 0; s < r; s++)
    o = n[s], t[o] = e[o];
  return t;
}
function Ii(e) {
  function t(n, s, r, o) {
    let a = n[o++];
    if (a === "__proto__") return !0;
    const i = Number.isFinite(+a), l = o >= n.length;
    return a = !a && O.isArray(r) ? r.length : a, l ? (O.hasOwnProp(r, a) ? r[a] = [r[a], s] : r[a] = s, !i) : ((!r[a] || !O.isObject(r[a])) && (r[a] = []), t(n, s, r[a], o) && O.isArray(r[a]) && (r[a] = Mh(r[a])), !i);
  }
  if (O.isFormData(e) && O.isFunction(e.entries)) {
    const n = {};
    return O.forEachEntry(e, (s, r) => {
      t(Dh(s), r, n, 0);
    }), n;
  }
  return null;
}
function Rh(e, t, n) {
  if (O.isString(e))
    try {
      return (t || JSON.parse)(e), O.trim(e);
    } catch (s) {
      if (s.name !== "SyntaxError")
        throw s;
    }
  return (n || JSON.stringify)(e);
}
const Bn = {
  transitional: Li,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const s = n.getContentType() || "", r = s.indexOf("application/json") > -1, o = O.isObject(t);
    if (o && O.isHTMLForm(t) && (t = new FormData(t)), O.isFormData(t))
      return r ? JSON.stringify(Ii(t)) : t;
    if (O.isArrayBuffer(t) || O.isBuffer(t) || O.isStream(t) || O.isFile(t) || O.isBlob(t) || O.isReadableStream(t))
      return t;
    if (O.isArrayBufferView(t))
      return t.buffer;
    if (O.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let i;
    if (o) {
      if (s.indexOf("application/x-www-form-urlencoded") > -1)
        return Ph(t, this.formSerializer).toString();
      if ((i = O.isFileList(t)) || s.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return Es(
          i ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return o || r ? (n.setContentType("application/json", !1), Rh(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || Bn.transitional, s = n && n.forcedJSONParsing, r = this.responseType === "json";
    if (O.isResponse(t) || O.isReadableStream(t))
      return t;
    if (t && O.isString(t) && (s && !this.responseType || r)) {
      const a = !(n && n.silentJSONParsing) && r;
      try {
        return JSON.parse(t, this.parseReviver);
      } catch (i) {
        if (a)
          throw i.name === "SyntaxError" ? te.from(i, te.ERR_BAD_RESPONSE, this, null, this.response) : i;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: We.classes.FormData,
    Blob: We.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
O.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Bn.headers[e] = {};
});
const Fh = O.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Bh = (e) => {
  const t = {};
  let n, s, r;
  return e && e.split(`
`).forEach(function(a) {
    r = a.indexOf(":"), n = a.substring(0, r).trim().toLowerCase(), s = a.substring(r + 1).trim(), !(!n || t[n] && Fh[n]) && (n === "set-cookie" ? t[n] ? t[n].push(s) : t[n] = [s] : t[n] = t[n] ? t[n] + ", " + s : s);
  }), t;
}, Ao = Symbol("internals");
function xn(e) {
  return e && String(e).trim().toLowerCase();
}
function Kn(e) {
  return e === !1 || e == null ? e : O.isArray(e) ? e.map(Kn) : String(e);
}
function Uh(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let s;
  for (; s = n.exec(e); )
    t[s[1]] = s[2];
  return t;
}
const Vh = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Ls(e, t, n, s, r) {
  if (O.isFunction(s))
    return s.call(this, t, n);
  if (r && (t = n), !!O.isString(t)) {
    if (O.isString(s))
      return t.indexOf(s) !== -1;
    if (O.isRegExp(s))
      return s.test(t);
  }
}
function Hh(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, s) => n.toUpperCase() + s);
}
function jh(e, t) {
  const n = O.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((s) => {
    Object.defineProperty(e, s + n, {
      value: function(r, o, a) {
        return this[s].call(this, t, r, o, a);
      },
      configurable: !0
    });
  });
}
let nt = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, s) {
    const r = this;
    function o(i, l, c) {
      const h = xn(l);
      if (!h)
        throw new Error("header name must be a non-empty string");
      const f = O.findKey(r, h);
      (!f || r[f] === void 0 || c === !0 || c === void 0 && r[f] !== !1) && (r[f || l] = Kn(i));
    }
    const a = (i, l) => O.forEach(i, (c, h) => o(c, h, l));
    if (O.isPlainObject(t) || t instanceof this.constructor)
      a(t, n);
    else if (O.isString(t) && (t = t.trim()) && !Vh(t))
      a(Bh(t), n);
    else if (O.isObject(t) && O.isIterable(t)) {
      let i = {}, l, c;
      for (const h of t) {
        if (!O.isArray(h))
          throw TypeError("Object iterator must return a key-value pair");
        i[c = h[0]] = (l = i[c]) ? O.isArray(l) ? [...l, h[1]] : [l, h[1]] : h[1];
      }
      a(i, n);
    } else
      t != null && o(n, t, s);
    return this;
  }
  get(t, n) {
    if (t = xn(t), t) {
      const s = O.findKey(this, t);
      if (s) {
        const r = this[s];
        if (!n)
          return r;
        if (n === !0)
          return Uh(r);
        if (O.isFunction(n))
          return n.call(this, r, s);
        if (O.isRegExp(n))
          return n.exec(r);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = xn(t), t) {
      const s = O.findKey(this, t);
      return !!(s && this[s] !== void 0 && (!n || Ls(this, this[s], s, n)));
    }
    return !1;
  }
  delete(t, n) {
    const s = this;
    let r = !1;
    function o(a) {
      if (a = xn(a), a) {
        const i = O.findKey(s, a);
        i && (!n || Ls(s, s[i], i, n)) && (delete s[i], r = !0);
      }
    }
    return O.isArray(t) ? t.forEach(o) : o(t), r;
  }
  clear(t) {
    const n = Object.keys(this);
    let s = n.length, r = !1;
    for (; s--; ) {
      const o = n[s];
      (!t || Ls(this, this[o], o, t, !0)) && (delete this[o], r = !0);
    }
    return r;
  }
  normalize(t) {
    const n = this, s = {};
    return O.forEach(this, (r, o) => {
      const a = O.findKey(s, o);
      if (a) {
        n[a] = Kn(r), delete n[o];
        return;
      }
      const i = t ? Hh(o) : String(o).trim();
      i !== o && delete n[o], n[i] = Kn(r), s[i] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return O.forEach(this, (s, r) => {
      s != null && s !== !1 && (n[r] = t && O.isArray(s) ? s.join(", ") : s);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const s = new this(t);
    return n.forEach((r) => s.set(r)), s;
  }
  static accessor(t) {
    const s = (this[Ao] = this[Ao] = {
      accessors: {}
    }).accessors, r = this.prototype;
    function o(a) {
      const i = xn(a);
      s[i] || (jh(r, a), s[i] = !0);
    }
    return O.isArray(t) ? t.forEach(o) : o(t), this;
  }
};
nt.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
O.reduceDescriptors(nt.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(s) {
      this[n] = s;
    }
  };
});
O.freezeMethods(nt);
function Is(e, t) {
  const n = this || Bn, s = t || n, r = nt.from(s.headers);
  let o = s.data;
  return O.forEach(e, function(i) {
    o = i.call(n, o, r.normalize(), t ? t.status : void 0);
  }), r.normalize(), o;
}
function Pi(e) {
  return !!(e && e.__CANCEL__);
}
function vn(e, t, n) {
  te.call(this, e ?? "canceled", te.ERR_CANCELED, t, n), this.name = "CanceledError";
}
O.inherits(vn, te, {
  __CANCEL__: !0
});
function Di(e, t, n) {
  const s = n.config.validateStatus;
  !n.status || !s || s(n.status) ? e(n) : t(new te(
    "Request failed with status code " + n.status,
    [te.ERR_BAD_REQUEST, te.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function qh(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function Wh(e, t) {
  e = e || 10;
  const n = new Array(e), s = new Array(e);
  let r = 0, o = 0, a;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const c = Date.now(), h = s[o];
    a || (a = c), n[r] = l, s[r] = c;
    let f = o, p = 0;
    for (; f !== r; )
      p += n[f++], f = f % e;
    if (r = (r + 1) % e, r === o && (o = (o + 1) % e), c - a < t)
      return;
    const b = h && c - h;
    return b ? Math.round(p * 1e3 / b) : void 0;
  };
}
function zh(e, t) {
  let n = 0, s = 1e3 / t, r, o;
  const a = (c, h = Date.now()) => {
    n = h, r = null, o && (clearTimeout(o), o = null), e(...c);
  };
  return [(...c) => {
    const h = Date.now(), f = h - n;
    f >= s ? a(c, h) : (r = c, o || (o = setTimeout(() => {
      o = null, a(r);
    }, s - f)));
  }, () => r && a(r)];
}
const cs = (e, t, n = 3) => {
  let s = 0;
  const r = Wh(50, 250);
  return zh((o) => {
    const a = o.loaded, i = o.lengthComputable ? o.total : void 0, l = a - s, c = r(l), h = a <= i;
    s = a;
    const f = {
      loaded: a,
      total: i,
      progress: i ? a / i : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && i && h ? (i - a) / c : void 0,
      event: o,
      lengthComputable: i != null,
      [t ? "download" : "upload"]: !0
    };
    e(f);
  }, n);
}, Oo = (e, t) => {
  const n = e != null;
  return [(s) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: s
  }), t[1]];
}, So = (e) => (...t) => O.asap(() => e(...t)), Yh = We.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, We.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(We.origin),
  We.navigator && /(msie|trident)/i.test(We.navigator.userAgent)
) : () => !0, Kh = We.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, s, r, o, a) {
      if (typeof document > "u") return;
      const i = [`${e}=${encodeURIComponent(t)}`];
      O.isNumber(n) && i.push(`expires=${new Date(n).toUTCString()}`), O.isString(s) && i.push(`path=${s}`), O.isString(r) && i.push(`domain=${r}`), o === !0 && i.push("secure"), O.isString(a) && i.push(`SameSite=${a}`), document.cookie = i.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const t = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
      return t ? decodeURIComponent(t[1]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Gh(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Xh(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Mi(e, t, n) {
  let s = !Gh(t);
  return e && (s || n == !1) ? Xh(e, t) : t;
}
const No = (e) => e instanceof nt ? { ...e } : e;
function Zt(e, t) {
  t = t || {};
  const n = {};
  function s(c, h, f, p) {
    return O.isPlainObject(c) && O.isPlainObject(h) ? O.merge.call({ caseless: p }, c, h) : O.isPlainObject(h) ? O.merge({}, h) : O.isArray(h) ? h.slice() : h;
  }
  function r(c, h, f, p) {
    if (O.isUndefined(h)) {
      if (!O.isUndefined(c))
        return s(void 0, c, f, p);
    } else return s(c, h, f, p);
  }
  function o(c, h) {
    if (!O.isUndefined(h))
      return s(void 0, h);
  }
  function a(c, h) {
    if (O.isUndefined(h)) {
      if (!O.isUndefined(c))
        return s(void 0, c);
    } else return s(void 0, h);
  }
  function i(c, h, f) {
    if (f in t)
      return s(c, h);
    if (f in e)
      return s(void 0, c);
  }
  const l = {
    url: o,
    method: o,
    data: o,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    withXSRFToken: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: i,
    headers: (c, h, f) => r(No(c), No(h), f, !0)
  };
  return O.forEach(Object.keys({ ...e, ...t }), function(h) {
    const f = l[h] || r, p = f(e[h], t[h], h);
    O.isUndefined(p) && f !== i || (n[h] = p);
  }), n;
}
const Ri = (e) => {
  const t = Zt({}, e);
  let { data: n, withXSRFToken: s, xsrfHeaderName: r, xsrfCookieName: o, headers: a, auth: i } = t;
  if (t.headers = a = nt.from(a), t.url = $i(Mi(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), i && a.set(
    "Authorization",
    "Basic " + btoa((i.username || "") + ":" + (i.password ? unescape(encodeURIComponent(i.password)) : ""))
  ), O.isFormData(n)) {
    if (We.hasStandardBrowserEnv || We.hasStandardBrowserWebWorkerEnv)
      a.setContentType(void 0);
    else if (O.isFunction(n.getHeaders)) {
      const l = n.getHeaders(), c = ["content-type", "content-length"];
      Object.entries(l).forEach(([h, f]) => {
        c.includes(h.toLowerCase()) && a.set(h, f);
      });
    }
  }
  if (We.hasStandardBrowserEnv && (s && O.isFunction(s) && (s = s(t)), s || s !== !1 && Yh(t.url))) {
    const l = r && o && Kh.read(o);
    l && a.set(r, l);
  }
  return t;
}, Jh = typeof XMLHttpRequest < "u", Zh = Jh && function(e) {
  return new Promise(function(n, s) {
    const r = Ri(e);
    let o = r.data;
    const a = nt.from(r.headers).normalize();
    let { responseType: i, onUploadProgress: l, onDownloadProgress: c } = r, h, f, p, b, g;
    function m() {
      b && b(), g && g(), r.cancelToken && r.cancelToken.unsubscribe(h), r.signal && r.signal.removeEventListener("abort", h);
    }
    let y = new XMLHttpRequest();
    y.open(r.method.toUpperCase(), r.url, !0), y.timeout = r.timeout;
    function d() {
      if (!y)
        return;
      const _ = nt.from(
        "getAllResponseHeaders" in y && y.getAllResponseHeaders()
      ), A = {
        data: !i || i === "text" || i === "json" ? y.responseText : y.response,
        status: y.status,
        statusText: y.statusText,
        headers: _,
        config: e,
        request: y
      };
      Di(function(C) {
        n(C), m();
      }, function(C) {
        s(C), m();
      }, A), y = null;
    }
    "onloadend" in y ? y.onloadend = d : y.onreadystatechange = function() {
      !y || y.readyState !== 4 || y.status === 0 && !(y.responseURL && y.responseURL.indexOf("file:") === 0) || setTimeout(d);
    }, y.onabort = function() {
      y && (s(new te("Request aborted", te.ECONNABORTED, e, y)), y = null);
    }, y.onerror = function(x) {
      const A = x && x.message ? x.message : "Network Error", L = new te(A, te.ERR_NETWORK, e, y);
      L.event = x || null, s(L), y = null;
    }, y.ontimeout = function() {
      let x = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const A = r.transitional || Li;
      r.timeoutErrorMessage && (x = r.timeoutErrorMessage), s(new te(
        x,
        A.clarifyTimeoutError ? te.ETIMEDOUT : te.ECONNABORTED,
        e,
        y
      )), y = null;
    }, o === void 0 && a.setContentType(null), "setRequestHeader" in y && O.forEach(a.toJSON(), function(x, A) {
      y.setRequestHeader(A, x);
    }), O.isUndefined(r.withCredentials) || (y.withCredentials = !!r.withCredentials), i && i !== "json" && (y.responseType = r.responseType), c && ([p, g] = cs(c, !0), y.addEventListener("progress", p)), l && y.upload && ([f, b] = cs(l), y.upload.addEventListener("progress", f), y.upload.addEventListener("loadend", b)), (r.cancelToken || r.signal) && (h = (_) => {
      y && (s(!_ || _.type ? new vn(null, e, y) : _), y.abort(), y = null);
    }, r.cancelToken && r.cancelToken.subscribe(h), r.signal && (r.signal.aborted ? h() : r.signal.addEventListener("abort", h)));
    const w = qh(r.url);
    if (w && We.protocols.indexOf(w) === -1) {
      s(new te("Unsupported protocol " + w + ":", te.ERR_BAD_REQUEST, e));
      return;
    }
    y.send(o || null);
  });
}, Qh = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let s = new AbortController(), r;
    const o = function(c) {
      if (!r) {
        r = !0, i();
        const h = c instanceof Error ? c : this.reason;
        s.abort(h instanceof te ? h : new vn(h instanceof Error ? h.message : h));
      }
    };
    let a = t && setTimeout(() => {
      a = null, o(new te(`timeout ${t} of ms exceeded`, te.ETIMEDOUT));
    }, t);
    const i = () => {
      e && (a && clearTimeout(a), a = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(o) : c.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", o));
    const { signal: l } = s;
    return l.unsubscribe = () => O.asap(i), l;
  }
}, ep = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let s = 0, r;
  for (; s < n; )
    r = s + t, yield e.slice(s, r), s = r;
}, tp = async function* (e, t) {
  for await (const n of np(e))
    yield* ep(n, t);
}, np = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: s } = await t.read();
      if (n)
        break;
      yield s;
    }
  } finally {
    await t.cancel();
  }
}, $o = (e, t, n, s) => {
  const r = tp(e, t);
  let o = 0, a, i = (l) => {
    a || (a = !0, s && s(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: c, value: h } = await r.next();
        if (c) {
          i(), l.close();
          return;
        }
        let f = h.byteLength;
        if (n) {
          let p = o += f;
          n(p);
        }
        l.enqueue(new Uint8Array(h));
      } catch (c) {
        throw i(c), c;
      }
    },
    cancel(l) {
      return i(l), r.return();
    }
  }, {
    highWaterMark: 2
  });
}, Lo = 64 * 1024, { isFunction: Wn } = O, sp = (({ Request: e, Response: t }) => ({
  Request: e,
  Response: t
}))(O.global), {
  ReadableStream: Io,
  TextEncoder: Po
} = O.global, Do = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, rp = (e) => {
  e = O.merge.call({
    skipUndefined: !0
  }, sp, e);
  const { fetch: t, Request: n, Response: s } = e, r = t ? Wn(t) : typeof fetch == "function", o = Wn(n), a = Wn(s);
  if (!r)
    return !1;
  const i = r && Wn(Io), l = r && (typeof Po == "function" ? /* @__PURE__ */ ((g) => (m) => g.encode(m))(new Po()) : async (g) => new Uint8Array(await new n(g).arrayBuffer())), c = o && i && Do(() => {
    let g = !1;
    const m = new n(We.origin, {
      body: new Io(),
      method: "POST",
      get duplex() {
        return g = !0, "half";
      }
    }).headers.has("Content-Type");
    return g && !m;
  }), h = a && i && Do(() => O.isReadableStream(new s("").body)), f = {
    stream: h && ((g) => g.body)
  };
  r && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((g) => {
    !f[g] && (f[g] = (m, y) => {
      let d = m && m[g];
      if (d)
        return d.call(m);
      throw new te(`Response type '${g}' is not supported`, te.ERR_NOT_SUPPORT, y);
    });
  });
  const p = async (g) => {
    if (g == null)
      return 0;
    if (O.isBlob(g))
      return g.size;
    if (O.isSpecCompliantForm(g))
      return (await new n(We.origin, {
        method: "POST",
        body: g
      }).arrayBuffer()).byteLength;
    if (O.isArrayBufferView(g) || O.isArrayBuffer(g))
      return g.byteLength;
    if (O.isURLSearchParams(g) && (g = g + ""), O.isString(g))
      return (await l(g)).byteLength;
  }, b = async (g, m) => {
    const y = O.toFiniteNumber(g.getContentLength());
    return y ?? p(m);
  };
  return async (g) => {
    let {
      url: m,
      method: y,
      data: d,
      signal: w,
      cancelToken: _,
      timeout: x,
      onDownloadProgress: A,
      onUploadProgress: L,
      responseType: C,
      headers: F,
      withCredentials: D = "same-origin",
      fetchOptions: j
    } = Ri(g), q = t || fetch;
    C = C ? (C + "").toLowerCase() : "text";
    let ne = Qh([w, _ && _.toAbortSignal()], x), De = null;
    const V = ne && ne.unsubscribe && (() => {
      ne.unsubscribe();
    });
    let U;
    try {
      if (L && c && y !== "get" && y !== "head" && (U = await b(F, d)) !== 0) {
        let ee = new n(m, {
          method: "POST",
          body: d,
          duplex: "half"
        }), re;
        if (O.isFormData(d) && (re = ee.headers.get("content-type")) && F.setContentType(re), ee.body) {
          const [de, ve] = Oo(
            U,
            cs(So(L))
          );
          d = $o(ee.body, Lo, de, ve);
        }
      }
      O.isString(D) || (D = D ? "include" : "omit");
      const R = o && "credentials" in n.prototype, W = {
        ...j,
        signal: ne,
        method: y.toUpperCase(),
        headers: F.normalize().toJSON(),
        body: d,
        duplex: "half",
        credentials: R ? D : void 0
      };
      De = o && new n(m, W);
      let B = await (o ? q(De, j) : q(m, W));
      const J = h && (C === "stream" || C === "response");
      if (h && (A || J && V)) {
        const ee = {};
        ["status", "statusText", "headers"].forEach((Te) => {
          ee[Te] = B[Te];
        });
        const re = O.toFiniteNumber(B.headers.get("content-length")), [de, ve] = A && Oo(
          re,
          cs(So(A), !0)
        ) || [];
        B = new s(
          $o(B.body, Lo, de, () => {
            ve && ve(), V && V();
          }),
          ee
        );
      }
      C = C || "text";
      let K = await f[O.findKey(f, C) || "text"](B, g);
      return !J && V && V(), await new Promise((ee, re) => {
        Di(ee, re, {
          data: K,
          headers: nt.from(B.headers),
          status: B.status,
          statusText: B.statusText,
          config: g,
          request: De
        });
      });
    } catch (R) {
      throw V && V(), R && R.name === "TypeError" && /Load failed|fetch/i.test(R.message) ? Object.assign(
        new te("Network Error", te.ERR_NETWORK, g, De),
        {
          cause: R.cause || R
        }
      ) : te.from(R, R && R.code, g, De);
    }
  };
}, op = /* @__PURE__ */ new Map(), Fi = (e) => {
  let t = e && e.env || {};
  const { fetch: n, Request: s, Response: r } = t, o = [
    s,
    r,
    n
  ];
  let a = o.length, i = a, l, c, h = op;
  for (; i--; )
    l = o[i], c = h.get(l), c === void 0 && h.set(l, c = i ? /* @__PURE__ */ new Map() : rp(t)), h = c;
  return c;
};
Fi();
const Sr = {
  http: xh,
  xhr: Zh,
  fetch: {
    get: Fi
  }
};
O.forEach(Sr, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Mo = (e) => `- ${e}`, ap = (e) => O.isFunction(e) || e === null || e === !1;
function ip(e, t) {
  e = O.isArray(e) ? e : [e];
  const { length: n } = e;
  let s, r;
  const o = {};
  for (let a = 0; a < n; a++) {
    s = e[a];
    let i;
    if (r = s, !ap(s) && (r = Sr[(i = String(s)).toLowerCase()], r === void 0))
      throw new te(`Unknown adapter '${i}'`);
    if (r && (O.isFunction(r) || (r = r.get(t))))
      break;
    o[i || "#" + a] = r;
  }
  if (!r) {
    const a = Object.entries(o).map(
      ([l, c]) => `adapter ${l} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let i = n ? a.length > 1 ? `since :
` + a.map(Mo).join(`
`) : " " + Mo(a[0]) : "as no adapter specified";
    throw new te(
      "There is no suitable adapter to dispatch the request " + i,
      "ERR_NOT_SUPPORT"
    );
  }
  return r;
}
const Bi = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: ip,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: Sr
};
function Ps(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new vn(null, e);
}
function Ro(e) {
  return Ps(e), e.headers = nt.from(e.headers), e.data = Is.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Bi.getAdapter(e.adapter || Bn.adapter, e)(e).then(function(s) {
    return Ps(e), s.data = Is.call(
      e,
      e.transformResponse,
      s
    ), s.headers = nt.from(s.headers), s;
  }, function(s) {
    return Pi(s) || (Ps(e), s && s.response && (s.response.data = Is.call(
      e,
      e.transformResponse,
      s.response
    ), s.response.headers = nt.from(s.response.headers))), Promise.reject(s);
  });
}
const Ui = "1.13.2", ks = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  ks[e] = function(s) {
    return typeof s === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Fo = {};
ks.transitional = function(t, n, s) {
  function r(o, a) {
    return "[Axios v" + Ui + "] Transitional option '" + o + "'" + a + (s ? ". " + s : "");
  }
  return (o, a, i) => {
    if (t === !1)
      throw new te(
        r(a, " has been removed" + (n ? " in " + n : "")),
        te.ERR_DEPRECATED
      );
    return n && !Fo[a] && (Fo[a] = !0, console.warn(
      r(
        a,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(o, a, i) : !0;
  };
};
ks.spelling = function(t) {
  return (n, s) => (console.warn(`${s} is likely a misspelling of ${t}`), !0);
};
function lp(e, t, n) {
  if (typeof e != "object")
    throw new te("options must be an object", te.ERR_BAD_OPTION_VALUE);
  const s = Object.keys(e);
  let r = s.length;
  for (; r-- > 0; ) {
    const o = s[r], a = t[o];
    if (a) {
      const i = e[o], l = i === void 0 || a(i, o, e);
      if (l !== !0)
        throw new te("option " + o + " must be " + l, te.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new te("Unknown option " + o, te.ERR_BAD_OPTION);
  }
}
const Gn = {
  assertOptions: lp,
  validators: ks
}, xt = Gn.validators;
let Yt = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new To(),
      response: new To()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (s) {
      if (s instanceof Error) {
        let r = {};
        Error.captureStackTrace ? Error.captureStackTrace(r) : r = new Error();
        const o = r.stack ? r.stack.replace(/^.+\n/, "") : "";
        try {
          s.stack ? o && !String(s.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (s.stack += `
` + o) : s.stack = o;
        } catch {
        }
      }
      throw s;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = Zt(this.defaults, n);
    const { transitional: s, paramsSerializer: r, headers: o } = n;
    s !== void 0 && Gn.assertOptions(s, {
      silentJSONParsing: xt.transitional(xt.boolean),
      forcedJSONParsing: xt.transitional(xt.boolean),
      clarifyTimeoutError: xt.transitional(xt.boolean)
    }, !1), r != null && (O.isFunction(r) ? n.paramsSerializer = {
      serialize: r
    } : Gn.assertOptions(r, {
      encode: xt.function,
      serialize: xt.function
    }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), Gn.assertOptions(n, {
      baseUrl: xt.spelling("baseURL"),
      withXsrfToken: xt.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let a = o && O.merge(
      o.common,
      o[n.method]
    );
    o && O.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (g) => {
        delete o[g];
      }
    ), n.headers = nt.concat(a, o);
    const i = [];
    let l = !0;
    this.interceptors.request.forEach(function(m) {
      typeof m.runWhen == "function" && m.runWhen(n) === !1 || (l = l && m.synchronous, i.unshift(m.fulfilled, m.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(m) {
      c.push(m.fulfilled, m.rejected);
    });
    let h, f = 0, p;
    if (!l) {
      const g = [Ro.bind(this), void 0];
      for (g.unshift(...i), g.push(...c), p = g.length, h = Promise.resolve(n); f < p; )
        h = h.then(g[f++], g[f++]);
      return h;
    }
    p = i.length;
    let b = n;
    for (; f < p; ) {
      const g = i[f++], m = i[f++];
      try {
        b = g(b);
      } catch (y) {
        m.call(this, y);
        break;
      }
    }
    try {
      h = Ro.call(this, b);
    } catch (g) {
      return Promise.reject(g);
    }
    for (f = 0, p = c.length; f < p; )
      h = h.then(c[f++], c[f++]);
    return h;
  }
  getUri(t) {
    t = Zt(this.defaults, t);
    const n = Mi(t.baseURL, t.url, t.allowAbsoluteUrls);
    return $i(n, t.params, t.paramsSerializer);
  }
};
O.forEach(["delete", "get", "head", "options"], function(t) {
  Yt.prototype[t] = function(n, s) {
    return this.request(Zt(s || {}, {
      method: t,
      url: n,
      data: (s || {}).data
    }));
  };
});
O.forEach(["post", "put", "patch"], function(t) {
  function n(s) {
    return function(o, a, i) {
      return this.request(Zt(i || {}, {
        method: t,
        headers: s ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: a
      }));
    };
  }
  Yt.prototype[t] = n(), Yt.prototype[t + "Form"] = n(!0);
});
let cp = class Vi {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(o) {
      n = o;
    });
    const s = this;
    this.promise.then((r) => {
      if (!s._listeners) return;
      let o = s._listeners.length;
      for (; o-- > 0; )
        s._listeners[o](r);
      s._listeners = null;
    }), this.promise.then = (r) => {
      let o;
      const a = new Promise((i) => {
        s.subscribe(i), o = i;
      }).then(r);
      return a.cancel = function() {
        s.unsubscribe(o);
      }, a;
    }, t(function(o, a, i) {
      s.reason || (s.reason = new vn(o, a, i), n(s.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (s) => {
      t.abort(s);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Vi(function(r) {
        t = r;
      }),
      cancel: t
    };
  }
};
function up(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function dp(e) {
  return O.isObject(e) && e.isAxiosError === !0;
}
const Qs = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(Qs).forEach(([e, t]) => {
  Qs[t] = e;
});
function Hi(e) {
  const t = new Yt(e), n = yi(Yt.prototype.request, t);
  return O.extend(n, Yt.prototype, t, { allOwnKeys: !0 }), O.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(r) {
    return Hi(Zt(e, r));
  }, n;
}
const Ie = Hi(Bn);
Ie.Axios = Yt;
Ie.CanceledError = vn;
Ie.CancelToken = cp;
Ie.isCancel = Pi;
Ie.VERSION = Ui;
Ie.toFormData = Es;
Ie.AxiosError = te;
Ie.Cancel = Ie.CanceledError;
Ie.all = function(t) {
  return Promise.all(t);
};
Ie.spread = up;
Ie.isAxiosError = dp;
Ie.mergeConfig = Zt;
Ie.AxiosHeaders = nt;
Ie.formToJSON = (e) => Ii(O.isHTMLForm(e) ? new FormData(e) : e);
Ie.getAdapter = Bi.getAdapter;
Ie.HttpStatusCode = Qs;
Ie.default = Ie;
const {
  Axios: qy,
  AxiosError: Wy,
  CanceledError: zy,
  isCancel: Yy,
  CancelToken: Ky,
  VERSION: Gy,
  all: Xy,
  Cancel: Jy,
  isAxiosError: Zy,
  spread: Qy,
  toFormData: ev,
  AxiosHeaders: tv,
  HttpStatusCode: nv,
  formToJSON: sv,
  getAdapter: rv,
  mergeConfig: ov
} = Ie;
function ji(e) {
  const t = z(null), n = z(!1), s = z(null), r = z({}), o = zo({}), a = z(0), i = async (d) => {
    n.value = !0, s.value = null;
    try {
      t.value = await e.getMenuByQr(d);
    } catch (w) {
      s.value = w.message || "無法載入菜單";
    } finally {
      n.value = !1;
    }
  }, l = async (d) => {
    try {
      r.value = await e.getImages(d);
    } catch {
    } finally {
    }
  }, c = () => {
    Object.keys(o).forEach((d) => {
      delete o[d];
    });
  }, h = (d) => {
    const w = o[d] || 0;
    w < 7 && a.value < 20 && (o[d] = w + 1, a.value++);
  }, f = (d) => {
    o[d] && o[d] > 0 && (o[d]--, a.value--, o[d] === 0 && delete o[d]);
  }, p = me(() => t.value ? t.value.items.reduce((w, _) => {
    const x = o[_.id] || 0;
    if (x <= 0) return w;
    const A = new Pt(_.price).times(x);
    return w.plus(A);
  }, new Pt(0)).toString() : "0"), b = async (d, w) => {
    if (!d) {
      s.value = "遺失桌號資訊 (QR code)，無法下單";
      return;
    }
    if (!(!t.value || Object.keys(o).length === 0)) {
      n.value = !0;
      try {
        const _ = (w == null ? void 0 : w.nickname) || "", x = (w == null ? void 0 : w.memo1) || "", A = {
          merchantId: t.value.merchantId,
          tableNumber: t.value.tableNumber,
          qr: d,
          items: Object.entries(o).map(([C, F]) => ({ menuItemId: C, quantity: F })),
          nickname: _,
          memo1: x
        };
        return await e.submitOrder(A);
      } catch (_) {
        throw s.value = _.message || "送單失敗", _;
      } finally {
        n.value = !1;
      }
    }
  };
  return {
    menuData: t,
    loading: n,
    error: s,
    cart: o,
    totalCounter: a,
    loadMenu: i,
    addToCart: h,
    removeFromCart: f,
    totalPrice: p,
    handleOrderSubmit: async (d, w) => {
      var _, x, A, L;
      try {
        const C = (w == null ? void 0 : w.nickname) || "", F = (w == null ? void 0 : w.memo1) || "", D = await b(d, {
          nickname: C,
          memo1: F
        });
        if (D)
          return await we.fire({
            title: "Order placed successfully！",
            text: `Order Number: ${D}`,
            icon: "success",
            confirmButtonColor: "#2563eb",
            timer: 1500
          }), c(), D;
      } catch (C) {
        let F = "請確認網路連線或聯繫服務人員", D = "UNKNOWN_ERROR";
        throw Ie.isAxiosError(C) ? (D = ((x = (_ = C.response) == null ? void 0 : _.data) == null ? void 0 : x.error_code) || D, F = ((L = (A = C.response) == null ? void 0 : A.data) == null ? void 0 : L.message) || C.message) : C instanceof Error && (F = C.message), we.fire({
          title: "下單失敗",
          text: F,
          icon: "error",
          footer: `錯誤代碼: ${D}`
        }), C;
      }
    },
    handlePaymentSubmit: async (d) => {
      if (!d.qr || typeof d.qr != "string" || d.qr.trim() === "")
        return Ce.error("handlePaymentSubmit Validation Error: QR code is missing or invalid"), !1;
      if (!Array.isArray(d.ids) || d.ids.length === 0)
        return Ce.error("handlePaymentSubmit Validation Error: No order IDs selected"), !1;
      if (!d.merchant_id || typeof d.merchant_id != "string" || d.merchant_id.trim() === "")
        return Ce.error("handlePaymentSubmit Validation Error: Merchant ID is missing or invalid"), !1;
      try {
        Ce.log("handlePaymentSubmit payload:", d);
        const w = await e.handlePayment(d);
        if (w) {
          if (w == "BFFErrSvcBatchProcessAmountLimit")
            return w;
          document.body.appendChild(w), w.submit();
        }
        return !0;
      } catch (w) {
        return Ce.error("Payment error:", w), !1;
      }
    },
    images: r,
    loadImg: l,
    queryCompanyName: async (d) => await e.queryCompanyName(d)
  };
}
function qi(e) {
  const t = z([]), n = z(!1), s = z(null), r = async (i) => {
    if (i) {
      n.value = !0, s.value = null;
      try {
        const l = await e.getTableOrders(i);
        t.value = Array.isArray(l) ? l : [];
      } catch (l) {
        s.value = l.message || "無法載入訂單紀錄", console.error("OrderHistory Error:", l);
      } finally {
        n.value = !1;
      }
    }
  }, o = async (i) => {
    if (i) {
      n.value = !0, s.value = null;
      try {
        const l = await e.getTableSessionOrders(i);
        t.value = Array.isArray(l) ? l : [];
      } catch (l) {
        s.value = l.message || "無法載入訂單紀錄", console.error("OrderHistory Error:", l);
      } finally {
        n.value = !1;
      }
    }
  }, a = me(() => t.value.reduce((l, c) => {
    const h = c.subtotal || "0";
    return l.plus(new Pt(h));
  }, new Pt(0)).toString());
  return {
    orderHistory: t,
    historyLoading: n,
    historyError: s,
    loadOrderHistory: r,
    loadOrderHistorySession: o,
    cumulativeTotal: a
  };
}
function fp(e, t, n, s, r) {
  const o = z([]), a = z("0"), i = (m) => {
    o.value = m.ids, a.value = m.total;
  }, l = z("All"), c = me(() => {
    var w;
    const m = ((w = e.value) == null ? void 0 : w.categoryItem) || [], y = /* @__PURE__ */ new Map();
    return m.forEach((_) => {
      _.category && (!y.has(_.category) || _.orderNum < y.get(_.category)) && y.set(_.category, _.orderNum);
    }), Array.from(y.entries()).map(([_, x]) => ({
      name: _,
      order: x
    })).sort((_, x) => _.order - x.order || _.name.localeCompare(x.name)).map((_) => _.name);
  }), h = me(() => {
    var y;
    const m = ((y = e.value) == null ? void 0 : y.items) || [];
    return l.value === "All" ? m : m.filter((d) => d.category === l.value);
  }), f = [
    "杏簾招客飲，在望有山莊",
    "菱荇鵝兒水，桑榆燕子梁",
    "一畦春韭綠，十里稻花香",
    "盛世無飢餒，何須耕織忙"
  ], p = z(f[0]);
  bt(n, () => {
    const m = (f.indexOf(p.value) + 1) % f.length;
    p.value = f[m];
  });
  const b = (m) => m ? m.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;") : "";
  return {
    selectedOrderIds: o,
    selectedTotal: a,
    handleSelectionChange: i,
    selectedCategory: l,
    availableCategories: c,
    filteredItems: h,
    formatOrderHtml: (m, y, d) => {
      const w = m.map((_) => {
        const x = _.name ? b(_.name) : d("menu.unknownItem"), A = Number(_.price).toFixed(2), L = Number(_.subtotal).toFixed(2);
        return `
        <li style="border-bottom: 1px solid #f3f4f6; padding: 12px 4px; display: flex; justify-content: space-between; align-items: center;">
          <div style="flex: 1; min-width: 0; padding-right: 8px;">
            <div style="font-weight: 600; color: #1f2937; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" title="${x}">
              ${x}
            </div>
            <div style="font-size: 0.85em; color: #6b7280; margin-top: 2px;">
              $${A} x ${_.quantity}
            </div>
          </div>
          <div style="font-weight: 700; color: #111827; flex-shrink: 0;">
            $${L}
          </div>
        </li>
      `;
      }).join("");
      return `
      <div style="text-align: left; max-height: 260px; overflow-y: auto; font-family: system-ui, -apple-system, sans-serif; padding-right: 4px;">
        <div style="border-bottom: 2px solid #3b82f6; padding-bottom: 8px; margin-bottom: 4px; font-weight: bold; display: flex; justify-content: space-between; color: #4b5563; font-size: 0.9em;">
          <span>${d("menu.item")}</span>
          <span>${d("menu.subtotal")}</span>
        </div>
        <ul style="list-style: none; padding: 0; margin: 0;">${w}</ul>
        <div style="margin-top: 16px; padding-top: 12px; border-top: 2px solid #f3f4f6; text-align: right; display: flex; justify-content: flex-end; align-items: center;">
          <span style="color: #4b5563; margin-right: 8px; font-weight: 500;">${d("menu.orderTotal")}:</span>
          <span style="font-size: 1.4em; font-weight: 800; color: #2563eb;">$${Number(y).toFixed(2)}</span>
        </div>
      </div>`;
    },
    currentQuote: p
  };
}
function mp() {
  const e = (s) => {
    var r, o, a, i;
    return {
      carrier_num: ((r = s.carrier_num) == null ? void 0 : r.trim().toUpperCase()) || "",
      customer_identifier: ((o = s.customer_identifier) == null ? void 0 : o.replace(/\D/g, "").slice(0, 8)) || "",
      customer_name: ((a = s.customer_name) == null ? void 0 : a.trim()) || "",
      customer_email: ((i = s.customer_email) == null ? void 0 : i.trim()) || ""
    };
  }, t = (s) => {
    if (!/^\d{8}$/.test(s)) return !1;
    const r = [1, 2, 1, 2, 1, 2, 4, 1];
    let o = 0, a = 0;
    for (let i = 0; i < 8; i++) {
      const l = parseInt(s.charAt(i), 10) * r[i];
      if (l >= 10) {
        const c = Math.floor(l / 10), h = l % 10;
        i === 6 && c === 7 ? (o += 7, a += 8) : (o += c + h, a += c + h);
      } else
        o += l, a += l;
    }
    return o % 5 === 0 || a % 5 === 0;
  };
  return { normalizeForm: e, validateUBN: t, validateForm: (s) => {
    if (s.carrier_num && !/^\/[0-9A-Z.+-]{7}$/.test(s.carrier_num))
      return "手機條碼格式需為 /ABC1234，共 8 碼";
    if (s.customer_identifier) {
      if (s.customer_identifier.length !== 8) return "統一編號需為 8 碼數字";
      if (!t(s.customer_identifier)) return "統一編號格式驗證失敗";
      if (!s.customer_name) return "填寫統一編號時，請一併填入公司全名";
    }
    return s.customer_email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s.customer_email) ? "CustomerEmail 格式不正確" : "";
  } };
}
function hp(e, t, n, s) {
  const r = z([]), o = z(0);
  let a = null;
  const i = 4e3, l = async (f) => {
    if (!f || !t.value) return;
    await n(f);
    const p = Array.from({ length: 10 }, (g, m) => {
      var _;
      const y = (m + 1).toString();
      if (!((_ = t.value) != null && _[y])) return Promise.resolve(null);
      const d = t.value[y], w = `${s}${f}-${y}?t=${d}`;
      return new Promise((x) => {
        const A = new Image();
        A.src = w, A.onload = () => x(w), A.onerror = () => x(null);
      });
    }), b = await Promise.all(p);
    r.value = b.filter((g) => g !== null);
  }, c = () => {
    a || r.value.length <= 1 || (a = setInterval(() => {
      const f = e.value;
      if (!f) return;
      const p = f.firstElementChild;
      if (!p) return;
      const b = p.offsetWidth + 14;
      o.value = (Math.round(f.scrollLeft / b) + 1) % r.value.length, f.scrollTo({ left: o.value * b, behavior: "smooth" });
    }, i));
  }, h = () => {
    a && (clearInterval(a), a = null);
  };
  return bt(r, (f) => {
    f.length > 1 && setTimeout(c, 1e3);
  }, { immediate: !0 }), qo(h), { activeImages: r, currentIndex: o, checkAndLoadImages: l, startAutoplay: c, stopAutoplay: h };
}
const pp = { class: "flex items-center gap-2 mb-4 px-1" }, gp = { class: "text-sm font-bold text-gray-700 uppercase tracking-widest" }, wp = /* @__PURE__ */ ye({
  __name: "SectionHeader",
  props: {
    title: {},
    color: {}
  },
  setup(e) {
    return (t, n) => ($(), I("div", pp, [
      u("span", {
        class: ke(["w-2 h-2 rounded-full shadow-sm", e.color || "bg-gray-400"])
      }, null, 2),
      u("h3", gp, T(e.title), 1)
    ]));
  }
}), Bo = /* @__PURE__ */ bn(wp, [["__scopeId", "data-v-b70df232"]]), bp = { class: "w-full bg-white border-t border-gray-100 pb-[env(safe-area-inset-bottom,1rem)]" }, yp = { class: "max-w-screen-md mx-auto p-4 flex items-center gap-4" }, vp = { class: "flex-1 flex flex-col" }, _p = { class: "text-[10px] text-blue-700 font-bold uppercase tracking-wider" }, xp = { class: "text-xl font-black text-gray-700" }, Ep = { class: "bg-green-700/50 px-2 py-0.5 rounded text-xs" }, kp = { class: "flex-1 flex flex-col" }, Cp = { class: "text-[10px] text-gray-400 font-bold uppercase tracking-wider" }, Tp = { class: "text-xl font-black text-gray-700" }, Ap = ["disabled"], Op = { class: "flex items-center justify-center gap-2" }, Sp = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 opacity-50",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, Np = /* @__PURE__ */ ye({
  __name: "OrderFooter",
  props: {
    totalPrice: {},
    loading: { type: Boolean },
    selectedIds: {},
    selectedTotal: {},
    showName: {}
  },
  emits: ["submit", "checkout"],
  setup(e) {
    Ce.log("OrderFooter.vue");
    const { t } = Ot();
    return (n, s) => {
      var r, o, a, i, l;
      return $(), I("section", bp, [
        u("div", yp, [
          e.selectedIds && e.selectedIds.length > 0 ? ($(), I(Me, { key: 0 }, [
            u("div", vp, [
              u("span", _p, T((r = k(t)) == null ? void 0 : r("menu.selectedAmount")), 1),
              u("span", xp, "$" + T(e.selectedTotal || 0), 1)
            ]),
            u("button", {
              onClick: s[0] || (s[0] = (c) => n.$emit("checkout")),
              class: "flex-[1.5] relative overflow-hidden bg-green-700 text-white py-4 rounded-2xl font-black shadow-lg shadow-green-100 active:scale-95 transition-all flex items-center justify-center gap-2 border-b-4 border-green-700"
            }, [
              u("span", null, T((o = k(t)) == null ? void 0 : o("order.checkout")), 1),
              u("span", Ep, T(e.selectedIds.length) + " " + T((a = k(t)) == null ? void 0 : a("menu.itemsUnit")), 1)
            ])
          ], 64)) : ($(), I(Me, { key: 1 }, [
            u("div", kp, [
              u("span", Cp, T((i = k(t)) == null ? void 0 : i("menu.subtotal")), 1),
              u("span", Tp, "$" + T(e.totalPrice), 1)
            ]),
            u("button", {
              onClick: s[1] || (s[1] = (c) => n.$emit("submit")),
              disabled: e.loading,
              class: "flex-[1.5] relative overflow-hidden group bg-blue-700 disabled:bg-gray-100 text-white py-4 rounded-2xl font-black shadow-lg shadow-blue-100 active:scale-95 transition-all border-b-4 border-blue-700 disabled:border-gray-700"
            }, [
              s[3] || (s[3] = u("div", { class: "absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-shine pointer-events-none" }, null, -1)),
              u("div", Op, [
                u("span", null, T(e.loading ? (l = k(t)) == null ? void 0 : l("menu.processing") : e.showName), 1),
                e.loading ? X("", !0) : ($(), I("svg", Sp, [...s[2] || (s[2] = [
                  u("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "3",
                    d: "M14 5l7 7m0 0l-7 7m7-7H3"
                  }, null, -1)
                ])]))
              ])
            ], 8, Ap)
          ], 64))
        ])
      ]);
    };
  }
}), Wi = /* @__PURE__ */ bn(Np, [["__scopeId", "data-v-ab532642"]]), zi = /* @__PURE__ */ ye({
  __name: "AddButton",
  emits: ["click"],
  setup(e) {
    return (t, n) => ($(), I("button", {
      type: "button",
      onClick: n[0] || (n[0] = (s) => t.$emit("click")),
      class: "menu-action-btn"
    }, [...n[1] || (n[1] = [
      u("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "w-5 h-5",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor"
      }, [
        u("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2.5",
          d: "M12 4v16m8-8H4"
        })
      ], -1)
    ])]));
  }
}), Yi = /* @__PURE__ */ ye({
  __name: "RemoveButton",
  emits: ["click"],
  setup(e) {
    return (t, n) => ($(), I("button", {
      type: "button",
      onClick: n[0] || (n[0] = (s) => t.$emit("click")),
      class: "menu-action-btn bg-white text-blue-700 border border-blue-100"
    }, [...n[1] || (n[1] = [
      u("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "w-5 h-5",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor"
      }, [
        u("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2.5",
          d: "M20 12H4"
        })
      ], -1)
    ])]));
  }
}), $p = { class: "space-y-3" }, Lp = { class: "flex-1" }, Ip = { class: "font-bold text-gray-700" }, Pp = {
  key: 0,
  class: "text-xs bg-sky-700 text-white"
}, Dp = { class: "text-blue-700 font-mono font-bold text-lg" }, Mp = { class: "menu-controls-pill flex items-center bg-gray-100 rounded-full px-2 py-1 gap-2" }, Rp = {
  key: 1,
  class: "text-lg font-black text-gray-700 min-w-[1.5rem] text-center tabular-nums"
}, Fp = /* @__PURE__ */ ye({
  __name: "MenuItemList",
  props: {
    items: {},
    cart: {},
    totalCount: {},
    onAdd: { type: Function },
    onRemove: { type: Function }
  },
  setup(e) {
    const { t } = Ot(), n = e;
    return me(() => Object.values(n.cart).reduce((s, r) => s + r, 0)), (s, r) => {
      var o, a;
      return $(), I("main", $p, [
        ($(!0), I(Me, null, ze(e.items, (i) => ($(), I("div", {
          key: i.id,
          class: "menu-item-row flex items-center justify-between p-3 bg-white rounded-lg shadow-sm"
        }, [
          u("div", Lp, [
            u("h3", Ip, T(i.name), 1),
            i.description ? ($(), I("p", Pp, T(i.description), 1)) : X("", !0),
            u("p", Dp, "$ " + T(i.price), 1)
          ]),
          u("div", Mp, [
            e.cart[i.id] ? ($(), it(Yi, {
              key: 0,
              onClick: (l) => e.onRemove(i.id)
            }, null, 8, ["onClick"])) : X("", !0),
            e.cart[i.id] ? ($(), I("span", Rp, T(e.cart[i.id]), 1)) : X("", !0),
            (e.cart[i.id] || 0) < 7 && e.totalCount < 20 ? ($(), it(zi, {
              key: 2,
              onClick: (l) => e.onAdd(i.id)
            }, null, 8, ["onClick"])) : X("", !0)
          ])
        ]))), 128)),
        e.totalCount >= 10 ? ($(), I("div", {
          key: 0,
          class: ke(["text-right text-[10px] font-bold", e.totalCount >= 20 ? "text-red-700" : "text-orange-400"])
        }, T((o = k(t)) == null ? void 0 : o("menu.currentNum")) + ": " + T(e.totalCount) + " / 20 " + T(e.totalCount >= 20 ? (a = k(t)) == null ? void 0 : a("menu.orderMaxNum") : ""), 3)) : X("", !0)
      ]);
    };
  }
}), Bp = { class: "sticky top-0 z-30 bg-white/80 backdrop-blur-xl border-b py-4 mb-6 shadow-sm -mx-4 px-4" }, Up = { class: "flex justify-between max-w-screen-md mx-auto" }, Vp = { class: "flex items-center gap-3 cursor-pointer" }, Hp = ["checked", "indeterminate"], jp = { class: "text-sm font-black" }, qp = { class: "text-[10px] text-gray-400" }, Wp = { class: "text-right" }, zp = { class: "text-[10px] text-gray-400" }, Yp = { class: "text-2xl font-black text-blue-700" }, Kp = /* @__PURE__ */ ye({
  __name: "OrderListHeader",
  props: {
    isAllSelected: { type: Boolean },
    isIndeterminate: { type: Boolean },
    selectedCount: {},
    total: {},
    t: { type: Function }
  },
  emits: ["toggle-all"],
  setup(e) {
    const t = e, n = (s) => {
      var r;
      return ((r = t.t) == null ? void 0 : r.call(t, s)) ?? s;
    };
    return (s, r) => ($(), I("div", Bp, [
      u("div", Up, [
        u("label", Vp, [
          u("input", {
            type: "checkbox",
            checked: e.isAllSelected,
            indeterminate: e.isIndeterminate,
            onChange: r[0] || (r[0] = (o) => s.$emit("toggle-all")),
            class: "w-6 h-6 rounded-lg"
          }, null, 40, Hp),
          u("div", null, [
            u("div", jp, T(n("checkoutBar.selectAll")), 1),
            u("div", qp, T(n("checkoutBar.itemsSelected").replace("{count}", String(e.selectedCount))), 1)
          ])
        ]),
        u("div", Wp, [
          u("div", zp, T(n("checkoutBar.totalAmount")), 1),
          u("div", Yp, " $" + T(Number(e.total).toLocaleString()), 1)
        ])
      ])
    ]));
  }
}), Gp = /* @__PURE__ */ ye({
  __name: "ItemStatusControl",
  props: {
    status: {},
    isLocked: { type: Boolean },
    isSmall: { type: Boolean },
    ostatus: {},
    showAdd: { type: Boolean, default: !0 }
  },
  emits: ["change"],
  setup(e) {
    const t = e, n = me(
      () => Yo(t.status)
    ), s = me(
      () => t.status !== Nt.SERVED && En.includes(t.status)
    ), r = me(
      () => t.ostatus === Re.NEW && t.status !== Nt.CANCEL && En.includes(t.status) || t.ostatus === Re.PAID && t.status !== Nt.NEW && En.includes(t.status)
    ), o = (a) => [
      "w-7 h-7 flex items-center justify-center transition-all duration-100",
      a ? "opacity-40 grayscale contrast-50 cursor-not-allowed scale-95 pointer-events-none" : "opacity-100 grayscale-0 active:scale-90"
    ];
    return (a, i) => ($(), I("div", {
      class: ke(["menu-controls-pill bg-white shadow-sm flex items-center px-1", [
        e.isSmall ? "min-w-[110px] h-8" : "min-w-[120px]",
        e.showAdd ? "justify-between" : "justify-center"
      ]])
    }, [
      e.showAdd ? ($(), it(Yi, {
        key: 0,
        disabled: !r.value || e.isLocked,
        onClick: i[0] || (i[0] = (l) => a.$emit("change", -1)),
        class: ke(o(!r.value || e.isLocked))
      }, null, 8, ["disabled", "class"])) : X("", !0),
      u("span", {
        class: ke([
          "text-[10px] font-black px-2 py-0.5 rounded-full text-center min-w-[50px]",
          e.isLocked ? "bg-gray-100 text-gray-400" : n.value.color
        ])
      }, T(n.value.text), 3),
      e.showAdd ? ($(), it(zi, {
        key: 1,
        disabled: !s.value || e.isLocked,
        onClick: i[1] || (i[1] = (l) => a.$emit("change", 1)),
        class: ke(o(!s.value || e.isLocked))
      }, null, 8, ["disabled", "class"])) : X("", !0)
    ], 2));
  }
});
function Xp() {
  const e = z({});
  return {
    expandedGroups: e,
    getGroupedItems: (a) => a ? a.reduce((i, l) => (i[l.item_name] || (i[l.item_name] = []), i[l.item_name].push(l), i), {}) : {},
    getItemTotal: (a) => a.reduce((i, l) => l.status !== Nt.CANCEL ? i + Number(l.unit_price) : i, 0),
    toggleGroup: (a, i) => {
      const l = `${a}-${i}`;
      e.value[l] = !e.value[l];
    },
    isExpanded: (a, i) => !!e.value[`${a}-${i}`],
    getStatusInfo: (a) => Yo(a) || { text: "未知", color: "bg-gray-100 text-gray-600" }
  };
}
const Jp = { class: "flex gap-4" }, Zp = { class: "pt-1" }, Qp = ["checked", "disabled"], eg = { class: "flex-1 flex flex-col gap-2" }, tg = { class: "flex items-center gap-3" }, ng = {
  key: 0,
  class: "bg-blue-700 text-white text-[10px] font-black px-2 py-0.5 rounded-full"
}, sg = {
  key: 1,
  class: "bg-blue-700 text-white text-[10px] font-black px-2 py-0.5 rounded-full"
}, rg = {
  key: 2,
  class: "text-xs font-black text-gray-700 bg-amber-100 px-2 py-0.5 rounded-md border border-amber-200"
}, og = { class: "font-mono text-xs font-bold text-gray-400" }, ag = { class: "flex items-center gap-2 text-[10px] font-bold text-gray-400" }, ig = { class: "text-blue-700" }, lg = { class: "flex items-center justify-between" }, cg = { class: "text-right" }, ug = { class: "text-[10px] text-gray-400 font-bold block leading-none" }, dg = { class: "text-blue-700 font-black text-lg tracking-tight" }, fg = {
  key: 0,
  class: "mt-1 flex items-start gap-2 bg-gray-50 border-l-4 border-amber-400 p-2 rounded-r-lg"
}, mg = { class: "text-[11px] leading-relaxed font-bold text-gray-600 italic" }, hg = { class: "space-y-3" }, pg = ["onClick"], gg = { class: "flex items-center gap-2" }, wg = { class: "text-gray-700 font-bold" }, bg = {
  key: 0,
  class: "text-[10px] bg-blue-50 text-blue-700 px-1.5 py-0.5 rounded-md font-black"
}, yg = { class: "flex items-center gap-3" }, vg = {
  key: 0,
  class: "flex items-center gap-1"
}, _g = { class: "text-[10px] text-gray-400 font-bold" }, xg = { class: "font-mono font-bold text-gray-900 min-w-[45px] text-right" }, Eg = {
  key: 0,
  class: "mt-2 ml-4 space-y-2 border-l-2 border-blue-50 pl-3 py-1"
}, kg = { class: "flex items-center gap-3" }, Cg = { class: "font-mono font-bold text-gray-400 text-xs min-w-[35px] text-right" }, Ki = /* @__PURE__ */ ye({
  __name: "OrderCard",
  props: {
    order: {},
    isSelected: { type: Boolean },
    sessionIndex: {},
    index: {},
    length: {},
    showAdd: { type: Boolean },
    disableStatus: {},
    disabled: { type: Boolean }
  },
  emits: ["status-change", "toggle-selection"],
  setup(e) {
    const t = localStorage.getItem("merchant_tz") || "UTC", { t: n } = Ot();
    Ce.log("OrderCard.vue");
    const s = (l, c) => l !== Nt.CANCEL ? c : 0, { getGroupedItems: r, getItemTotal: o, toggleGroup: a, isExpanded: i } = Xp();
    return (l, c) => {
      var h, f, p;
      return $(), I("div", {
        class: ke(["menu-history-card flex flex-col gap-4 p-4 transition-all border rounded-2xl bg-white", {
          "ring-2 ring-blue-700 bg-blue-50/30 border-transparent": e.isSelected,
          "border-gray-100": !e.isSelected,
          "opacity-50 pointer-events-none bg-gray-50/50": e.disabled
        }])
      }, [
        u("div", Jp, [
          u("div", Zp, [
            u("input", {
              type: "checkbox",
              checked: e.isSelected,
              onChange: c[0] || (c[0] = (b) => l.$emit("toggle-selection", e.order.id)),
              disabled: e.disabled || e.disableStatus !== void 0 && e.order.status === e.disableStatus,
              class: "menu-checkbox w-5 h-5 rounded border-gray-700 text-blue-700 focus:ring-blue-700 disabled:border-gray-300 disabled:bg-gray-100 disabled:cursor-not-allowed"
            }, null, 40, Qp)
          ]),
          u("div", eg, [
            u("div", tg, [
              e.sessionIndex ? ($(), I("span", ng, " #" + T(e.sessionIndex), 1)) : ($(), I("span", sg, " #" + T(e.index + 1), 1)),
              (h = e.order.info) != null && h.nickname ? ($(), I("span", rg, " 👤 " + T(e.order.info.nickname), 1)) : X("", !0),
              u("span", og, T(String(e.order.id).slice(-3)), 1),
              u("div", ag, [
                c[1] || (c[1] = u("span", { class: "text-gray-700" }, "|", -1)),
                u("span", ig, T(k(Ko)(e.order.created_at, k(t))), 1)
              ])
            ]),
            u("div", lg, [
              u("span", {
                class: ke([
                  "text-[10px] px-2 py-0.5 rounded-md font-black uppercase tracking-wider shadow-sm",
                  k(Ds)(e.order.status).color
                ])
              }, T(k(Ds)(e.order.status).text), 3),
              u("div", cg, [
                u("span", ug, T(((f = k(n)) == null ? void 0 : f("order.subtotal")) ?? "SUBTOTAL"), 1),
                u("span", dg, " $" + T(e.order.subtotal), 1)
              ])
            ]),
            (p = e.order.info) != null && p.memo1 ? ($(), I("div", fg, [
              c[2] || (c[2] = u("span", { class: "text-xs" }, "📝", -1)),
              u("p", mg, T(e.order.info.memo1), 1)
            ])) : X("", !0)
          ])
        ]),
        c[4] || (c[4] = u("hr", { class: "border-gray-50" }, null, -1)),
        u("div", hg, [
          ($(!0), I(Me, null, ze(k(r)(e.order.items), (b, g) => {
            var m, y;
            return $(), I("div", {
              key: g,
              class: "border-b border-gray-50 last:border-0 pb-2"
            }, [
              u("div", {
                class: "flex justify-between items-center text-sm cursor-pointer hover:bg-gray-50/50 rounded-lg p-1 transition-colors",
                onClick: (d) => b.length > 0 ? k(a)(e.order.id, g) : null
              }, [
                u("div", gg, [
                  u("span", wg, T(g), 1),
                  b.length > 0 ? ($(), I("span", bg, " x" + T(b.length), 1)) : X("", !0)
                ]),
                u("div", yg, [
                  b.length > 0 ? ($(), I("div", vg, [
                    u("span", _g, T(k(i)(e.order.id, g) ? ((m = k(n)) == null ? void 0 : m("common.collapse")) ?? "收" : ((y = k(n)) == null ? void 0 : y("common.expand")) ?? "開"), 1),
                    ($(), I("svg", {
                      class: ke(["w-3 h-3 text-gray-700 transition-transform duration-700", { "rotate-180": k(i)(e.order.id, g) }]),
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor"
                    }, [...c[3] || (c[3] = [
                      u("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "3",
                        d: "M19 9l-7 7-7-7"
                      }, null, -1)
                    ])], 2))
                  ])) : X("", !0),
                  u("span", xg, " $" + T(k(o)(b)), 1)
                ])
              ], 8, pg),
              b.length > 0 && k(i)(e.order.id, g) ? ($(), I("div", Eg, [
                ($(!0), I(Me, null, ze(b, (d) => ($(), I("div", {
                  key: d.id,
                  class: "flex justify-between items-center text-sm"
                }, [
                  u("div", kg, [
                    ot(Gp, {
                      "is-small": "",
                      "show-add": e.showAdd,
                      status: d.status,
                      ostatus: e.order.status,
                      "is-locked": e.isSelected,
                      onChange: (w) => l.$emit("status-change", e.order, d.id, w)
                    }, null, 8, ["show-add", "status", "ostatus", "is-locked", "onChange"]),
                    u("span", Cg, " $" + T(s(d.status, d.unit_price)), 1)
                  ])
                ]))), 128))
              ])) : X("", !0)
            ]);
          }), 128))
        ])
      ], 2);
    };
  }
}), Tg = {
  key: 0,
  class: "relative pb-[env(safe-area-inset-bottom,80px)]"
}, Ag = { class: "space-y-6 max-w-screen-md mx-auto" }, Og = /* @__PURE__ */ ye({
  __name: "OrderHistoryList",
  props: {
    orders: {},
    selectedIds: {},
    t: { type: Function }
  },
  emits: ["selection-change"],
  setup(e, { emit: t }) {
    Ce.log("OrderHistoryList.vue");
    const n = e, s = t, r = (d) => String(d), o = me(() => new Set(n.selectedIds.map(r))), a = me(() => {
      if (n.selectedIds.length === 0) return null;
      const d = n.orders.find((w) => c(w.id));
      return d ? d.status : null;
    }), i = (d) => d.status === Re.PAID ? !0 : a.value === null || c(d.id) ? !1 : d.status !== a.value, l = me(() => a.value === null ? n.orders.filter((d) => d.status !== Re.PAID) : n.orders.filter((d) => d.status === a.value)), c = (d) => o.value.has(r(d)), h = me(
      () => n.orders.filter((d) => c(d.id)).reduce((d, w) => d + Number(w.subtotal || 0), 0)
    ), f = me(
      () => l.value.length > 0 && l.value.every((d) => c(d.id))
    ), p = me(() => {
      const d = l.value.filter((w) => c(w.id)).length;
      return d > 0 && d < l.value.length;
    }), b = (d) => {
      const _ = n.orders.filter((x) => d.includes(x.id)).reduce((x, A) => x.plus(new Pt(A.subtotal || "0")), new Pt(0));
      s("selection-change", {
        ids: d,
        total: _.toFixed(2)
      });
    }, g = (d) => {
      if (Ce.log("toggleSelection", d), d.status === Re.PAID || !c(d.id) && a.value !== null && d.status !== a.value)
        return;
      const w = [...n.selectedIds], _ = w.indexOf(d.id);
      _ === -1 ? w.push(d.id) : w.splice(_, 1), b(w);
    }, m = () => {
      if (f.value) {
        const d = new Set(
          l.value.map((w) => r(w.id))
        );
        b(
          n.selectedIds.filter(
            (w) => !d.has(r(w))
          )
        );
      } else
        b([
          .../* @__PURE__ */ new Set([
            ...n.selectedIds.map(r),
            ...l.value.map((d) => r(d.id))
          ])
        ]);
    };
    z({});
    const y = (...d) => {
    };
    return (d, w) => e.orders.length ? ($(), I("div", Tg, [
      ot(Kp, {
        "is-all-selected": f.value,
        "is-indeterminate": p.value,
        "selected-count": e.selectedIds.length,
        total: h.value,
        t: e.t,
        onToggleAll: m
      }, null, 8, ["is-all-selected", "is-indeterminate", "selected-count", "total", "t"]),
      u("div", Ag, [
        ($(!0), I(Me, null, ze(e.orders, (_, x) => ($(), it(Ki, {
          key: _.id,
          order: _,
          length: e.orders.length,
          index: e.orders.length - x - 1,
          "is-selected": c(_.id),
          showAdd: !1,
          disableStatus: k(Re).PAID,
          disabled: i(_),
          onToggleSelection: () => g(_),
          onStatusChange: y
        }, null, 8, ["order", "length", "index", "is-selected", "disableStatus", "disabled", "onToggleSelection"]))), 128))
      ])
    ])) : X("", !0);
  }
}), Sg = { class: "sticky top-0 z-30 w-full bg-white/90 backdrop-blur-md shadow-sm border-b border-gray-100/50 pt-safe-top transition-all" }, Ng = { class: "max-w-screen-md mx-auto px-5 py-4 flex items-center justify-between" }, $g = { class: "space-y-0.5" }, Lg = { class: "text-2xl text-blue-700 font-black tracking-widest block font-sans" }, Ig = {
  key: 0,
  class: "text-xs text-blue-700/80 font-medium tracking-wide block truncate max-w-[220px]"
}, Pg = { class: "inline-flex items-center gap-1.5 mt-1 bg-gray-100 px-2.5 py-1 rounded-full" }, Dg = { class: "text-xs font-bold text-gray-700" }, Mg = ["disabled"], Rg = /* @__PURE__ */ ye({
  __name: "MerchantHeader",
  props: {
    menuData: {},
    historyLoading: { type: Boolean },
    t: { type: Function }
  },
  emits: ["refresh"],
  setup(e) {
    return (t, n) => ($(), I("header", Sg, [
      u("div", Ng, [
        u("div", $g, [
          u("span", Lg, T(e.menuData.merchant_name), 1),
          e.menuData.memo1 ? ($(), I("span", Ig, T(e.menuData.memo1), 1)) : X("", !0),
          u("div", Pg, [
            n[1] || (n[1] = u("span", { class: "w-1.5 h-1.5 rounded-full bg-green-700 animate-pulse" }, null, -1)),
            u("h1", Dg, T(e.t("order.tableNumber")) + ": " + T(e.menuData.tableNumber), 1)
          ])
        ]),
        u("button", {
          onClick: n[0] || (n[0] = (s) => t.$emit("refresh")),
          disabled: e.historyLoading,
          class: "p-3.5 bg-gray-100 hover:bg-gray-100/80 active:scale-90 rounded-2xl transition-all disabled:opacity-50 flex items-center justify-center shadow-inner"
        }, [
          u("span", {
            class: ke([{ "animate-spin": e.historyLoading }, "text-lg leading-none select-none"])
          }, "🔄", 2)
        ], 8, Mg)
      ])
    ]));
  }
}), Fg = { class: "flex items-center gap-2 mb-1" }, Bg = { class: "text-sm font-black text-gray-800 tracking-wide uppercase" }, Ug = /* @__PURE__ */ ye({
  __name: "BlockSectionHeader",
  props: {
    title: {},
    color: {}
  },
  setup(e) {
    return (t, n) => ($(), I("div", Fg, [
      u("span", {
        class: ke(["w-1 h-4 rounded-full", e.color || "bg-blue-700"])
      }, null, 2),
      u("h2", Bg, T(e.title), 1)
    ]));
  }
}), Vg = { class: "bg-white p-5 rounded-3xl shadow-sm space-y-4" }, Hg = { class: "space-y-4 pt-1" }, jg = { class: "flex flex-col gap-1.5" }, qg = { class: "flex justify-between items-center px-1" }, Wg = {
  for: "nickname",
  class: "text-xs font-black text-gray-700 uppercase tracking-wider"
}, zg = { class: "text-[10px] font-bold text-gray-700/60" }, Yg = ["placeholder"], Kg = { class: "flex flex-col gap-1.5" }, Gg = { class: "flex justify-between items-center px-1" }, Xg = {
  for: "memo",
  class: "text-xs font-black text-gray-700 uppercase tracking-wider"
}, Jg = { class: "text-[10px] font-bold text-gray-700/60" }, Zg = ["placeholder"], Qg = /* @__PURE__ */ ye({
  __name: "OrderMemoForm",
  props: {
    modelValue: {},
    t: { type: Function }
  },
  setup(e) {
    return (t, n) => ($(), I("section", Vg, [
      ot(Ug, {
        title: e.t("order.additionalInfo"),
        color: "bg-gray-700"
      }, null, 8, ["title"]),
      u("div", Hg, [
        u("div", jg, [
          u("div", qg, [
            u("label", Wg, T(e.t("order.nickname")), 1),
            u("div", zg, T(e.modelValue.nickname.length) + " / 50 ", 1)
          ]),
          Qe(u("input", {
            id: "nickname",
            "onUpdate:modelValue": n[0] || (n[0] = (s) => e.modelValue.nickname = s),
            type: "text",
            maxlength: "50",
            placeholder: e.t("order.nicknamePlaceholder"),
            class: "w-full p-3.5 bg-gray-100 rounded-2xl focus:bg-white focus:ring-2 focus:ring-blue-700 outline-none transition-all duration-200 text-sm font-medium text-gray-700 shadow-inner"
          }, null, 8, Yg), [
            [pt, e.modelValue.nickname]
          ])
        ]),
        u("div", Kg, [
          u("div", Gg, [
            u("label", Xg, T(e.t("order.specialInstructions")), 1),
            u("div", Jg, T(e.modelValue.memo1.length) + " / 255 ", 1)
          ]),
          Qe(u("textarea", {
            id: "memo",
            "onUpdate:modelValue": n[1] || (n[1] = (s) => e.modelValue.memo1 = s),
            maxlength: "255",
            placeholder: e.t("order.memoPlaceholder"),
            rows: "3",
            class: "w-full p-3.5 bg-gray-100 rounded-2xl focus:bg-white focus:ring-2 focus:ring-blue-700 outline-none transition-all duration-200 resize-none text-sm font-medium text-gray-700 shadow-inner"
          }, null, 8, Zg), [
            [pt, e.modelValue.memo1]
          ])
        ])
      ])
    ]));
  }
}), ew = { class: "flex flex-col min-h-dvh bg-gray-100 text-gray-700 overflow-x-hidden pb-safe-bottom tap-none" }, tw = { class: "flex-1 w-full max-w-screen-md mx-auto px-4 py-5 space-y-6" }, nw = {
  key: 0,
  class: "mt-1"
}, sw = { class: "relative overflow-hidden rounded-3xl shadow-sm bg-white w-full" }, rw = ["src", "onClick"], ow = { class: "absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-[10px] font-black text-blue-700 shadow-sm border border-white/50" }, aw = {
  key: 1,
  class: "bg-red-100 text-red-700 p-4 rounded-2xl border border-red-100/50 text-sm font-medium shadow-sm animate-fade-in"
}, iw = {
  key: 2,
  class: "bg-white p-4 rounded-3xl shadow-sm"
}, lw = { class: "sticky top-[100px] z-20 -mx-4 px-4 py-2 bg-gray-100/80 backdrop-blur-md flex gap-2 overflow-x-auto no-scrollbar scroll-touch" }, cw = ["onClick"], uw = { class: "bg-white p-4 rounded-3xl shadow-sm" }, dw = {
  key: 1,
  class: "py-16 text-center text-gray-700 font-medium"
}, fw = {
  key: 1,
  class: "bg-white border-t border-gray-100 shadow-[0_-4px_24px_rgba(0,0,0,0,04)] pt-5 pb-4"
}, mw = { class: "max-w-screen-md mx-auto px-5" }, hw = { class: "mt-6 flex flex-col items-center gap-3 pb-4" }, pw = { class: "text-[9px] font-medium tracking-wider text-gray-700/40 uppercase" }, gw = {
  key: 0,
  class: "w-full mt-4 pt-4 border-t border-gray-100/80 text-center"
}, ww = { class: "text-amber-700 font-black" }, bw = { class: "block text-[11px] text-amber-700 font-medium mt-0.5" }, Uo = "px-4 py-2 rounded-xl text-xs font-bold whitespace-nowrap transition-all duration-200 active:scale-[0.97] select-none shadow-sm", Vo = "bg-blue-700 text-white shadow-md shadow-blue-700/10", Ho = "bg-white text-gray-700 pointer-hover:hover:bg-blue-100/50", av = /* @__PURE__ */ ye({
  __name: "MenuOrderPage",
  props: {
    menuApi: {},
    orderApi: {},
    qr: {},
    t: { type: Function },
    baseUrl: {}
  },
  setup(e) {
    Ce.log("MenuOrderPage.vue initialized");
    const t = e, n = (oe) => {
      var se;
      return ((se = t.t) == null ? void 0 : se.call(t, oe)) ?? oe;
    }, s = z(null), r = [
      "1de956ad-ea63-4e74-853a-8b24b4ef3d26",
      "8aaf84df-4d4f-436c-bd70-963a440f0448",
      "8cba5a9b-7007-4a4c-830e-01d402f1ccc0",
      "030b9e3e-4c90-43e4-8a1a-b7c90d4ce37d"
    ], o = zo({ nickname: "", memo1: "" }), {
      menuData: a,
      loading: i,
      error: l,
      cart: c,
      totalCounter: h,
      loadMenu: f,
      addToCart: p,
      removeFromCart: b,
      totalPrice: g,
      handleOrderSubmit: m,
      handlePaymentSubmit: y,
      images: d,
      loadImg: w,
      queryCompanyName: _
    } = ji(t.menuApi), {
      historyLoading: x,
      historyError: A,
      orderHistory: L,
      cumulativeTotal: C,
      loadOrderHistorySession: F
    } = qi(t.orderApi), {
      selectedCategory: D,
      availableCategories: j,
      filteredItems: q,
      formatOrderHtml: ne,
      currentQuote: De,
      selectedOrderIds: V,
      handleSelectionChange: U,
      selectedTotal: R
    } = fp(a, c, g), { normalizeForm: W, validateForm: B, validateUBN: J } = mp(), { activeImages: K, checkAndLoadImages: ee, startAutoplay: re, stopAutoplay: de } = hp(s, d, w, t.baseUrl), ve = me(() => {
      var oe;
      return r.includes(((oe = a.value) == null ? void 0 : oe.merchantId) ?? "");
    }), Te = me(() => {
      var oe, se;
      return (se = (oe = L.value.find((ae) => {
        var Q;
        return (Q = ae.info) == null ? void 0 : Q.nickname;
      })) == null ? void 0 : oe.info) == null ? void 0 : se.nickname;
    }), dt = () => U({ ids: [], total: "0" }), st = () => {
      var oe, se, ae, Q;
      return W({
        carrier_num: (oe = document.getElementById("checkout-carrier-num")) == null ? void 0 : oe.value,
        customer_identifier: (se = document.getElementById("checkout-customer-identifier")) == null ? void 0 : se.value,
        customer_name: (ae = document.getElementById("checkout-customer-name")) == null ? void 0 : ae.value,
        customer_email: (Q = document.getElementById("checkout-customer-email")) == null ? void 0 : Q.value
      });
    };
    bt(Te, (oe) => {
      oe && !o.nickname && (o.nickname = oe);
    }, { immediate: !0 });
    const ft = async () => {
      var se;
      if (((se = a.value) == null ? void 0 : se.pStatus) !== !0)
        return dt(), we.fire(n("order.checkoutDisabledTitle"), n("order.checkoutDisabledText"), "warning");
      if (V.value.length === 0)
        return we.fire(n("order.noOrderSelectedTitle"), n("order.noOrderSelectedText"), "warning");
      (await we.fire({
        title: n("order.confirmCheckout"),
        html: wu(
          V.value.length,
          R.value,
          n
        ),
        icon: "info",
        showCancelButton: !0,
        confirmButtonText: n("order.checkoutNow"),
        cancelButtonText: n("common.cancel"),
        confirmButtonColor: "#15803d",
        reverseButtons: !0,
        showLoaderOnConfirm: !0,
        didOpen: () => {
          const ae = document.getElementById("checkout-customer-identifier"), Q = document.getElementById("checkout-carrier-num"), ge = document.getElementById("checkout-customer-name");
          ae == null || ae.addEventListener("input", async () => {
            let Ke = ae.value.replace(/\D/g, "").slice(0, 8);
            if (ae.value = Ke, Ke.length === 8 && J(Ke)) {
              ge && (ge.placeholder = "查詢中...");
              try {
                const Ve = await _(Ke);
                ge && (ge.value = (Ve == null ? void 0 : Ve.Company_Name) || ""), !(Ve != null && Ve.Company_Name) && ge && (ge.placeholder = "查無公司名稱，請手動輸入");
              } catch {
                ge && (ge.placeholder = "查詢失敗，請手動輸入");
              }
            }
          }), Q == null || Q.addEventListener("input", () => {
            Q.value = Q.value.trim().toUpperCase().slice(0, 8);
          });
        },
        preConfirm: async () => {
          var v;
          const ae = st(), Q = B(ae);
          if (Q)
            return we.showValidationMessage(Q), !1;
          await F(t.qr);
          const ge = L.value.map((E) => String(E.id));
          if (!V.value.every((E) => ge.includes(String(E))))
            return V.value = [], we.showValidationMessage(n("order.statusChanged")), !1;
          const Ve = await y({
            qr: t.qr,
            ids: V.value.map(String),
            merchant_id: ((v = a.value) == null ? void 0 : v.merchantId) ?? "",
            ...ae
          });
          return Ve || (dt(), we.showValidationMessage(n("order.checkoutFailed"))), Ve;
        }
      })).isConfirmed && we.fire({ title: n("order.checkoutSubmitted"), text: n("order.checkoutProcessing"), icon: "success", timer: 2e3, showConfirmButton: !1 });
    }, rt = async () => {
      if (L.value.length >= 3)
        return we.fire({ title: n("order.tooManyOrdersTitle"), text: n("order.tooManyOrdersText"), icon: "error" });
      const oe = Object.entries(c).map(([ae, Q]) => {
        var Ve;
        const ge = (Ve = a.value) == null ? void 0 : Ve.items.find((v) => v.id === ae), Ke = (ge == null ? void 0 : ge.price) || "0";
        return {
          menu_item_id: ae,
          name: ge == null ? void 0 : ge.name,
          price: Ke,
          quantity: Q,
          subtotal: new Pt(Ke).times(Q).toFixed(2)
        };
      }).filter((ae) => ae.quantity > 0);
      if (oe.length === 0) return;
      (await we.fire({
        title: n("order.confirmOrder"),
        html: ne(oe, g.value, n) || "請確認您的訂單內容",
        icon: "question",
        showCancelButton: !0,
        confirmButtonText: n("common.ok"),
        cancelButtonText: n("common.cancel"),
        confirmButtonColor: "#1d4ed8",
        reverseButtons: !0,
        heightAuto: !1,
        returnFocus: !1
      })).isConfirmed && await m(t.qr, { nickname: o.nickname, memo1: o.memo1 }) && (Object.keys(c).forEach((Q) => delete c[Q]), h.value = 0, await F(t.qr));
    }, Ae = (oe) => {
      we.fire({
        imageUrl: oe,
        showConfirmButton: !1,
        showCloseButton: !0,
        allowOutsideClick: !0,
        allowEscapeKey: !0,
        imageWidth: "95%",
        customClass: { popup: "border-none shadow-none bg-transparent", image: "animate__animated animate__zoomIn rounded-3xl shadow-2xl" }
      });
    };
    return Dt(async () => {
      var oe;
      t.qr && (await f(t.qr), await F(t.qr), await ee((oe = a.value) == null ? void 0 : oe.merchantId));
    }), (oe, se) => {
      const ae = tr("router-link");
      return $(), I("div", ew, [
        k(a) ? ($(), it(Rg, {
          key: 0,
          "menu-data": k(a),
          "history-loading": k(x),
          t: n,
          onRefresh: se[0] || (se[0] = (Q) => k(F)(t.qr))
        }, null, 8, ["menu-data", "history-loading"])) : X("", !0),
        u("main", tw, [
          k(K).length > 0 ? ($(), I("section", nw, [
            u("div", {
              ref_key: "scrollContainer",
              ref: s,
              class: "flex gap-3.5 overflow-x-auto no-scrollbar snap-x snap-mandatory px-4 -mx-4 pb-1 scroll-touch",
              style: { "scroll-behavior": "smooth" },
              onMouseenter: se[1] || (se[1] = //@ts-ignore
              (...Q) => k(de) && k(de)(...Q)),
              onMouseleave: se[2] || (se[2] = //@ts-ignore
              (...Q) => k(re) && k(re)(...Q)),
              onTouchstart: se[3] || (se[3] = //@ts-ignore
              (...Q) => k(de) && k(de)(...Q)),
              onTouchend: se[4] || (se[4] = //@ts-ignore
              (...Q) => k(re) && k(re)(...Q))
            }, [
              ($(!0), I(Me, null, ze(k(K), (Q, ge) => ($(), I("div", {
                key: Q,
                class: "flex-none w-full snap-center"
              }, [
                u("div", sw, [
                  u("img", {
                    src: Q,
                    class: "w-full h-auto block transition-transform duration-500 active:scale-98",
                    onClick: (Ke) => Ae(Q)
                  }, null, 8, rw),
                  se[7] || (se[7] = u("div", { class: "absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/40 via-black/10 to-transparent pointer-events-none" }, null, -1)),
                  u("div", ow, T(ge + 1) + " / " + T(k(K).length), 1)
                ])
              ]))), 128))
            ], 544)
          ])) : X("", !0),
          k(l) || k(A) ? ($(), I("div", aw, " ⚠️ " + T(k(l) || k(A)), 1)) : X("", !0),
          k(L).length > 0 ? ($(), I("section", iw, [
            ot(Bo, {
              title: n("order.orderHistory"),
              color: "bg-blue-700",
              class: "mb-3"
            }, null, 8, ["title"]),
            k(x) ? X("", !0) : ($(), it(Og, {
              key: 0,
              orders: k(L),
              t: n,
              "selected-ids": k(V),
              "total-accumulated": k(C),
              onSelectionChange: k(U)
            }, null, 8, ["orders", "selected-ids", "total-accumulated", "onSelectionChange"]))
          ])) : X("", !0),
          u("nav", lw, [
            u("button", {
              onClick: se[5] || (se[5] = (Q) => D.value = "All"),
              class: ke([Uo, k(D) === "All" ? Vo : Ho])
            }, T(n("menu.all")), 3),
            ($(!0), I(Me, null, ze(k(j), (Q) => ($(), I("button", {
              key: Q,
              onClick: (ge) => D.value = Q,
              class: ke([Uo, k(D) === Q ? Vo : Ho])
            }, T(Q), 11, cw))), 128))
          ]),
          u("section", uw, [
            ot(Bo, {
              title: k(D) === "All" ? n("order.menuToday") : k(D),
              color: "bg-green-700",
              class: "mb-4"
            }, null, 8, ["title"]),
            k(a) ? ($(), it(Fp, {
              key: 0,
              items: k(q),
              cart: k(c),
              totalCount: k(h),
              "on-add": k(p),
              "on-remove": k(b)
            }, null, 8, ["items", "cart", "totalCount", "on-add", "on-remove"])) : X("", !0),
            k(q).length === 0 && !k(i) ? ($(), I("div", dw, " ☕ " + T(n("menu.emptyCategory")), 1)) : X("", !0)
          ]),
          ot(Qg, {
            modelValue: o,
            "onUpdate:modelValue": se[6] || (se[6] = (Q) => o = Q),
            t: n
          }, null, 8, ["modelValue"])
        ]),
        k(a) ? ($(), I("footer", fw, [
          u("div", mw, [
            ot(Wi, {
              "total-price": k(g),
              loading: k(i),
              "selected-ids": k(V),
              "selected-total": k(R),
              showName: n("order.submitConfirm"),
              onSubmit: rt,
              onCheckout: ft
            }, null, 8, ["total-price", "loading", "selected-ids", "selected-total", "showName"]),
            u("div", hw, [
              se[8] || (se[8] = u("div", { class: "h-px w-12 bg-gray-100" }, null, -1)),
              ot(sl, {
                name: "menu-quote-fade",
                mode: "out-in"
              }, {
                default: kn(() => [
                  ($(), I("p", {
                    key: k(De),
                    class: "text-xs font-serif italic text-gray-700/80 tracking-[0.18em] text-center leading-relaxed max-w-[280px]"
                  }, " 「 " + T(k(De)) + " 」 ", 1))
                ]),
                _: 1
              }),
              u("p", pw, T(n("order.quoteVersion")), 1),
              ve.value ? ($(), I("div", gw, [
                ot(ae, {
                  to: "/about",
                  class: "inline-block rounded-2xl border border-amber-100 bg-amber-100/40 px-8 py-3.5 text-sm font-bold text-gray-700 shadow-sm transition-all pointer-hover:hover:bg-amber-100 pointer-hover:hover:border-amber-700 active:scale-95"
                }, {
                  default: kn(() => [
                    Ge(T(n("demo.noticeTitle1")) + " ", 1),
                    u("span", ww, T(n("demo.noticeTitle2")), 1),
                    Ge(" " + T(n("demo.noticeTitle3")) + " ", 1),
                    u("span", bw, "👉 " + T(n("demo.noticeAction")), 1)
                  ]),
                  _: 1
                })
              ])) : X("", !0)
            ])
          ])
        ])) : X("", !0)
      ]);
    };
  }
});
function yw(e) {
  const t = z([]), n = z(!1), s = z(null);
  return {
    tables: t,
    loading: n,
    error: s,
    fetchTables: async () => {
      n.value = !0, s.value = null;
      try {
        t.value = await e.getTables();
      } catch (a) {
        s.value = a.message || "Failed to load tables";
      } finally {
        n.value = !1;
      }
    },
    batchPostTables: async (a) => {
      n.value = !0, s.value = null;
      try {
        const i = await e.createTables(10);
        t.value = [...t.value, ...i];
      } catch (i) {
        s.value = i.message || "Failed to generate tables";
      } finally {
        n.value = !1;
      }
    }
  };
}
const vw = ["disabled"], _w = { class: "flex items-center" }, xw = /* @__PURE__ */ ye({
  __name: "BaseButton",
  props: {
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    size: { default: "lg" },
    variant: { default: "primary" },
    fullWidth: { type: Boolean, default: !0 }
  },
  emits: ["click"],
  setup(e) {
    return (t, n) => ($(), I("button", {
      disabled: e.disabled || e.loading,
      onClick: n[0] || (n[0] = (s) => t.$emit("click")),
      class: ke(["menu-btn", [
        // Size Logic
        e.size === "lg" ? "menu-btn-lg" : "menu-btn-md",
        // Style Variant Logic
        e.variant === "primary" ? "menu-btn-primary" : "menu-btn-outline",
        // Layout Logic
        e.fullWidth ? "menu-btn-full" : ""
      ]])
    }, [
      e.loading ? ($(), I("svg", {
        key: 0,
        class: ke(["animate-spin h-5 w-5 mr-2", e.variant === "primary" ? "text-white" : "text-blue-700"]),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24"
      }, [...n[1] || (n[1] = [
        u("circle", {
          class: "opacity-25",
          cx: "12",
          cy: "12",
          r: "10",
          stroke: "currentColor",
          "stroke-width": "4"
        }, null, -1),
        u("path", {
          class: "opacity-75",
          fill: "currentColor",
          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        }, null, -1)
      ])], 2)) : X("", !0),
      u("span", _w, [
        rl(t.$slots, "default")
      ])
    ], 10, vw));
  }
}), Ew = { class: "min-h-dvh w-full bg-slate-50 flex flex-col" }, kw = { class: "w-full bg-white border-b px-4 py-6 pt-[env(safe-area-inset-top,24px)]" }, Cw = { class: "max-w-screen-xl mx-auto" }, Tw = { class: "relative pl-4 border-l-4 border-blue-700" }, Aw = { class: "text-xl font-black text-gray-900 tracking-tight" }, Ow = { class: "text-gray-400 text-sm font-medium mt-1 uppercase tracking-wider" }, Sw = { class: "mt-8 flex flex-wrap gap-4" }, Nw = { class: "flex-1 w-full px-4 py-8 pb-[env(safe-area-inset-bottom,24px)]" }, $w = { class: "max-w-screen-xl mx-auto" }, Lw = {
  key: 0,
  class: "bg-red-50 text-red-700 p-4 rounded-2xl mb-6 border border-red-100 flex items-center gap-3"
}, Iw = { class: "font-bold" }, Pw = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" }, Dw = { class: "self-start text-[10px] bg-gray-100 px-2 py-1 rounded-md text-gray-400 font-mono" }, Mw = { class: "group relative bg-white border border-gray-100 rounded-[2rem] p-6 shadow-sm hover:shadow-xl transition-all duration-700 overflow-hidden flex flex-col items-center gap-4" }, Rw = { class: "flex items-baseline justify-center gap-2" }, Fw = { class: "text-xl font-black uppercase tracking-[0.2em] text-blue-700" }, Bw = { class: "text-2xl font-black text-gray-900 leading-none" }, Uw = { class: "relative p-3 bg-white rounded-3xl shadow-inner border border-gray-50 group-hover:border-blue-100 transition-colors" }, Vw = ["src"], Hw = {
  key: 1,
  class: "w-32 h-32 flex flex-col items-center justify-center gap-2"
}, jw = { class: "text-[9px] text-gray-400 font-bold uppercase tracking-widest" }, qw = { class: "mt-2 flex flex-col items-center gap-3 w-full" }, Ww = { class: "text-[9px] font-mono text-gray-400 bg-gray-50 px-3 py-1 rounded-full truncate w-full text-center" }, zw = ["href"], Yw = 9, Kw = 10, Gw = /* @__PURE__ */ ye({
  __name: "TablePostPage",
  props: {
    api: {}
  },
  setup(e) {
    const { t } = Ot(), n = e, { tables: s, loading: r, error: o, fetchTables: a, batchPostTables: i } = yw(n.api), l = async () => {
      try {
        await i(Kw), await a();
      } catch (c) {
        Ce.error("Failed to generate tables:", c);
      }
    };
    return Dt(async () => {
      try {
        await a();
      } catch (c) {
        Ce.error("Failed to initial fetch tables:", c);
      }
    }), (c, h) => {
      const f = tr("router-link");
      return $(), I("div", Ew, [
        u("header", kw, [
          u("div", Cw, [
            ot(f, {
              to: "/all_order",
              class: "inline-flex items-center gap-2 px-3 py-1.5 mb-6 text-sm font-bold text-gray-700 hover:text-blue-700 bg-gray-50 rounded-full transition-all"
            }, {
              default: kn(() => [
                h[1] || (h[1] = u("span", { class: "flex items-center justify-center w-6 h-6 rounded-full bg-white shadow-sm" }, [
                  u("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "w-3.5 h-3.5",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }, [
                    u("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "3",
                      d: "M15 19l-7-7 7-7"
                    })
                  ])
                ], -1)),
                Ge(" " + T(k(t)("tables.backBtn")), 1)
              ]),
              _: 1
            }),
            u("div", Tw, [
              u("h1", Aw, T(k(t)("tables.title")), 1),
              u("p", Ow, T(k(t)("tables.subtitle")), 1)
            ]),
            u("div", Sw, [
              k(s).length < Yw ? ($(), it(xw, {
                key: 0,
                onClick: l,
                loading: k(r),
                class: "shadow-lg py-4 px-8 text-lg bg-blue-700 text-white rounded-xl flex items-center justify-center transition-transform active:scale-[0.98] flex-1 sm:flex-none",
                "full-width": !1
              }, {
                default: kn(() => [
                  Ge(T(k(t)("tables.generateBtn")), 1)
                ]),
                _: 1
              }, 8, ["loading"])) : X("", !0),
              u("button", {
                onClick: h[0] || (h[0] = //@ts-ignore
                (...p) => k(a) && k(a)(...p)),
                class: "shadow-lg py-4 px-8 text-lg bg-white border border-gray-100 text-gray-700 rounded-xl flex items-center justify-center transition-transform active:scale-[0.98] flex-1 sm:flex-none"
              }, T(k(t)("tables.refreshBtn")), 1)
            ])
          ])
        ]),
        u("main", Nw, [
          u("div", $w, [
            k(o) ? ($(), I("div", Lw, [
              u("span", Iw, T(k(t)("common.error")) + ":", 1),
              Ge(" " + T(k(o)), 1)
            ])) : X("", !0),
            u("div", Pw, [
              ($(!0), I(Me, null, ze(k(s), (p) => ($(), I("div", {
                key: p.id,
                class: "flex flex-col gap-2"
              }, [
                u("div", Dw, " #" + T(p.id.slice(-8)), 1),
                u("div", Mw, [
                  h[4] || (h[4] = u("div", { class: "absolute top-0 right-0 w-24 h-24 bg-blue-50 rounded-full -mr-12 -mt-12 transition-transform group-hover:scale-150 duration-700 opacity-50" }, null, -1)),
                  u("div", Rw, [
                    u("span", Fw, T(k(t)("tables.cardHeader")), 1),
                    u("span", Bw, T(p.tableNumber), 1)
                  ]),
                  u("div", Uw, [
                    p.qrcode_base64 ? ($(), I("img", {
                      key: 0,
                      src: p.qrcode_base64,
                      class: "w-full max-w-[12rem] aspect-square object-contain mix-blend-multiply rounded-xl"
                    }, null, 8, Vw)) : ($(), I("div", Hw, [
                      h[2] || (h[2] = u("div", { class: "animate-pulse w-8 h-8 rounded-full bg-gray-100" }, null, -1)),
                      u("span", jw, T(k(t)("tables.generating")), 1)
                    ]))
                  ]),
                  u("div", qw, [
                    u("div", Ww, T(p.url), 1),
                    u("a", {
                      href: p.url,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      class: "flex items-center gap-2 px-6 py-2.5 bg-gray-900 text-white text-[11px] font-bold rounded-full hover:bg-blue-700 transition-all active:scale-95 shadow-md shadow-gray-100"
                    }, [
                      u("span", null, T(k(t)("tables.openLink")), 1),
                      h[3] || (h[3] = u("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "w-3 h-3",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        u("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2.5",
                          d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                        })
                      ], -1))
                    ], 8, zw)
                  ])
                ])
              ]))), 128))
            ])
          ])
        ])
      ]);
    };
  }
}), iv = /* @__PURE__ */ bn(Gw, [["__scopeId", "data-v-f46a14aa"]]);
function Gi(e) {
  const t = z([]), n = z(!1), s = z(null);
  return {
    ordersOrderManagement: t,
    loadingOrderManagement: n,
    errorOrderManagement: s,
    fetchOrders: async () => {
      n.value = !0, s.value = null;
      try {
        t.value = await e.getOrders();
      } catch (l) {
        s.value = `取得訂單失敗: ${l.message}`;
      } finally {
        n.value = !1;
      }
    },
    updateStatus: async (l) => {
      n.value = !0, s.value = null;
      try {
        const c = await e.updateItemStatus(l), h = t.value.find((f) => f.id === l.orderId);
        if (h) {
          const f = h.items.find((p) => p.id === l.itemId);
          f && (f.status = l.newStatus);
        }
      } catch (c) {
        throw s.value = `更新狀態失敗: ${c.message}`, c;
      } finally {
        n.value = !1;
      }
    },
    performCheckout: async (l, c) => {
      if (l.length === 0) throw new Error("未選擇任何訂單");
      n.value = !0, s.value = null;
      const h = (c == null ? void 0 : c.memo2) || "", f = c == null ? void 0 : c.status;
      if (f === void 0 || isNaN(f) || f < 0 || f > 4) {
        n.value = !1;
        const p = `無效的訂單狀態: ${(c == null ? void 0 : c.status) === void 0 ? "未定義" : c.status}`;
        throw s.value = p, new Error(p);
      }
      try {
        const p = await e.checkoutOrders(l, { memo2: h, status: f });
        return p.rows_affected > 0 && (await we.fire({
          title: "訂單處理完成！",
          text: p.message,
          icon: "success",
          confirmButtonColor: "#2563eb",
          timer: 1500
        }), t.value = t.value.filter((b) => !l.includes(b.id))), p;
      } catch (p) {
        throw s.value = `訂單處理失敗: ${p.message}`, p;
      } finally {
        n.value = !1;
      }
    },
    performCheckout2: async (l, c, h, f, p, b) => {
      if (l.length === 0) throw new Error("未選擇任何訂單");
      if (!c) throw new Error("缺少 QR Code 參數");
      n.value = !0, s.value = null;
      const g = {
        ids: l,
        qr: c,
        carrier_num: h || "",
        customer_identifier: f || "",
        customer_name: p || "",
        memo2: b || ""
      }, m = {
        ids: l
      };
      try {
        const y = await e.checkDuplicates(m);
        if (!await il(y.duplicates))
          return n.value = !1, { rows_affected: 0, status: "CANCELLED", amount: "0", checkout_at: 0, merchant_trade_no: "" };
        const w = await e.counterCheckoutOrders(
          g
        );
        return w.rows_affected > 0 && (await we.fire({
          title: "櫃台結帳處理完成！",
          text: w.merchant_trade_no || "現場交易已同步完成",
          icon: "success",
          confirmButtonColor: "#2563eb",
          timer: 1500
        }), t.value = t.value.filter((_) => !l.includes(_.id))), w;
      } catch (y) {
        throw s.value = `櫃台結帳處理失敗: ${y.message}`, y;
      } finally {
        n.value = !1;
      }
    }
  };
}
const Xw = { class: "flex flex-col gap-4 mb-6" }, Jw = { class: "flex items-center justify-between" }, Zw = ["disabled"], Qw = { class: "text-[10px] font-bold uppercase" }, eb = { class: "bg-white p-4 rounded-2xl shadow-sm border border-gray-100 flex items-end justify-between" }, tb = { class: "text-[10px] text-gray-400 font-black uppercase tracking-widest mb-1" }, nb = { class: "text-4xl font-black text-gray-900 leading-none" }, sb = { class: "flex flex-col items-end" }, rb = { class: "text-[10px] font-bold text-gray-400 uppercase" }, ob = /* @__PURE__ */ ye({
  __name: "OrderTableHeader",
  props: {
    tableNumber: {},
    loading: { type: Boolean },
    t: { type: Function }
  },
  emits: ["refresh"],
  setup(e) {
    return (t, n) => {
      const s = tr("router-link");
      return $(), I("section", Xw, [
        u("div", Jw, [
          ot(s, {
            to: "/all_order",
            class: "flex items-center gap-1 text-sm font-bold text-blue-700 hover:text-blue-700 transition-colors"
          }, {
            default: kn(() => [
              n[1] || (n[1] = u("span", { class: "text-lg" }, "‹", -1)),
              Ge(" 📋 " + T(e.t("order.manage")), 1)
            ]),
            _: 1
          }),
          u("button", {
            onClick: n[0] || (n[0] = (r) => t.$emit("refresh")),
            disabled: e.loading,
            class: "flex items-center gap-2 px-3 py-1.5 rounded-full bg-blue-50 text-blue-700 hover:bg-blue-100 active:scale-95 transition-all disabled:opacity-50"
          }, [
            u("span", {
              class: ke([{ "animate-spin": e.loading }, "text-sm"])
            }, "🔄", 2),
            u("span", Qw, T(e.t("common.refresh")), 1)
          ], 8, Zw)
        ]),
        u("div", eb, [
          u("div", null, [
            u("p", tb, T(e.t("order.currentTable")), 1),
            u("h1", nb, T(e.tableNumber || e.t("common.na")), 1)
          ]),
          u("div", sb, [
            n[2] || (n[2] = u("span", { class: "flex h-2 w-2 rounded-full bg-green-700 animate-pulse mb-1" }, null, -1)),
            u("span", rb, T(e.t("order.activeSession")), 1)
          ])
        ])
      ]);
    };
  }
}), ab = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
}, ib = { class: "bg-white rounded-2xl w-full max-w-md overflow-hidden shadow-xl mx-4" }, lb = { class: "px-6 py-4 border-b border-gray-100 flex justify-between items-center bg-gray-50" }, cb = { class: "text-sm font-semibold text-blue-700" }, ub = { class: "p-6 space-y-5 max-h-[65vh] overflow-y-auto" }, db = ["value"], fb = { key: 0 }, mb = {
  key: 0,
  class: "text-xs text-red-500 mt-1 font-medium"
}, hb = { key: 1 }, pb = {
  key: 0,
  class: "text-xs text-red-500 mt-1 font-medium"
}, gb = { key: 2 }, wb = { class: "relative" }, bb = {
  key: 0,
  class: "absolute right-3 top-1/2 -translate-y-1/2"
}, yb = { class: "px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-end space-x-3" }, vb = ["disabled"], _b = ["disabled"], xb = {
  key: 0,
  class: "animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"
}, Eb = /* @__PURE__ */ ye({
  __name: "CheckoutInvoiceModal",
  props: /* @__PURE__ */ Pr({
    isOpen: { type: Boolean },
    otype: {},
    total: {},
    options: {},
    queryCompanyName: { type: Function },
    isSubmitting: { type: Boolean }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Pr(["close", "submit"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, s = ol(e, "modelValue"), r = t, o = z(""), a = z(""), i = z(!1);
    bt(() => n.isOpen, (h) => {
      h || (o.value = "", a.value = "");
    });
    const l = async (h) => {
      const f = h.target, p = ll(f.value);
      if (f.value = p.value, s.value.CustomerIdentifier = p.value, o.value = p.error, p.isReady && n.queryCompanyName) {
        i.value = !0;
        try {
          const b = await n.queryCompanyName(p.value), g = b == null ? void 0 : b.Company_Name;
          g ? s.value.CustomerName = g : o.value = "查無此統一編號的公司名稱";
        } catch (b) {
          Ce.error("查詢公司名稱失敗:", b), o.value = "系統查詢名稱失敗，請手動輸入公司名稱";
        } finally {
          i.value = !1;
        }
      }
    }, c = () => {
      if (s.value.CarrierNum && !s.value.CarrierNum.startsWith("/")) {
        a.value = "手機條碼第一碼必須為斜線 /";
        return;
      }
      a.value = "", r("submit");
    };
    return (h, f) => e.isOpen ? ($(), I("div", ab, [
      u("div", ib, [
        u("div", lb, [
          f[6] || (f[6] = u("h3", { class: "text-base font-bold text-gray-800" }, "結帳與發票設定", -1)),
          u("p", cb, "總金額: " + T(e.total), 1)
        ]),
        u("div", ub, [
          u("div", null, [
            f[7] || (f[7] = u("label", { class: "block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" }, "變更訂單狀態", -1)),
            Qe(u("select", {
              "onUpdate:modelValue": f[0] || (f[0] = (p) => s.value.status = p),
              class: "w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-700 focus:ring-2 focus:ring-blue-700/20 transition-all outline-none"
            }, [
              ($(!0), I(Me, null, ze(e.options, (p) => ($(), I("option", {
                key: p.value,
                value: p.value
              }, T(p.icon) + " " + T(p.label), 9, db))), 128))
            ], 512), [
              [nr, s.value.status]
            ])
          ]),
          u("div", null, [
            f[8] || (f[8] = u("label", { class: "block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" }, "備註", -1)),
            Qe(u("input", {
              "onUpdate:modelValue": f[1] || (f[1] = (p) => s.value.memo2 = p),
              type: "text",
              maxlength: "30",
              placeholder: "",
              class: "w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-700 focus:ring-2 focus:ring-blue-700/20 transition-all outline-none font-mono"
            }, null, 512), [
              [pt, s.value.memo2]
            ]),
            f[9] || (f[9] = u("p", { class: "text-[10px] text-gray-700 opacity-50 mt-1.5 ml-1" }, "備註", -1))
          ]),
          f[15] || (f[15] = u("hr", { class: "border-gray-100" }, null, -1)),
          e.otype === 0 ? ($(), I("div", fb, [
            f[10] || (f[10] = u("label", { class: "block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" }, "手機條碼 (CarrierNum)", -1)),
            Qe(u("input", {
              "onUpdate:modelValue": f[2] || (f[2] = (p) => s.value.CarrierNum = p),
              type: "text",
              maxlength: "8",
              placeholder: "/ABC1234",
              class: "w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-700 focus:ring-2 focus:ring-blue-700/20 transition-all outline-none font-mono"
            }, null, 512), [
              [pt, s.value.CarrierNum]
            ]),
            f[11] || (f[11] = u("p", { class: "text-[10px] text-gray-700 opacity-50 mt-1.5 ml-1" }, "* 第一碼必須為斜線 /", -1)),
            a.value ? ($(), I("p", mb, T(a.value), 1)) : X("", !0)
          ])) : X("", !0),
          e.otype === 0 ? ($(), I("div", hb, [
            f[12] || (f[12] = u("label", { class: "block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" }, "買受人統編 (CustomerIdentifier)", -1)),
            Qe(u("input", {
              "onUpdate:modelValue": f[3] || (f[3] = (p) => s.value.CustomerIdentifier = p),
              onInput: l,
              type: "text",
              maxlength: "8",
              placeholder: "8 位數字統編",
              class: "w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-700 focus:ring-2 focus:ring-blue-700/20 transition-all outline-none font-mono"
            }, null, 544), [
              [pt, s.value.CustomerIdentifier]
            ]),
            o.value ? ($(), I("p", pb, T(o.value), 1)) : X("", !0)
          ])) : X("", !0),
          e.otype === 0 ? ($(), I("div", gb, [
            f[14] || (f[14] = u("label", { class: "block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" }, "買受人名稱 (CustomerName)", -1)),
            u("div", wb, [
              Qe(u("input", {
                "onUpdate:modelValue": f[4] || (f[4] = (p) => s.value.CustomerName = p),
                type: "text",
                placeholder: "公司全名",
                class: "w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-700 focus:ring-2 focus:ring-blue-700/20 transition-all outline-none"
              }, null, 512), [
                [pt, s.value.CustomerName]
              ]),
              i.value ? ($(), I("div", bb, [...f[13] || (f[13] = [
                u("div", { class: "animate-spin rounded-full h-4 w-4 border-2 border-blue-700 border-t-transparent" }, null, -1)
              ])])) : X("", !0)
            ])
          ])) : X("", !0)
        ]),
        u("div", yb, [
          u("button", {
            onClick: f[5] || (f[5] = (p) => h.$emit("close")),
            disabled: e.isSubmitting,
            class: "px-4 py-2 text-sm font-medium text-gray-500 hover:text-gray-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          }, " 取消 ", 8, vb),
          u("button", {
            onClick: c,
            disabled: e.isSubmitting,
            class: "px-5 py-2 text-sm font-medium text-white bg-blue-700 rounded-xl hover:bg-blue-800 transition-colors shadow-lg shadow-blue-700/20 disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2"
          }, [
            e.isSubmitting ? ($(), I("span", xb)) : X("", !0),
            u("span", null, T(e.isSubmitting ? "處理中..." : "確認送出"), 1)
          ], 8, _b)
        ])
      ])
    ])) : X("", !0);
  }
}), kb = { key: 0 }, Cb = { class: "flex items-center justify-between mb-4" }, Tb = { class: "menu-section-title" }, Ab = { class: "text-xs font-bold text-white bg-blue-700 px-3 py-1 rounded-full shadow-sm" }, Ob = { class: "flex items-center justify-between mb-4 px-1" }, Sb = { class: "flex items-center gap-2 cursor-pointer" }, Nb = ["checked"], $b = { class: "text-sm font-bold text-gray-700" }, Lb = /* @__PURE__ */ ye({
  __name: "OrderManagementList",
  props: {
    orders: {},
    t: { type: Function }
  },
  emits: ["update-item-status", "selection-change"],
  setup(e, { emit: t }) {
    Ce.log("OrderManagementList.vue");
    const n = e, s = (b) => {
      var g;
      return ((g = n.t) == null ? void 0 : g.call(n, b)) ?? b;
    }, r = t, o = z([]), a = me(() => n.orders.length > 0 && o.value.length === n.orders.length), i = () => {
      o.value = a.value ? [] : n.orders.map((b) => b.id);
    }, l = (b) => {
      const g = o.value.indexOf(b), m = [...o.value];
      g > -1 ? m.splice(g, 1) : m.push(b), o.value = m;
    }, c = me(() => n.orders.filter(
      (b) => (
        // 1. Must be selected
        o.value.includes(b.id) && // 2. Must be a valid status (e.g., exclude CLOSED or specific error statuses)
        b.status !== Re.PAID
      )
    ).reduce((b, g) => b + Number(g.subtotal || 0), 0));
    bt(o, (b) => {
      r("selection-change", {
        ids: [...b],
        // Send a copy to ensure reactivity in the parent
        total: c.value
      });
    }, { deep: !0 });
    const h = (b, g, m) => {
      const y = b.items.find((_) => _.id === g);
      if (!y) return;
      const d = En.indexOf(y.status), w = En[d + m];
      if (w !== void 0) {
        const _ = new Pt(b.subtotal || "0"), x = new Pt(y.unit_price || "0");
        y.status !== Nt.CANCEL && w === Nt.CANCEL ? b.subtotal = _.minus(x).toFixed(2) : y.status === Nt.CANCEL && w !== Nt.CANCEL && (b.subtotal = _.plus(x).toFixed(2)), y.status = w, r("update-item-status", { orderId: b.id, itemId: g, newStatus: w });
      }
    }, f = me(() => [...n.orders].sort((b, g) => {
      var w, _;
      const m = ((w = b.info) == null ? void 0 : w.session_id) || "", y = ((_ = g.info) == null ? void 0 : _.session_id) || "", d = m.localeCompare(y);
      if (d === 0) {
        const x = new Date(b.created_at).getTime();
        return new Date(g.created_at).getTime() - x;
      }
      return d;
    })), p = me(() => {
      const b = {}, g = {};
      return [...f.value].reverse().forEach((m) => {
        var d;
        const y = ((d = m.info) == null ? void 0 : d.session_id) || "default";
        b[y] = (b[y] || 0) + 1, g[m.id] = b[y];
      }), g;
    });
    return (b, g) => e.orders.length > 0 ? ($(), I("div", kb, [
      u("header", Cb, [
        u("h2", Tb, [
          g[0] || (g[0] = u("span", { class: "menu-section-dot" }, null, -1)),
          Ge(" " + T(s("orderHistory.title")), 1)
        ]),
        u("span", Ab, T(s("orderHistory.selectedTotal")) + " $" + T(c.value), 1)
      ]),
      u("div", Ob, [
        u("label", Sb, [
          u("input", {
            type: "checkbox",
            checked: a.value,
            onChange: i,
            class: "menu-checkbox w-5 h-5 accent-blue-700"
          }, null, 40, Nb),
          u("span", $b, T(s("orderHistory.selectAll")), 1)
        ])
      ]),
      ($(!0), I(Me, null, ze(f.value, (m, y) => ($(), it(Ki, {
        key: m.id,
        order: m,
        length: e.orders.length,
        index: e.orders.length - y - 1,
        "is-selected": o.value.includes(m.id),
        "show-add": !0,
        "session-index": p.value[m.id],
        onToggleSelection: l,
        onStatusChange: h
      }, null, 8, ["order", "length", "index", "is-selected", "session-index"]))), 128))
    ])) : X("", !0);
  }
}), Ib = { class: "menu-order-shell" }, Pb = {
  key: 0,
  class: "bg-red-50 text-red-700 p-4 rounded-2xl mb-4 border border-red-100 text-sm font-medium"
}, Db = {
  key: 2,
  class: "flex flex-col items-center justify-center py-20 space-y-4"
}, Mb = { class: "text-gray-400 text-sm font-medium" }, lv = /* @__PURE__ */ ye({
  __name: "OrderManagementPage",
  props: {
    menuApi: {},
    orderApi: {},
    orderManagementApi: {},
    qr: {},
    onNavigate: { type: Function },
    t: { type: Function }
  },
  setup(e) {
    const t = e, n = (F) => {
      var D;
      return ((D = t.t) == null ? void 0 : D.call(t, F)) ?? F;
    }, s = me(() => n("common.done"));
    ji(t.menuApi);
    const { historyLoading: r, historyError: o, orderHistory: a, cumulativeTotal: i, loadOrderHistory: l } = qi(t.orderApi), { updateStatus: c, performCheckout: h, performCheckout2: f } = Gi(t.orderManagementApi), p = z("0"), b = z([]), g = z(""), m = z(!1), y = z(!1), d = z(0), w = z([]), _ = z({
      status: Re.COMPLETE,
      CarrierNum: "",
      CustomerIdentifier: "",
      CustomerName: "",
      memo2: ""
    });
    Dt(() => {
      t.qr && l(t.qr);
    });
    const x = ({ ids: F, total: D }) => {
      b.value = F, p.value = D;
    }, A = async (F) => {
      await c(F);
    }, L = async () => {
      if (b.value.length === 0) return;
      const D = a.value.filter(
        (q) => b.value.includes(q.id)
      ).map((q) => q.status);
      if (new Set(D).size > 1) {
        we.fire({
          icon: "error",
          title: "錯誤",
          text: "❌ 無法同時結帳不同狀態的訂單，請重新選擇！"
        });
        return;
      }
      D[0] === Re.PAID ? d.value = 1 : d.value = 0, g.value = D[0], w.value = [
        { value: Re.COMPLETE, label: n("order.statusComplete"), icon: "✅" },
        { value: Re.CLOSED, label: n("order.statusClose"), icon: "❌" }
      ], _.value.status = w.value[0].value, _.value.CarrierNum = "", _.value.CustomerIdentifier = "", _.value.CustomerName = "", _.value.memo2 = "", m.value = !0;
    }, C = async () => {
      var F;
      try {
        y.value = !0;
        let D;
        const { status: j, memo2: q, CarrierNum: ne, CustomerIdentifier: De, CustomerName: V } = _.value;
        j === Re.CLOSED || g.value === Re.PAID ? D = await h(b.value, {
          memo2: q,
          status: j
        }) : D = await f(
          b.value,
          t.qr,
          ne,
          De,
          V,
          q
        ), D.rows_affected > 0 && (m.value = !1, p.value = "0", await l(t.qr), await al(), a.value.length === 0 && ((F = t.onNavigate) == null || F.call(t, "/all_order")));
      } catch (D) {
        console.error("Checkout failed:", D), we.fire({
          icon: "error",
          title: "結帳失敗",
          text: "系統發生錯誤，請稍後再試。"
        });
      } finally {
        y.value = !1;
      }
    };
    return (F, D) => {
      var j, q;
      return $(), I("div", Ib, [
        k(a).length > 0 ? ($(), it(ob, {
          key: 0,
          "table-number": (q = (j = k(a)[0]) == null ? void 0 : j.table) == null ? void 0 : q.tableNumber,
          loading: k(r),
          t: n,
          onRefresh: D[0] || (D[0] = (ne) => k(l)(t.qr))
        }, null, 8, ["table-number", "loading"])) : X("", !0),
        u("section", null, [
          k(o) ? ($(), I("div", Pb, T(k(o)), 1)) : X("", !0),
          !k(r) && k(a).length > 0 ? ($(), it(Lb, {
            key: 1,
            orders: k(a),
            "total-accumulated": k(i),
            t: n,
            onUpdateItemStatus: A,
            onSelectionChange: x
          }, null, 8, ["orders", "total-accumulated"])) : X("", !0),
          k(r) ? ($(), I("div", Db, [
            D[3] || (D[3] = u("div", { class: "w-12 h-12 border-4 border-blue-100 border-t-blue-700 rounded-full animate-spin" }, null, -1)),
            u("p", Mb, T(n("order.loadingHistory")), 1)
          ])) : X("", !0),
          k(a).length > 0 ? ($(), it(Wi, {
            key: 3,
            "total-price": p.value,
            loading: k(r),
            showName: s.value,
            onSubmit: L
          }, null, 8, ["total-price", "loading", "showName"])) : X("", !0)
        ]),
        ot(Eb, {
          modelValue: _.value,
          "onUpdate:modelValue": D[1] || (D[1] = (ne) => _.value = ne),
          "is-open": m.value,
          otype: d.value,
          total: p.value,
          options: w.value,
          "query-company-name": t.menuApi.queryCompanyName,
          "is-submitting": y.value,
          onClose: D[2] || (D[2] = (ne) => m.value = !1),
          onSubmit: C
        }, null, 8, ["modelValue", "is-open", "otype", "total", "options", "query-company-name", "is-submitting"])
      ]);
    };
  }
});
function Rb(e) {
  const t = z([]), n = z(!1), s = z(null), r = z(1), o = z(10), a = z(0), i = z(void 0);
  return {
    orders: t,
    loading: n,
    error: s,
    currentPage: r,
    pageSize: o,
    totalCount: a,
    selectedStatus: i,
    // 匯出這些讓 UI 綁定
    fetchOrders: async () => {
      n.value = !0, s.value = null;
      try {
        const c = await e.getAllOrderWithPage({
          page: r.value,
          size: o.value,
          status: i.value
        });
        t.value = c.orders, a.value = c.total_count;
      } catch (c) {
        s.value = c.message || "無法取得訂單列表";
      } finally {
        n.value = !1;
      }
    },
    getStatusLabel: Ds
  };
}
const Fb = { class: "flex flex-col min-h-dvh w-full bg-slate-50 overflow-x-hidden" }, Bb = { class: "w-full px-4 pt-[env(safe-area-inset-top,1.5rem)] pb-6 max-w-4xl mx-auto" }, Ub = { class: "flex flex-col gap-6" }, Vb = { class: "flex justify-between items-start" }, Hb = ["disabled"], jb = { class: "text-3xl font-black text-gray-900 tracking-tight" }, qb = { class: "text-gray-400 text-sm font-bold mt-1" }, Wb = { class: "text-blue-700" }, zb = { class: "bg-gray-100/50 p-1 rounded-2xl flex w-full" }, Yb = ["onClick"], Kb = { class: "flex-grow px-4 pb-12 max-w-4xl mx-auto w-full" }, Gb = {
  key: 0,
  class: "flex flex-col items-center justify-center py-20"
}, Xb = { class: "text-gray-400 font-medium mt-4" }, Jb = {
  key: 1,
  class: "bg-red-50 text-red-700 p-5 rounded-2xl border border-red-100 font-medium flex items-center gap-3"
}, Zb = {
  key: 2,
  class: "grid grid-cols-1 gap-6"
}, Qb = ["onClick"], e0 = { class: "p-6" }, t0 = { class: "flex justify-between items-start mb-4" }, n0 = { class: "space-y-1" }, s0 = { class: "flex items-center gap-2" }, r0 = {
  key: 0,
  class: "w-2 h-2 rounded-full bg-blue-700 animate-pulse"
}, o0 = { class: "text-2xl font-black text-gray-900" }, a0 = { class: "flex items-center gap-2 flex-wrap" }, i0 = { class: "text-[0.65rem] text-gray-400 font-mono tracking-tighter bg-gray-50 px-1.5 py-0.5 rounded border border-gray-100" }, l0 = {
  key: 0,
  class: "text-xs font-black text-gray-700 bg-amber-100 px-2 py-0.5 rounded-md border border-amber-200"
}, c0 = {
  key: 0,
  class: "mt-1 flex items-start gap-2 bg-gray-50 border-l-4 border-amber-400 p-2 rounded-r-lg"
}, u0 = { class: "text-[11px] leading-relaxed font-bold text-gray-600 italic" }, d0 = {
  key: 1,
  class: "mt-1 flex items-start gap-2 bg-gray-50 border-l-4 border-amber-400 p-2 rounded-r-lg"
}, f0 = { class: "text-[11px] leading-relaxed font-bold text-gray-600 italic" }, m0 = { class: "mt-6 pt-5 border-t border-gray-50 flex justify-between items-end" }, h0 = { class: "text-[0.7rem] font-bold text-gray-400" }, p0 = { class: "text-right" }, g0 = { class: "text-[0.6rem] text-gray-400 font-bold uppercase tracking-widest mb-1" }, w0 = { class: "text-3xl font-black text-blue-700 tabular-nums leading-none" }, b0 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-20 bg-white rounded-[3rem] border-2 border-dashed border-gray-100"
}, y0 = { class: "text-gray-400 font-bold" }, v0 = {
  key: 3,
  class: "flex flex-col sm:flex-row items-center justify-between gap-4 bg-white px-6 py-4 rounded-2xl border border-gray-100 shadow-xs mt-2"
}, _0 = { class: "text-xs font-mono font-bold text-gray-400" }, x0 = { class: "flex items-center gap-3" }, E0 = ["disabled"], k0 = ["disabled"], cv = /* @__PURE__ */ ye({
  __name: "MerchantOrderListPage",
  props: {
    merchantOrderApi: {},
    orderManagementApi: {},
    t: { type: Function }
  },
  emits: ["navigate-to-table"],
  setup(e, { emit: t }) {
    const n = e, s = (x) => {
      var A;
      return ((A = n.t) == null ? void 0 : A.call(n, x)) ?? x;
    }, r = localStorage.getItem("merchant_tz") || "UTC", {
      orders: o,
      loading: a,
      error: i,
      currentPage: l,
      totalCount: c,
      pageSize: h,
      selectedStatus: f,
      fetchOrders: p,
      getStatusLabel: b
    } = Rb(n.merchantOrderApi), {
      performCheckout: g
    } = Gi(n.orderManagementApi), m = z("all"), y = [
      { key: "active", label: "order.tab.active" },
      { key: "completed", label: "order.tab.completed" },
      { key: "all", label: "order.tab.all" }
    ];
    bt(m, (x) => {
      x === "completed" ? f.value = Re.COMPLETE : x === "active" ? f.value = Re.PAID : f.value = void 0, l.value = 1, p();
    }), bt(l, () => {
      p();
    });
    const d = () => {
      p();
    }, w = t, _ = async (x) => {
      var L, C, F;
      if (x.status === Re.COMPLETE || x.status === Re.CLOSED) {
        if (Ce.log("handleTableClick", (L = x.table) == null ? void 0 : L.tableNumber, (C = x.table) == null ? void 0 : C.qr, x.id, x.status), await we.fire({
          title: s("order.completedTitle"),
          text: s("order.completedText"),
          icon: "info",
          confirmButtonColor: "#2563eb",
          timer: 1e3
        }), (await we.fire({
          title: "是否要修改狀態？",
          text: "點擊確認將會更新目前的訂單狀態。",
          icon: "question",
          showCancelButton: !0,
          // 顯示取消按鈕
          confirmButtonColor: "#2563eb",
          // 保持相同的主題藍色
          cancelButtonColor: "#d33",
          confirmButtonText: "確定修改",
          cancelButtonText: "不用，謝謝"
        })).isConfirmed)
          try {
            we.fire({
              title: "更新中...",
              allowOutsideClick: !1,
              didOpen: () => {
                we.showLoading();
              }
            });
            const j = await g(
              [x.id],
              {
                memo2: "",
                // 因為 memo2 是必填的，若無內容可先帶空字串
                status: Re.NEW
              }
            );
            p();
          } catch (j) {
            Ce.error("API 呼叫失敗:", j), await we.fire({
              title: "修改失敗",
              text: "切換狀態時發生錯誤，請稍後再試。",
              icon: "error",
              confirmButtonColor: "#2563eb",
              timer: 1e3
            });
          }
        return;
      }
      const A = (F = x.table) == null ? void 0 : F.qr;
      A && w("navigate-to-table", A);
    };
    return Dt(() => {
      p();
    }), (x, A) => {
      var L;
      return $(), I("div", Fb, [
        u("header", Bb, [
          u("div", Ub, [
            u("div", Vb, [
              u("button", {
                onClick: d,
                disabled: k(a),
                "aria-label": "Refresh Orders",
                class: "w-14 h-14 flex-shrink-0 flex items-center justify-center rounded-2xl bg-white shadow-sm border border-gray-100 active:scale-90 transition-all touch-manipulation"
              }, [
                u("span", {
                  class: ke([{ "animate-spin": k(a) }, "text-xl"])
                }, "🔄", 2)
              ], 8, Hb),
              u("div", null, [
                u("h1", jb, T(s("order.manage")), 1),
                u("p", qb, [
                  Ge(T(s("order.totalPrefix")) + " ", 1),
                  u("span", Wb, T(k(c)), 1),
                  Ge(" " + T(s("order.totalSuffix")), 1)
                ])
              ])
            ]),
            u("nav", zb, [
              ($(), I(Me, null, ze(y, (C) => u("button", {
                key: C.key,
                onClick: (F) => m.value = C.key,
                class: ke([
                  "flex-1 py-3 text-sm font-bold rounded-xl transition-all touch-manipulation",
                  m.value === C.key ? "bg-white text-blue-700 shadow-sm" : "text-gray-700"
                ])
              }, T(s(C.label)), 11, Yb)), 64))
            ])
          ])
        ]),
        u("main", Kb, [
          k(a) ? ($(), I("div", Gb, [
            A[2] || (A[2] = u("div", { class: "w-12 h-12 border-4 border-blue-100 border-t-blue-700 rounded-full animate-spin" }, null, -1)),
            u("p", Xb, T(s("order.syncing")), 1)
          ])) : k(i) ? ($(), I("div", Jb, [
            A[3] || (A[3] = u("span", null, "⚠️", -1)),
            Ge(" " + T(k(i)), 1)
          ])) : ($(), I("div", Zb, [
            ($(!0), I(Me, null, ze(k(o), (C) => {
              var F, D, j, q;
              return $(), I("article", {
                key: C.id,
                class: "bg-white rounded-[2.5rem] border border-gray-100 shadow-sm flex flex-col transition-all active:scale-[0.98] touch-manipulation",
                onClick: (ne) => _(C)
              }, [
                u("div", e0, [
                  u("div", t0, [
                    u("div", n0, [
                      u("div", s0, [
                        m.value === "active" ? ($(), I("span", r0)) : X("", !0),
                        u("h2", o0, T(s("order.table")) + " " + T((F = C.table) == null ? void 0 : F.tableNumber), 1)
                      ]),
                      u("div", a0, [
                        u("p", i0, T(C.id.slice(-3)), 1),
                        (D = C.info) != null && D.nickname ? ($(), I("p", l0, " 👤 " + T(C.info.nickname), 1)) : X("", !0)
                      ])
                    ]),
                    u("span", {
                      class: ke([
                        "px-4 py-1.5 rounded-xl text-[0.7rem] font-black uppercase tracking-wider",
                        k(b)(C.status).color
                      ])
                    }, T(k(b)(C.status).text), 3)
                  ]),
                  (j = C.info) != null && j.memo1 ? ($(), I("div", c0, [
                    A[4] || (A[4] = u("span", { class: "text-xs" }, "📝", -1)),
                    u("p", u0, T(C.info.memo1), 1)
                  ])) : X("", !0),
                  (q = C.info) != null && q.memo2 ? ($(), I("div", d0, [
                    A[5] || (A[5] = u("span", { class: "text-xs" }, "📝", -1)),
                    u("p", f0, T(C.info.memo2), 1)
                  ])) : X("", !0),
                  u("div", m0, [
                    u("time", h0, " 🕒 " + T(k(Ko)(C.created_at, k(r))), 1),
                    u("div", p0, [
                      u("p", g0, T(s("order.totalAmount")), 1),
                      u("p", w0, [
                        A[6] || (A[6] = u("span", { class: "text-lg" }, "$", -1)),
                        Ge(T(C.subtotal), 1)
                      ])
                    ])
                  ])
                ])
              ], 8, Qb);
            }), 128)),
            k(o).length === 0 ? ($(), I("div", b0, [
              A[7] || (A[7] = u("div", { class: "w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center text-3xl mb-4" }, " 📋 ", -1)),
              u("p", y0, T(s("order.emptyPrefix")) + " " + T(s((L = y.find((C) => C.key === m.value)) == null ? void 0 : L.label)) + " " + T(s("order.emptySuffix")), 1)
            ])) : X("", !0)
          ])),
          k(o).length > 0 ? ($(), I("div", v0, [
            u("span", _0, " PAGE " + T(k(l)) + " / " + T(Math.ceil(k(c) / k(h)) || 1), 1),
            u("div", x0, [
              u("button", {
                onClick: A[0] || (A[0] = (C) => l.value--),
                disabled: k(l) === 1 || k(a),
                class: "inline-flex items-center rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm font-bold text-gray-700 transition hover:bg-gray-50 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
              }, " ← " + T(s("common.prev")), 9, E0),
              u("button", {
                onClick: A[1] || (A[1] = (C) => l.value++),
                disabled: k(l) * k(h) >= k(c) || k(a),
                class: "inline-flex items-center rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm font-bold text-gray-700 transition hover:bg-gray-50 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
              }, T(s("common.next")) + " → ", 9, k0)
            ])
          ])) : X("", !0)
        ]),
        A[8] || (A[8] = u("footer", { class: "w-full pb-[env(safe-area-inset-bottom,2rem)] bg-transparent pointer-events-none" }, null, -1))
      ]);
    };
  }
});
function C0(e) {
  const t = z(/* @__PURE__ */ new Set()), n = z(!1), s = z(null);
  return {
    selectedItemIds: t,
    loading: n,
    error: s,
    toggleSelection: (a) => {
      t.value.has(a) ? t.value.delete(a) : t.value.add(a);
    },
    submitCategorization: async (a) => {
      if (t.value.size === 0) {
        s.value = "Please select at least one item";
        return;
      }
      n.value = !0, s.value = null;
      try {
        const i = {
          itemIds: Array.from(t.value)
          // This becomes ["uuid1", "uuid2"]
        };
        Ce.log("submitCategorization", i);
        const l = await e.updateCategoryItems(a, i);
        return t.value.clear(), l;
      } catch (i) {
        throw s.value = i.message || "儲存失敗", i;
      } finally {
        n.value = !1;
      }
    }
  };
}
const T0 = { class: "menu-lib-container" }, A0 = { class: "lib-header" }, O0 = { class: "lib-title" }, S0 = { class: "lib-subtitle" }, N0 = {
  key: 0,
  class: "lib-status-loading"
}, $0 = {
  key: 1,
  class: "lib-status-error"
}, L0 = { class: "lib-form mb-8" }, I0 = { class: "lib-label" }, P0 = { class: "lib-label-text" }, D0 = { class: "lib-instruction-box" }, M0 = {
  value: "",
  disabled: "",
  selected: ""
}, R0 = ["value"], F0 = { class: "lib-grid" }, B0 = ["onClick"], U0 = { class: "card-header-row" }, V0 = {
  key: 0,
  class: "check-mark"
}, H0 = { class: "card-title" }, j0 = { class: "price-tag" }, q0 = { class: "card-footer" }, W0 = { class: "price-tag" }, z0 = { class: "id-tag" }, Y0 = { class: "lib-footer-actions" }, K0 = ["disabled"], G0 = /* @__PURE__ */ ye({
  __name: "MenuCategoryPage",
  props: {
    menuItems: {},
    categoryItems: {},
    menuCategoryApi: {}
  },
  emits: ["updated"],
  setup(e, { emit: t }) {
    const { t: n } = Ot(), s = e, r = t, o = z(""), { selectedItemIds: a, loading: i, error: l, toggleSelection: c, submitCategorization: h } = C0(s.menuCategoryApi), f = me(() => {
      const b = s.categoryItems.find((g) => g.id === o.value);
      return b ? b.category : n("assign.noneSelected");
    }), p = async () => {
      if (o.value)
        try {
          await h(o.value), await we.fire({
            title: n("assign.successTitle"),
            text: n("assign.successText"),
            icon: "success",
            confirmButtonColor: "#2563eb",
            timer: 1e3
          }), a.value.clear(), o.value = "", r("updated");
        } catch (b) {
          console.error("Save failed:", b);
        }
    };
    return (b, g) => ($(), I("section", T0, [
      u("header", A0, [
        u("h1", O0, T(k(n)("assign.title")), 1),
        u("p", S0, T(k(n)("assign.subtitle")), 1)
      ]),
      k(i) ? ($(), I("div", N0, T(k(n)("common.processing")), 1)) : k(l) ? ($(), I("div", $0, T(k(l)), 1)) : X("", !0),
      u("div", L0, [
        u("label", I0, [
          u("span", P0, T(k(n)("assign.targetLabel")), 1),
          u("div", D0, T(k(n)("assign.instruction")), 1)
        ]),
        Qe(u("select", {
          "onUpdate:modelValue": g[0] || (g[0] = (m) => o.value = m),
          class: "lib-select"
        }, [
          u("option", M0, "-- " + T(k(n)("assign.selectPlaceholder")) + " --", 1),
          ($(!0), I(Me, null, ze(e.categoryItems, (m) => ($(), I("option", {
            key: m.id,
            value: m.id
          }, T(m.category), 9, R0))), 128))
        ], 512), [
          [nr, o.value]
        ])
      ]),
      u("div", F0, [
        ($(!0), I(Me, null, ze(e.menuItems, (m) => ($(), I("div", {
          key: m.id,
          onClick: (y) => k(c)(m.id),
          class: ke(["lib-card selectable-card", [
            k(a).has(m.id) ? "card-selected" : m.id.charCodeAt(0) % 2 === 0 ? "card-even" : "card-odd"
          ]])
        }, [
          u("div", U0, [
            u("div", {
              class: ke(["custom-checkbox", { "is-checked": k(a).has(m.id) }])
            }, [
              k(a).has(m.id) ? ($(), I("div", V0, "L")) : X("", !0)
            ], 2),
            u("p", H0, T(m.name), 1),
            u("p", j0, T(m.category), 1)
          ]),
          u("div", q0, [
            u("p", W0, "$" + T(m.price), 1),
            u("p", z0, "ID: " + T(m.id.slice(-5)), 1)
          ])
        ], 10, B0))), 128))
      ]),
      u("div", Y0, [
        u("button", {
          onClick: p,
          disabled: k(i) || !o.value || k(a).size === 0,
          class: "lib-btn-primary"
        }, T(k(i) ? k(n)("common.saving") : k(n)("assign.submitBtn", { count: k(a).size, category: f.value })), 9, K0)
      ])
    ]));
  }
}), uv = /* @__PURE__ */ bn(G0, [["__scopeId", "data-v-297891c5"]]);
function X0(e) {
  const t = z([]), n = z(!1), s = z(null);
  return {
    categories: t,
    loading: n,
    error: s,
    loadCategories: async () => {
      n.value = !0, s.value = null;
      try {
        t.value = await e.fetchCategories();
      } catch {
        s.value = "載入分類失敗";
      } finally {
        n.value = !1;
      }
    },
    handleBulkCreate: async (a) => {
      n.value = !0;
      try {
        return Ce.log("handleBulkCreate newCategories", a), await e.createCategories(a);
      } catch (i) {
        throw s.value = "批量新增失敗", i;
      } finally {
        n.value = !1;
      }
    }
  };
}
const J0 = { class: "menu-lib-container" }, Z0 = { class: "lib-header" }, Q0 = { class: "lib-title" }, ey = {
  key: 0,
  class: "lib-status-loading"
}, ty = {
  key: 1,
  class: "lib-status-error"
}, ny = { class: "lib-label" }, sy = { class: "lib-label-text" }, ry = { class: "lib-instruction-box" }, oy = { class: "whitespace-pre-line" }, ay = { class: "text-accent" }, iy = ["placeholder"], ly = ["disabled"], cy = { class: "lib-grid" }, uy = { class: "card-body" }, dy = { class: "card-title" }, fy = { class: "card-footer" }, my = { class: "order-tag" }, hy = { class: "id-tag" }, py = { class: "lib-footer-actions" }, gy = /* @__PURE__ */ ye({
  __name: "CategoryManagerPage",
  props: {
    categoryApi: {},
    merchantId: {}
  },
  emits: ["saved"],
  setup(e, { emit: t }) {
    const { t: n } = Ot(), s = e, r = t, { categories: o, loading: a, error: i, loadCategories: l, handleBulkCreate: c } = X0(s.categoryApi), h = z("");
    bt(o, (p) => {
      h.value || (h.value = [...p].sort((b, g) => b.orderNum - g.orderNum).map((b) => b.category).join(`
`));
    }, { immediate: !0 }), Dt(l);
    const f = async () => {
      const p = [...new Set(
        h.value.split(`
`).map((b) => b.trim()).filter((b) => b !== "")
      )];
      if (p.length !== 0) {
        a.value = !0;
        try {
          const b = p.map((g, m) => ({
            category: g,
            orderNum: m + 1,
            merchantId: s.merchantId
          }));
          await c(b), r("saved"), await we.fire({
            title: n("category.saveSuccessTitle"),
            text: n("category.saveSuccessText"),
            icon: "success",
            confirmButtonColor: "#2563eb",
            timer: 1500
          }), await l();
        } catch (b) {
          console.error("Failed to save categories:", b);
        } finally {
          a.value = !1;
        }
      }
    };
    return (p, b) => ($(), I("section", J0, [
      u("header", Z0, [
        u("h1", Q0, T(k(n)("category.title")), 1)
      ]),
      k(a) ? ($(), I("div", ey, T(k(n)("common.loading")), 1)) : k(i) ? ($(), I("div", ty, T(k(i)), 1)) : X("", !0),
      u("form", {
        onSubmit: Wo(f, ["prevent"]),
        class: "lib-form"
      }, [
        u("label", ny, [
          u("span", sy, T(k(n)("category.inputLabel")), 1),
          u("div", ry, [
            Ge(T(k(n)("category.formatInstruction")), 1),
            b[2] || (b[2] = u("br", null, null, -1)),
            Ge(" " + T(k(n)("category.exampleTitle")), 1),
            b[3] || (b[3] = u("br", null, null, -1)),
            u("div", oy, T(k(n)("category.exampleList")), 1),
            u("span", ay, T(k(n)("category.autoSyncNote")), 1)
          ])
        ]),
        Qe(u("textarea", {
          "onUpdate:modelValue": b[0] || (b[0] = (g) => h.value = g),
          class: "lib-textarea",
          placeholder: k(n)("category.placeholder")
        }, null, 8, iy), [
          [pt, h.value]
        ]),
        u("button", {
          type: "submit",
          disabled: k(a),
          class: "lib-btn-primary"
        }, T(k(a) ? k(n)("common.saving") : k(n)("category.submitBtn")), 9, ly)
      ], 32),
      u("div", cy, [
        ($(!0), I(Me, null, ze(k(o), (g) => ($(), I("div", {
          key: g.id,
          class: ke(["lib-card", g.orderNum % 2 === 0 ? "card-even" : "card-odd"])
        }, [
          u("div", uy, [
            u("h2", dy, T(g.category), 1)
          ]),
          u("div", fy, [
            u("p", my, T(k(n)("category.orderPrefix")) + ": #" + T(g.orderNum), 1),
            u("p", hy, "ID: " + T(g.id.slice(-5)), 1)
          ])
        ], 2))), 128))
      ]),
      u("div", py, [
        u("button", {
          onClick: b[1] || (b[1] = //@ts-ignore
          (...g) => k(l) && k(l)(...g)),
          class: "lib-btn-secondary"
        }, T(k(n)("category.reloadBtn")), 1)
      ])
    ]));
  }
}), dv = /* @__PURE__ */ bn(gy, [["__scopeId", "data-v-ea2fc320"]]);
var Nr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function $r(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Xi = { exports: {} };
(function(e, t) {
  (function(n, s) {
    e.exports = s();
  })(Nr, function() {
    var n = 1e3, s = 6e4, r = 36e5, o = "millisecond", a = "second", i = "minute", l = "hour", c = "day", h = "week", f = "month", p = "quarter", b = "year", g = "date", m = "Invalid Date", y = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, d = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, w = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(V) {
      var U = ["th", "st", "nd", "rd"], R = V % 100;
      return "[" + V + (U[(R - 20) % 10] || U[R] || U[0]) + "]";
    } }, _ = function(V, U, R) {
      var W = String(V);
      return !W || W.length >= U ? V : "" + Array(U + 1 - W.length).join(R) + V;
    }, x = { s: _, z: function(V) {
      var U = -V.utcOffset(), R = Math.abs(U), W = Math.floor(R / 60), B = R % 60;
      return (U <= 0 ? "+" : "-") + _(W, 2, "0") + ":" + _(B, 2, "0");
    }, m: function V(U, R) {
      if (U.date() < R.date()) return -V(R, U);
      var W = 12 * (R.year() - U.year()) + (R.month() - U.month()), B = U.clone().add(W, f), J = R - B < 0, K = U.clone().add(W + (J ? -1 : 1), f);
      return +(-(W + (R - B) / (J ? B - K : K - B)) || 0);
    }, a: function(V) {
      return V < 0 ? Math.ceil(V) || 0 : Math.floor(V);
    }, p: function(V) {
      return { M: f, y: b, w: h, d: c, D: g, h: l, m: i, s: a, ms: o, Q: p }[V] || String(V || "").toLowerCase().replace(/s$/, "");
    }, u: function(V) {
      return V === void 0;
    } }, A = "en", L = {};
    L[A] = w;
    var C = "$isDayjsObject", F = function(V) {
      return V instanceof ne || !(!V || !V[C]);
    }, D = function V(U, R, W) {
      var B;
      if (!U) return A;
      if (typeof U == "string") {
        var J = U.toLowerCase();
        L[J] && (B = J), R && (L[J] = R, B = J);
        var K = U.split("-");
        if (!B && K.length > 1) return V(K[0]);
      } else {
        var ee = U.name;
        L[ee] = U, B = ee;
      }
      return !W && B && (A = B), B || !W && A;
    }, j = function(V, U) {
      if (F(V)) return V.clone();
      var R = typeof U == "object" ? U : {};
      return R.date = V, R.args = arguments, new ne(R);
    }, q = x;
    q.l = D, q.i = F, q.w = function(V, U) {
      return j(V, { locale: U.$L, utc: U.$u, x: U.$x, $offset: U.$offset });
    };
    var ne = function() {
      function V(R) {
        this.$L = D(R.locale, null, !0), this.parse(R), this.$x = this.$x || R.x || {}, this[C] = !0;
      }
      var U = V.prototype;
      return U.parse = function(R) {
        this.$d = function(W) {
          var B = W.date, J = W.utc;
          if (B === null) return /* @__PURE__ */ new Date(NaN);
          if (q.u(B)) return /* @__PURE__ */ new Date();
          if (B instanceof Date) return new Date(B);
          if (typeof B == "string" && !/Z$/i.test(B)) {
            var K = B.match(y);
            if (K) {
              var ee = K[2] - 1 || 0, re = (K[7] || "0").substring(0, 3);
              return J ? new Date(Date.UTC(K[1], ee, K[3] || 1, K[4] || 0, K[5] || 0, K[6] || 0, re)) : new Date(K[1], ee, K[3] || 1, K[4] || 0, K[5] || 0, K[6] || 0, re);
            }
          }
          return new Date(B);
        }(R), this.init();
      }, U.init = function() {
        var R = this.$d;
        this.$y = R.getFullYear(), this.$M = R.getMonth(), this.$D = R.getDate(), this.$W = R.getDay(), this.$H = R.getHours(), this.$m = R.getMinutes(), this.$s = R.getSeconds(), this.$ms = R.getMilliseconds();
      }, U.$utils = function() {
        return q;
      }, U.isValid = function() {
        return this.$d.toString() !== m;
      }, U.isSame = function(R, W) {
        var B = j(R);
        return this.startOf(W) <= B && B <= this.endOf(W);
      }, U.isAfter = function(R, W) {
        return j(R) < this.startOf(W);
      }, U.isBefore = function(R, W) {
        return this.endOf(W) < j(R);
      }, U.$g = function(R, W, B) {
        return q.u(R) ? this[W] : this.set(B, R);
      }, U.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, U.valueOf = function() {
        return this.$d.getTime();
      }, U.startOf = function(R, W) {
        var B = this, J = !!q.u(W) || W, K = q.p(R), ee = function(rt, Ae) {
          var oe = q.w(B.$u ? Date.UTC(B.$y, Ae, rt) : new Date(B.$y, Ae, rt), B);
          return J ? oe : oe.endOf(c);
        }, re = function(rt, Ae) {
          return q.w(B.toDate()[rt].apply(B.toDate("s"), (J ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Ae)), B);
        }, de = this.$W, ve = this.$M, Te = this.$D, dt = "set" + (this.$u ? "UTC" : "");
        switch (K) {
          case b:
            return J ? ee(1, 0) : ee(31, 11);
          case f:
            return J ? ee(1, ve) : ee(0, ve + 1);
          case h:
            var st = this.$locale().weekStart || 0, ft = (de < st ? de + 7 : de) - st;
            return ee(J ? Te - ft : Te + (6 - ft), ve);
          case c:
          case g:
            return re(dt + "Hours", 0);
          case l:
            return re(dt + "Minutes", 1);
          case i:
            return re(dt + "Seconds", 2);
          case a:
            return re(dt + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, U.endOf = function(R) {
        return this.startOf(R, !1);
      }, U.$set = function(R, W) {
        var B, J = q.p(R), K = "set" + (this.$u ? "UTC" : ""), ee = (B = {}, B[c] = K + "Date", B[g] = K + "Date", B[f] = K + "Month", B[b] = K + "FullYear", B[l] = K + "Hours", B[i] = K + "Minutes", B[a] = K + "Seconds", B[o] = K + "Milliseconds", B)[J], re = J === c ? this.$D + (W - this.$W) : W;
        if (J === f || J === b) {
          var de = this.clone().set(g, 1);
          de.$d[ee](re), de.init(), this.$d = de.set(g, Math.min(this.$D, de.daysInMonth())).$d;
        } else ee && this.$d[ee](re);
        return this.init(), this;
      }, U.set = function(R, W) {
        return this.clone().$set(R, W);
      }, U.get = function(R) {
        return this[q.p(R)]();
      }, U.add = function(R, W) {
        var B, J = this;
        R = Number(R);
        var K = q.p(W), ee = function(ve) {
          var Te = j(J);
          return q.w(Te.date(Te.date() + Math.round(ve * R)), J);
        };
        if (K === f) return this.set(f, this.$M + R);
        if (K === b) return this.set(b, this.$y + R);
        if (K === c) return ee(1);
        if (K === h) return ee(7);
        var re = (B = {}, B[i] = s, B[l] = r, B[a] = n, B)[K] || 1, de = this.$d.getTime() + R * re;
        return q.w(de, this);
      }, U.subtract = function(R, W) {
        return this.add(-1 * R, W);
      }, U.format = function(R) {
        var W = this, B = this.$locale();
        if (!this.isValid()) return B.invalidDate || m;
        var J = R || "YYYY-MM-DDTHH:mm:ssZ", K = q.z(this), ee = this.$H, re = this.$m, de = this.$M, ve = B.weekdays, Te = B.months, dt = B.meridiem, st = function(Ae, oe, se, ae) {
          return Ae && (Ae[oe] || Ae(W, J)) || se[oe].slice(0, ae);
        }, ft = function(Ae) {
          return q.s(ee % 12 || 12, Ae, "0");
        }, rt = dt || function(Ae, oe, se) {
          var ae = Ae < 12 ? "AM" : "PM";
          return se ? ae.toLowerCase() : ae;
        };
        return J.replace(d, function(Ae, oe) {
          return oe || function(se) {
            switch (se) {
              case "YY":
                return String(W.$y).slice(-2);
              case "YYYY":
                return q.s(W.$y, 4, "0");
              case "M":
                return de + 1;
              case "MM":
                return q.s(de + 1, 2, "0");
              case "MMM":
                return st(B.monthsShort, de, Te, 3);
              case "MMMM":
                return st(Te, de);
              case "D":
                return W.$D;
              case "DD":
                return q.s(W.$D, 2, "0");
              case "d":
                return String(W.$W);
              case "dd":
                return st(B.weekdaysMin, W.$W, ve, 2);
              case "ddd":
                return st(B.weekdaysShort, W.$W, ve, 3);
              case "dddd":
                return ve[W.$W];
              case "H":
                return String(ee);
              case "HH":
                return q.s(ee, 2, "0");
              case "h":
                return ft(1);
              case "hh":
                return ft(2);
              case "a":
                return rt(ee, re, !0);
              case "A":
                return rt(ee, re, !1);
              case "m":
                return String(re);
              case "mm":
                return q.s(re, 2, "0");
              case "s":
                return String(W.$s);
              case "ss":
                return q.s(W.$s, 2, "0");
              case "SSS":
                return q.s(W.$ms, 3, "0");
              case "Z":
                return K;
            }
            return null;
          }(Ae) || K.replace(":", "");
        });
      }, U.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, U.diff = function(R, W, B) {
        var J, K = this, ee = q.p(W), re = j(R), de = (re.utcOffset() - this.utcOffset()) * s, ve = this - re, Te = function() {
          return q.m(K, re);
        };
        switch (ee) {
          case b:
            J = Te() / 12;
            break;
          case f:
            J = Te();
            break;
          case p:
            J = Te() / 3;
            break;
          case h:
            J = (ve - de) / 6048e5;
            break;
          case c:
            J = (ve - de) / 864e5;
            break;
          case l:
            J = ve / r;
            break;
          case i:
            J = ve / s;
            break;
          case a:
            J = ve / n;
            break;
          default:
            J = ve;
        }
        return B ? J : q.a(J);
      }, U.daysInMonth = function() {
        return this.endOf(f).$D;
      }, U.$locale = function() {
        return L[this.$L];
      }, U.locale = function(R, W) {
        if (!R) return this.$L;
        var B = this.clone(), J = D(R, W, !0);
        return J && (B.$L = J), B;
      }, U.clone = function() {
        return q.w(this.$d, this);
      }, U.toDate = function() {
        return new Date(this.valueOf());
      }, U.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, U.toISOString = function() {
        return this.$d.toISOString();
      }, U.toString = function() {
        return this.$d.toUTCString();
      }, V;
    }(), De = ne.prototype;
    return j.prototype = De, [["$ms", o], ["$s", a], ["$m", i], ["$H", l], ["$W", c], ["$M", f], ["$y", b], ["$D", g]].forEach(function(V) {
      De[V[1]] = function(U) {
        return this.$g(U, V[0], V[1]);
      };
    }), j.extend = function(V, U) {
      return V.$i || (V(U, ne, j), V.$i = !0), j;
    }, j.locale = D, j.isDayjs = F, j.unix = function(V) {
      return j(1e3 * V);
    }, j.en = L[A], j.Ls = L, j.p = {}, j;
  });
})(Xi);
var wy = Xi.exports;
const Lr = /* @__PURE__ */ $r(wy);
var Ji = { exports: {} };
(function(e, t) {
  (function(n, s) {
    e.exports = s();
  })(Nr, function() {
    var n = "minute", s = /[+-]\d\d(?::?\d\d)?/g, r = /([+-]|\d\d)/g;
    return function(o, a, i) {
      var l = a.prototype;
      i.utc = function(m) {
        var y = { date: m, utc: !0, args: arguments };
        return new a(y);
      }, l.utc = function(m) {
        var y = i(this.toDate(), { locale: this.$L, utc: !0 });
        return m ? y.add(this.utcOffset(), n) : y;
      }, l.local = function() {
        return i(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var c = l.parse;
      l.parse = function(m) {
        m.utc && (this.$u = !0), this.$utils().u(m.$offset) || (this.$offset = m.$offset), c.call(this, m);
      };
      var h = l.init;
      l.init = function() {
        if (this.$u) {
          var m = this.$d;
          this.$y = m.getUTCFullYear(), this.$M = m.getUTCMonth(), this.$D = m.getUTCDate(), this.$W = m.getUTCDay(), this.$H = m.getUTCHours(), this.$m = m.getUTCMinutes(), this.$s = m.getUTCSeconds(), this.$ms = m.getUTCMilliseconds();
        } else h.call(this);
      };
      var f = l.utcOffset;
      l.utcOffset = function(m, y) {
        var d = this.$utils().u;
        if (d(m)) return this.$u ? 0 : d(this.$offset) ? f.call(this) : this.$offset;
        if (typeof m == "string" && (m = function(A) {
          A === void 0 && (A = "");
          var L = A.match(s);
          if (!L) return null;
          var C = ("" + L[0]).match(r) || ["-", 0, 0], F = C[0], D = 60 * +C[1] + +C[2];
          return D === 0 ? 0 : F === "+" ? D : -D;
        }(m), m === null)) return this;
        var w = Math.abs(m) <= 16 ? 60 * m : m;
        if (w === 0) return this.utc(y);
        var _ = this.clone();
        if (y) return _.$offset = w, _.$u = !1, _;
        var x = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
        return (_ = this.local().add(w + x, n)).$offset = w, _.$x.$localOffset = x, _;
      };
      var p = l.format;
      l.format = function(m) {
        var y = m || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return p.call(this, y);
      }, l.valueOf = function() {
        var m = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * m;
      }, l.isUTC = function() {
        return !!this.$u;
      }, l.toISOString = function() {
        return this.toDate().toISOString();
      }, l.toString = function() {
        return this.toDate().toUTCString();
      };
      var b = l.toDate;
      l.toDate = function(m) {
        return m === "s" && this.$offset ? i(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : b.call(this);
      };
      var g = l.diff;
      l.diff = function(m, y, d) {
        if (m && this.$u === m.$u) return g.call(this, m, y, d);
        var w = this.local(), _ = i(m).local();
        return g.call(w, _, y, d);
      };
    };
  });
})(Ji);
var by = Ji.exports;
const yy = /* @__PURE__ */ $r(by);
var Zi = { exports: {} };
(function(e, t) {
  (function(n, s) {
    e.exports = s();
  })(Nr, function() {
    var n = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, s = {};
    return function(r, o, a) {
      var i, l = function(p, b, g) {
        g === void 0 && (g = {});
        var m = new Date(p), y = function(d, w) {
          w === void 0 && (w = {});
          var _ = w.timeZoneName || "short", x = d + "|" + _, A = s[x];
          return A || (A = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: d, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: _ }), s[x] = A), A;
        }(b, g);
        return y.formatToParts(m);
      }, c = function(p, b) {
        for (var g = l(p, b), m = [], y = 0; y < g.length; y += 1) {
          var d = g[y], w = d.type, _ = d.value, x = n[w];
          x >= 0 && (m[x] = parseInt(_, 10));
        }
        var A = m[3], L = A === 24 ? 0 : A, C = m[0] + "-" + m[1] + "-" + m[2] + " " + L + ":" + m[4] + ":" + m[5] + ":000", F = +p;
        return (a.utc(C).valueOf() - (F -= F % 1e3)) / 6e4;
      }, h = o.prototype;
      h.tz = function(p, b) {
        p === void 0 && (p = i);
        var g, m = this.utcOffset(), y = this.toDate(), d = y.toLocaleString("en-US", { timeZone: p }), w = Math.round((y - new Date(d)) / 1e3 / 60), _ = 15 * -Math.round(y.getTimezoneOffset() / 15) - w;
        if (!Number(_)) g = this.utcOffset(0, b);
        else if (g = a(d, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(_, !0), b) {
          var x = g.utcOffset();
          g = g.add(m - x, "minute");
        }
        return g.$x.$timezone = p, g;
      }, h.offsetName = function(p) {
        var b = this.$x.$timezone || a.tz.guess(), g = l(this.valueOf(), b, { timeZoneName: p }).find(function(m) {
          return m.type.toLowerCase() === "timezonename";
        });
        return g && g.value;
      };
      var f = h.startOf;
      h.startOf = function(p, b) {
        if (!this.$x || !this.$x.$timezone) return f.call(this, p, b);
        var g = a(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return f.call(g, p, b).tz(this.$x.$timezone, !0);
      }, a.tz = function(p, b, g) {
        var m = g && b, y = g || b || i, d = c(+a(), y);
        if (typeof p != "string") return a(p).tz(y);
        var w = function(L, C, F) {
          var D = L - 60 * C * 1e3, j = c(D, F);
          if (C === j) return [D, C];
          var q = c(D -= 60 * (j - C) * 1e3, F);
          return j === q ? [D, j] : [L - 60 * Math.min(j, q) * 1e3, Math.max(j, q)];
        }(a.utc(p, m).valueOf(), d, y), _ = w[0], x = w[1], A = a(_).utcOffset(x);
        return A.$x.$timezone = y, A;
      }, a.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, a.tz.setDefault = function(p) {
        i = p;
      };
    };
  });
})(Zi);
var vy = Zi.exports;
const _y = /* @__PURE__ */ $r(vy);
Lr.extend(yy);
Lr.extend(_y);
function xy(e) {
  const t = z("UTC"), n = z(!1), s = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
  return {
    currentTz: t,
    loading: n,
    detectBrowserTz: s,
    loadStoredTz: async () => {
      Ce.log("載入商家時區中..."), n.value = !0;
      try {
        const i = await e.getMerchantTz();
        Ce.log("取得商家時區:", i.tz), t.value = i.tz || "UTC";
      } catch (i) {
        Ce.error("無法載入時區", i);
      } finally {
        n.value = !1;
      }
    },
    formatTimeByZone: (i, l) => {
      if (!i) return "--";
      const c = l || t.value;
      return Lr(i).tz(c).format("YYYY-MM-DD HH:mm:ss");
    },
    syncTzToBackend: async () => {
      const i = s();
      n.value = !0;
      try {
        await e.updateMerchantTz(i), t.value = i;
      } catch (l) {
        throw l;
      } finally {
        n.value = !1;
      }
    }
  };
}
const Ey = [
  // West Coast / Pacific (Negative Offsets)
  { label: "UTC -10 (Hawaii Standard Time)", value: "Pacific/Honolulu", offset: -10 },
  { label: "UTC -9 (Alaska Standard Time)", value: "America/Anchorage", offset: -9 },
  { label: "UTC -8 (Pacific Time - Los Angeles / Vancouver)", value: "America/Los_Angeles", offset: -8 },
  { label: "UTC -7 (Mountain Time - Denver / Phoenix)", value: "America/Denver", offset: -7 },
  { label: "UTC -6 (Central Time - Chicago / Mexico City)", value: "America/Chicago", offset: -6 },
  { label: "UTC -5 (Eastern Time - New York / Toronto)", value: "America/New_York", offset: -5 },
  { label: "UTC -4 (Atlantic Time - Halifax)", value: "America/Halifax", offset: -4 },
  { label: "UTC -3 (Brasilia / Buenos Aires)", value: "America/Sao_Paulo", offset: -3 },
  { label: "UTC -1 (Azores)", value: "Atlantic/Azores", offset: -1 },
  // Base Timezone
  { label: "UTC +0 (London / Lisbon / Casablanca)", value: "Europe/London", offset: 0 },
  // East Coast / Asia / Oceania (Positive Offsets)
  { label: "UTC +1 (Paris / Berlin / Rome / Madrid)", value: "Europe/Paris", offset: 1 },
  { label: "UTC +2 (Athens / Istanbul / Cairo / Jerusalem)", value: "Europe/Athens", offset: 2 },
  { label: "UTC +3 (Moscow / Riyadh / Nairobi)", value: "Europe/Moscow", offset: 3 },
  { label: "UTC +4 (Dubai / Baku)", value: "Asia/Dubai", offset: 4 },
  { label: "UTC +5 (Karachi / Tashkent)", value: "Asia/Karachi", offset: 5 },
  { label: "UTC +5.5 (India - Delhi / Mumbai)", value: "Asia/Kolkata", offset: 5.5 },
  { label: "UTC +6 (Dhaka / Almaty)", value: "Asia/Dhaka", offset: 6 },
  { label: "UTC +7 (Bangkok / Ho Chi Minh / Jakarta)", value: "Asia/Ho_Chi_Minh", offset: 7 },
  { label: "UTC +8 (Taipei / Beijing / Hong Kong / Singapore)", value: "Asia/Taipei", offset: 8 },
  { label: "UTC +9 (Tokyo / Seoul)", value: "Asia/Tokyo", offset: 9 },
  { label: "UTC +9.5 (Adelaide)", value: "Australia/Adelaide", offset: 9.5 },
  { label: "UTC +10 (Sydney / Melbourne / Guam)", value: "Australia/Sydney", offset: 10 },
  { label: "UTC +11 (Solomon Islands / Guadalcanal)", value: "Pacific/Guadalcanal", offset: 11 },
  { label: "UTC +12 (Auckland / Fiji)", value: "Pacific/Auckland", offset: 12 }
], ky = { class: "p-6 bg-white rounded-xl shadow-md border border-gray-100 max-w-lg" }, Cy = { class: "space-y-4" }, Ty = ["value"], Ay = { class: "flex items-center gap-2 p-3 bg-blue-50 rounded-lg" }, Oy = { class: "flex-1" }, Sy = { class: "text-sm font-mono text-blue-700" }, Ny = {
  key: 0,
  class: "text-xs bg-orange-400 text-white px-2 py-1 rounded-full animate-pulse"
}, $y = ["disabled"], Ly = { class: "mt-6 pt-4 border-t border-dashed" }, Iy = { class: "text-xs text-gray-400 font-bold mb-1" }, Py = { class: "text-lg font-mono text-gray-600" }, fv = /* @__PURE__ */ ye({
  __name: "TzSettingCard",
  props: {
    merchantTzApi: {}
  },
  setup(e) {
    const t = e, { currentTz: n, loading: s, loadStoredTz: r, formatTimeByZone: o } = xy(t.merchantTzApi), a = z(""), i = me(() => a.value !== n.value), l = me(() => o((/* @__PURE__ */ new Date()).toISOString(), a.value));
    Dt(async () => {
      await r(), a.value = n.value;
    });
    const c = async () => {
      var h, f;
      try {
        s.value = !0, await t.merchantTzApi.updateMerchantTz(a.value), n.value = a.value;
      } catch (p) {
        (f = (h = p.response) == null ? void 0 : h.data) != null && f.message;
      } finally {
        s.value = !1;
      }
    };
    return (h, f) => ($(), I("div", ky, [
      f[3] || (f[3] = u("h3", { class: "text-lg font-bold text-gray-800 mb-2" }, "時區偏好設定", -1)),
      f[4] || (f[4] = u("p", { class: "text-sm text-gray-500 mb-6" }, "設定後，訂單與報表時間將依照此時區顯示。", -1)),
      u("div", Cy, [
        u("div", null, [
          f[1] || (f[1] = u("label", { class: "block text-sm font-bold text-gray-700 mb-1" }, "選擇時區 (GMT 偏移)", -1)),
          Qe(u("select", {
            "onUpdate:modelValue": f[0] || (f[0] = (p) => a.value = p),
            class: "w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none appearance-none bg-white"
          }, [
            ($(!0), I(Me, null, ze(k(Ey), (p) => ($(), I("option", {
              key: p.value,
              value: p.value
            }, T(p.label) + " (" + T(p.offset > 0 ? "+" + p.offset : p.offset) + ") ", 9, Ty))), 128))
          ], 512), [
            [nr, a.value]
          ])
        ]),
        u("div", Ay, [
          u("div", Oy, [
            f[2] || (f[2] = u("p", { class: "text-xs text-blue-500 font-bold uppercase" }, "目前資料庫設定", -1)),
            u("p", Sy, T(k(n)), 1)
          ]),
          i.value ? ($(), I("div", Ny, " 尚未儲存 ")) : X("", !0)
        ]),
        u("button", {
          onClick: c,
          disabled: k(s) || !i.value,
          class: "w-full py-3 bg-blue-600 text-white rounded-xl font-bold shadow-lg hover:bg-blue-700 transition disabled:bg-gray-300 disabled:shadow-none"
        }, T(k(s) ? "儲存中..." : "儲存時區設定"), 9, $y)
      ]),
      u("div", Ly, [
        u("p", Iy, "預覽時間 (" + T(a.value) + ")", 1),
        u("p", Py, T(l.value), 1)
      ])
    ]));
  }
}), Dy = { class: "p-6 bg-white rounded-xl shadow-md border border-gray-100 max-w-lg" }, My = { class: "space-y-4" }, Ry = {
  key: 0,
  class: "flex items-center gap-2 p-3 bg-orange-50 rounded-lg"
}, Fy = ["disabled"], mv = /* @__PURE__ */ ye({
  __name: "MerchantInfoEditCard",
  props: {
    merchantTzApi: {}
  },
  setup(e) {
    const t = e, n = z(!1), s = z({
      tz: "",
      memo1: "",
      memo2: "",
      merchant_name: ""
    }), r = z({
      merchantName: "",
      memo1: "",
      memo2: ""
    }), o = me(() => r.value.merchantName !== s.value.merchant_name || r.value.memo1 !== s.value.memo1 || r.value.memo2 !== s.value.memo2);
    Dt(async () => {
      await a();
    });
    const a = async () => {
      try {
        n.value = !0;
        const l = localStorage.getItem("merchantId");
        if (!l)
          throw new Error("Merchant ID not found in storage");
        const c = await t.merchantTzApi.getMerchantInfo(l);
        s.value = c, r.value.merchantName = c.merchant_name, r.value.memo1 = c.memo1, r.value.memo2 = c.memo2;
      } catch (l) {
        console.error("Failed to load merchant info:", l);
      } finally {
        n.value = !1;
      }
    }, i = async () => {
      var l, c;
      try {
        if (n.value = !0, !localStorage.getItem("merchantId"))
          throw new Error("Merchant ID not found in storage");
        const f = await t.merchantTzApi.updateMerchantInfo(
          r.value.merchantName,
          r.value.memo1,
          r.value.memo2
        );
        Ce.log("Merchant info updated:", f), s.value.merchant_name = r.value.merchantName, s.value.memo1 = r.value.memo1, s.value.memo2 = r.value.memo2;
      } catch (h) {
        const f = ((c = (l = h.response) == null ? void 0 : l.data) == null ? void 0 : c.error) || "儲存失敗";
        console.error(f);
      } finally {
        n.value = !1;
      }
    };
    return (l, c) => ($(), I("div", Dy, [
      c[7] || (c[7] = u("h3", { class: "text-lg font-bold text-gray-800 mb-2" }, "商家資訊設定", -1)),
      c[8] || (c[8] = u("p", { class: "text-sm text-gray-500 mb-6" }, "更新商家名稱與備註資訊。", -1)),
      u("div", My, [
        u("div", null, [
          c[3] || (c[3] = u("label", { class: "block text-sm font-bold text-gray-700 mb-1" }, "商家名稱", -1)),
          Qe(u("input", {
            "onUpdate:modelValue": c[0] || (c[0] = (h) => r.value.merchantName = h),
            type: "text",
            placeholder: "請輸入商家名稱",
            class: "w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none",
            maxlength: "100"
          }, null, 512), [
            [pt, r.value.merchantName]
          ])
        ]),
        u("div", null, [
          c[4] || (c[4] = u("label", { class: "block text-sm font-bold text-gray-700 mb-1" }, "備註 1 (客人點餐畫面說明)", -1)),
          Qe(u("textarea", {
            "onUpdate:modelValue": c[1] || (c[1] = (h) => r.value.memo1 = h),
            placeholder: "請輸入備註 1",
            class: "w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none resize-none",
            rows: "3",
            maxlength: "255"
          }, null, 512), [
            [pt, r.value.memo1]
          ])
        ]),
        u("div", null, [
          c[5] || (c[5] = u("label", { class: "block text-sm font-bold text-gray-700 mb-1" }, "備註 2 (客人訂位畫面說明)", -1)),
          Qe(u("textarea", {
            "onUpdate:modelValue": c[2] || (c[2] = (h) => r.value.memo2 = h),
            placeholder: "請輸入備註 2",
            class: "w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none resize-none",
            rows: "3",
            maxlength: "255"
          }, null, 512), [
            [pt, r.value.memo2]
          ])
        ]),
        o.value ? ($(), I("div", Ry, [...c[6] || (c[6] = [
          u("div", { class: "text-xs bg-orange-400 text-white px-2 py-1 rounded-full animate-pulse" }, " 尚未儲存 ", -1)
        ])])) : X("", !0),
        u("button", {
          onClick: i,
          disabled: n.value || !o.value,
          class: "w-full py-3 bg-blue-600 text-white rounded-xl font-bold shadow-lg hover:bg-blue-700 transition disabled:bg-gray-300 disabled:shadow-none"
        }, T(n.value ? "儲存中..." : "儲存商家資訊"), 9, Fy)
      ])
    ]));
  }
});
let er;
const hv = (e) => er ? er(e) : (console.warn(`Translation called for "${e}" before i18n was initialized.`), e), pv = (e) => {
  er = e;
};
export {
  dv as CategoryManagerPage,
  uv as MenuCategoryPage,
  Vy as MenuEditorPage,
  av as MenuOrderPage,
  mv as MerchantInfoEditCard,
  cv as MerchantOrderListPage,
  lv as OrderManagementPage,
  iv as TablePostPage,
  fv as TzSettingCard,
  pv as setI18nMenu,
  hv as t
};
